/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AadConnectRequestModel {
    token?: string | null;
}

export interface AadConnectResponseModel {
    isLoggedIn?: boolean;
    message?: string | null;
}

export interface AdminUserModel {
    userTenants?: TenantUserBaseModel[] | null;
    language?: string | null;
    phoneNumber?: string | null;
    userName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    displayName?: string | null;
    /** @format uuid */
    avatar?: string | null;
    notifyWeeklyAudits?: boolean | null;
    notifyIdleMeasures?: boolean;
    notifyCorrectionManagerUpdate?: boolean | null;
    notifyCorrectionImplementerUpdate?: boolean | null;
    email?: string | null;
    /** @format date-time */
    registrationDate?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface AdminUserModelApiResultSuccess {
    returnValue?: AdminUserModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AdminUserModelIEnumerableApiResultSuccess {
    returnValue?: AdminUserModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export enum AggregationEnum {
    Count = 'count',
    Avg = 'avg',
    Sum = 'sum',
}

export interface AggregationModel {
    predicates?: PredicateDefinition[] | null;
    aggregation?: AggregationEnum;
    aggregationProperty?: string | null;
}

export interface AggregationResponse {
    result?: IActionResult;
}

export interface AggregationResponseApiResultSuccess {
    returnValue?: AggregationResponse;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AiMessage {
    message?: string | null;
}

export enum AiServiceQueueActionEnum {
    AiGeneratePlanItemReport = 'AiGeneratePlanItemReport',
}

export interface AiServiceQueueItemModel {
    action?: AiServiceQueueActionEnum;
    isDone?: boolean;
    /** @format date-time */
    doneAt?: string | null;
    /** @format uuid */
    auditId?: string | null;
    /** @format uuid */
    planItemId?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface AiServiceQueueItemModelApiResultSuccess {
    returnValue?: AiServiceQueueItemModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AiServiceQueueItemModelIEnumerableApiResultSuccess {
    returnValue?: AiServiceQueueItemModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AiSuggestQuestionsRequest {
    generateDescription?: boolean;
    generateDisagreementResponse?: boolean;
    messages?: AiMessage[] | null;
}

export interface AiSuggestQuestionsResponse {
    suggestedCategories?: string[] | null;
    suggestedQuestions?: AiSuggestedQuestion[] | null;
    generateDescription?: boolean;
    generateDisagreementResponse?: boolean;
    messages?: AiMessage[] | null;
}

export interface AiSuggestQuestionsResponseApiResultSuccess {
    returnValue?: AiSuggestQuestionsResponse;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AiSuggestedQuestion {
    /** @format uuid */
    id?: string | null;
    /** @format int32 */
    index?: number;
    category?: string | null;
    code?: string | null;
    question?: string | null;
    description?: string | null;
    disagreementResponse?: string | null;
    originalQuestion?: string | null;
}

export interface AlertEscalationModel {
    /** @format uuid */
    alertId?: string;
    type?: AlertEscalationTypeEnum;
    /** @format uuid */
    tenantUserId?: string | null;
    tenantUser?: TenantUserBaseModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export enum AlertEscalationTypeEnum {
    TenantUser = 'TenantUser',
    DirectSupervisor = 'DirectSupervisor',
    SecondLevelSupervisor = 'SecondLevelSupervisor',
    ThirdLevelSupervisor = 'ThirdLevelSupervisor',
    Owner = 'Owner',
}

export enum AlertTimingEnum {
    Before = 'Before',
    Delay = 'Delay',
}

export enum AlertTypeEnum {
    Performance = 'Performance',
    Finding = 'Finding',
    MeasureImplementation = 'MeasureImplementation',
    MeasureVerification = 'MeasureVerification',
}

export interface ApiResultBase {
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ApiResultException {
    message?: string | null;
    stackTrace?: string | null;
    error?: ApiResultException;
}

export interface ApiResultFailed {
    returnValue?: Null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ApiResultSuccess {
    returnValue?: Null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ApplicationUserModel {
    language?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    twoFactorEnabled?: boolean;
    notifyWeeklyAudits?: boolean | null;
    notifyIdleMeasures?: boolean;
    notifyCorrectionManagerUpdate?: boolean | null;
    notifyCorrectionImplementerUpdate?: boolean | null;
    systemUser?: boolean;
    firstName?: string | null;
    lastName?: string | null;
    avatar?: string | null;
    isActive?: boolean;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ApplicationUserModelApiResultSuccess {
    returnValue?: ApplicationUserModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AuditBasicModel {
    name?: string | null;
    shortName?: string | null;
    /** @format uuid */
    categoryId?: string | null;
    category?: CategoryBasicModel;
    isActive?: boolean;
    aiGenerated?: boolean | null;
    /** @format uuid */
    ownerId?: string | null;
    owner?: TenantUserBaseModel;
    explanationType?: AuditExplanationTypeEnum;
    processType?: ProcessTypeEnum;
    useWorkplaceLimitation?: boolean;
    useShiftTypeLimitation?: boolean;
    useFaultTypes?: boolean;
    useSelfRepair?: boolean;
    isAllowedEmptyFindingDescription?: boolean;
    usePlanItemFindingManagerList?: boolean;
    isRequiredSavingAllInputs?: boolean;
    useIssueSolvingEscalation?: boolean;
    useDefects?: boolean;
    requireDefects?: boolean;
    useMachineComponents?: boolean;
    requireMachineComponents?: boolean;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface AuditBasicModelIEnumerableApiResultSuccess {
    returnValue?: AuditBasicModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AuditCustomFieldGroupModel {
    /** @format uuid */
    auditId?: string;
    auditCustomFields?: AuditCustomFieldModel[] | null;
    name?: string | null;
    /** @format int32 */
    position?: number;
    customFieldGroupType?: CustomFieldGroupTypeEnum;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface AuditCustomFieldModel {
    /** @format uuid */
    auditCustomFieldGroupId?: string;
    name?: string | null;
    type?: CustomFieldTypeEnum;
    title?: string | null;
    placeholder?: string | null;
    /** @format int32 */
    position?: number;
    isRequired?: boolean;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface AuditEscalationGroupModel {
    /** @format uuid */
    auditId?: string;
    /** @format uuid */
    groupId?: string;
    group?: GroupBasicModel;
    escalationGroupType?: EscalationGroupTypeEnum;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface AuditEscalationGroupModelApiResultSuccess {
    returnValue?: AuditEscalationGroupModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AuditEscalationGroupModelIEnumerableApiResultSuccess {
    returnValue?: AuditEscalationGroupModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AuditExplanationModel {
    /** @format uuid */
    auditId?: string;
    explanation?: AuditExplanationTypeEnum;
    /** @format int32 */
    responseValue?: number;
    explanationDescription?: string | null;
    /** @format uuid */
    fileId?: string | null;
    file?: FileModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export enum AuditExplanationTypeEnum {
    None = 'None',
    ByCategory = 'ByCategory',
    ByAudit = 'ByAudit',
    ByQuestionGroup = 'ByQuestionGroup',
}

export interface AuditFaultTypeModel {
    /** @format uuid */
    auditId?: string;
    name?: string | null;
    isActive?: boolean;
    priority?: string | null;
    isFailure?: boolean;
    isWorkplaceShutdown?: boolean;
    isPlannedShutdown?: boolean;
    isWorkplaceShutdownWhenStationShutdown?: boolean;
    color?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface AuditFaultTypeModelApiResultSuccess {
    returnValue?: AuditFaultTypeModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AuditFaultTypeModelIEnumerableApiResultSuccess {
    returnValue?: AuditFaultTypeModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AuditInstructionFileModel {
    /** @format uuid */
    auditId?: string;
    /** @format uuid */
    fileId?: string;
    file?: FileModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface AuditModel {
    instructions?: string | null;
    aiReportInstructions?: string | null;
    useProductGroups?: boolean;
    useVdaDefinitionAtPerformance?: boolean;
    customFieldUsageType?: CustomFieldUsageTypeEnum;
    auditExplanations?: AuditExplanationModel[] | null;
    escalationGroups?: AuditEscalationGroupModel[] | null;
    processSteps?: ProcessStepModel[] | null;
    productGroups?: ProductGroupModel[] | null;
    productGroupProcessSteps?: ProductGroupProcessStepModel[] | null;
    instructionFiles?: AuditInstructionFileModel[] | null;
    parts?: PartModel[] | null;
    auditCustomFieldGroups?: AuditCustomFieldGroupModel[] | null;
    name?: string | null;
    shortName?: string | null;
    /** @format uuid */
    categoryId?: string | null;
    category?: CategoryBasicModel;
    isActive?: boolean;
    aiGenerated?: boolean | null;
    /** @format uuid */
    ownerId?: string | null;
    owner?: TenantUserBaseModel;
    explanationType?: AuditExplanationTypeEnum;
    processType?: ProcessTypeEnum;
    useWorkplaceLimitation?: boolean;
    useShiftTypeLimitation?: boolean;
    useFaultTypes?: boolean;
    useSelfRepair?: boolean;
    isAllowedEmptyFindingDescription?: boolean;
    usePlanItemFindingManagerList?: boolean;
    isRequiredSavingAllInputs?: boolean;
    useIssueSolvingEscalation?: boolean;
    useDefects?: boolean;
    requireDefects?: boolean;
    useMachineComponents?: boolean;
    requireMachineComponents?: boolean;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface AuditModelApiResultSuccess {
    returnValue?: AuditModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AuditModelIEnumerableApiResultSuccess {
    returnValue?: AuditModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AuditShiftTypeModel {
    /** @format uuid */
    auditId?: string;
    /** @format uuid */
    shiftTypeId?: string;
    shiftType?: ShiftTypeModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface AuditShiftTypeModelApiResultSuccess {
    returnValue?: AuditShiftTypeModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AuditShiftTypeModelIEnumerableApiResultSuccess {
    returnValue?: AuditShiftTypeModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export enum AuditTimingLocationTypeEnum {
    Workplace = 'Workplace',
    Location = 'Location',
}

export interface AuditTimingModel {
    /** @format uuid */
    auditId?: string;
    /** @format uuid */
    groupId?: string;
    group?: GroupBasicModel;
    /** @format double */
    repeatEach?: number | null;
    type?: AuditTimingType;
    timingType?: AuditTimingTypeEnum;
    repeatFrequency?: RepeatFrequencyEnum;
    onMonday?: boolean;
    onTuesday?: boolean;
    onWednesday?: boolean;
    onThursday?: boolean;
    onFriday?: boolean;
    onSaturday?: boolean;
    onSunday?: boolean;
    /** @format int32 */
    dayOfMonth?: number | null;
    /** @format int32 */
    occurrenceCount?: number | null;
    /** @format date-time */
    planFromDate?: string | null;
    /** @format date-time */
    planToDate?: string | null;
    nextBusinessDayOnHoliday?: boolean;
    externalSystemId?: string | null;
    /** @format uuid */
    shiftTypeId?: string | null;
    shiftType?: ShiftTypeModel;
    /** @format uuid */
    workplaceId?: string | null;
    workplace?: WorkplaceModel;
    /** @format uuid */
    stationId?: string | null;
    station?: StationModel;
    auditTimingLocationType?: AuditTimingLocationTypeEnum;
    /** @format uuid */
    locationId?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface AuditTimingModelApiResultSuccess {
    returnValue?: AuditTimingModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AuditTimingModelIEnumerableApiResultSuccess {
    returnValue?: AuditTimingModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export enum AuditTimingType {
    SingleDay = 'SingleDay',
    Interval = 'Interval',
}

export enum AuditTimingTypeEnum {
    ByUser = 'ByUser',
    ByGroup = 'ByGroup',
}

export interface AuditWorkplaceModel {
    /** @format uuid */
    auditId?: string;
    /** @format uuid */
    workplaceId?: string;
    workplace?: WorkplaceModel;
    useStationLimitation?: boolean;
    auditWorkplaceStations?: AuditWorkplaceStationModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface AuditWorkplaceModelApiResultSuccess {
    returnValue?: AuditWorkplaceModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AuditWorkplaceModelIEnumerableApiResultSuccess {
    returnValue?: AuditWorkplaceModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface AuditWorkplaceStationModel {
    /** @format uuid */
    auditWorkplaceId?: string;
    /** @format uuid */
    stationId?: string;
    station?: StationModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface AvatarUploadModel {
    contentType?: string | null;
    base64?: string | null;
}

export interface AvatarUploadModelApiResultSuccess {
    returnValue?: AvatarUploadModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface BillOfMaterialItemModel {
    /** @format uuid */
    outputProductId?: string;
    /** @format uuid */
    inputProductId?: string;
    inputProduct?: ProductModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface BillOfMaterialItemModelApiResultSuccess {
    returnValue?: BillOfMaterialItemModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface BillOfMaterialItemModelIEnumerableApiResultSuccess {
    returnValue?: BillOfMaterialItemModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface CategoryAlertModel {
    /** @format uuid */
    categoryId?: string;
    name?: string | null;
    /** @format int32 */
    daysDelay?: number;
    /** @format int32 */
    daysDelayTo?: number | null;
    type?: AlertTypeEnum;
    alertTiming?: AlertTimingEnum;
    everyDay?: boolean;
    alertEscalations?: AlertEscalationModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface CategoryBasicModel {
    processType?: ProcessTypeEnum;
    name?: string | null;
    responseType?: ResponseTypeEnum;
    responseDescriptionType?: ResponseDescriptionTypeEnum;
    useExplanationByCategory?: boolean | null;
    useCommentOnResponse?: boolean | null;
    useNotRatedOption?: boolean | null;
    enforceReasonForNotRatedOption?: boolean | null;
    enforceInstuctionsConfirmation?: boolean | null;
    useMeasureType?: boolean | null;
    useAuditApproval?: boolean | null;
    useAuditApprovalWithNoFindings?: boolean | null;
    aiUseReportGeneration?: boolean;
    enforceDateImageCreationAfterAuditStart?: boolean;
    useShiftType?: boolean;
    useCustomer?: boolean;
    useProduct?: boolean;
    useProject?: boolean;
    useStation?: boolean;
    isStationRequired?: boolean;
    /** @format double */
    findingDefaultProcessDays?: number | null;
    enablePerformWhenCreatingMeasure?: boolean;
    enableVerificationWhenCreatingMeasure?: boolean;
    useFindingProcessUntil?: boolean;
    showNotClosedMeasuresInAudit?: boolean;
    canImplementerEditCauseAndMeasure?: boolean;
    useAutoEvidenceNumber?: boolean;
    autoEvidenceNumberMask?: string | null;
    showCommentOnlyForOkResponse?: boolean;
    measureVerificationUserType?: MeasureVerificationUserTypeEnum;
    planItemCloseType?: PlanItemCloseTypeEnum;
    mustSelectFindingManager?: boolean;
    useCustomNotRatedReason?: boolean;
    isSupplierAudit?: boolean;
    correctionManagers?: CorrectionManagerModel[] | null;
    responseValues?: ResponseValueModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface CategoryCustomFieldGroupModel {
    /** @format uuid */
    categoryId?: string;
    categoryCustomFields?: CategoryCustomFieldModel[] | null;
    name?: string | null;
    /** @format int32 */
    position?: number;
    customFieldGroupType?: CustomFieldGroupTypeEnum;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface CategoryCustomFieldModel {
    /** @format uuid */
    categoryCustomFieldGroupId?: string;
    name?: string | null;
    type?: CustomFieldTypeEnum;
    title?: string | null;
    placeholder?: string | null;
    /** @format int32 */
    position?: number;
    isRequired?: boolean;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface CategoryModel {
    categoryUsers?: CategoryUserModel[] | null;
    categoryCustomFieldGroups?: CategoryCustomFieldGroupModel[] | null;
    categoryAlerts?: CategoryAlertModel[] | null;
    processType?: ProcessTypeEnum;
    name?: string | null;
    responseType?: ResponseTypeEnum;
    responseDescriptionType?: ResponseDescriptionTypeEnum;
    useExplanationByCategory?: boolean | null;
    useCommentOnResponse?: boolean | null;
    useNotRatedOption?: boolean | null;
    enforceReasonForNotRatedOption?: boolean | null;
    enforceInstuctionsConfirmation?: boolean | null;
    useMeasureType?: boolean | null;
    useAuditApproval?: boolean | null;
    useAuditApprovalWithNoFindings?: boolean | null;
    aiUseReportGeneration?: boolean;
    enforceDateImageCreationAfterAuditStart?: boolean;
    useShiftType?: boolean;
    useCustomer?: boolean;
    useProduct?: boolean;
    useProject?: boolean;
    useStation?: boolean;
    isStationRequired?: boolean;
    /** @format double */
    findingDefaultProcessDays?: number | null;
    enablePerformWhenCreatingMeasure?: boolean;
    enableVerificationWhenCreatingMeasure?: boolean;
    useFindingProcessUntil?: boolean;
    showNotClosedMeasuresInAudit?: boolean;
    canImplementerEditCauseAndMeasure?: boolean;
    useAutoEvidenceNumber?: boolean;
    autoEvidenceNumberMask?: string | null;
    showCommentOnlyForOkResponse?: boolean;
    measureVerificationUserType?: MeasureVerificationUserTypeEnum;
    planItemCloseType?: PlanItemCloseTypeEnum;
    mustSelectFindingManager?: boolean;
    useCustomNotRatedReason?: boolean;
    isSupplierAudit?: boolean;
    correctionManagers?: CorrectionManagerModel[] | null;
    responseValues?: ResponseValueModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface CategoryModelApiResultSuccess {
    returnValue?: CategoryModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface CategoryModelIEnumerableApiResultSuccess {
    returnValue?: CategoryModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface CategoryUserModel {
    /** @format uuid */
    categoryId?: string;
    category?: CategoryBasicModel;
    /** @format uuid */
    tenantUserId?: string;
    tenantUser?: TenantUserBaseModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface CategoryUserModelApiResultSuccess {
    returnValue?: CategoryUserModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface CategoryUserModelIEnumerableApiResultSuccess {
    returnValue?: CategoryUserModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface CodebookModel {
    type?: CodebookTypeEnum;
    name?: string | null;
    nameIdentifier?: string | null;
    /** @format int32 */
    position?: number;
    color?: string | null;
    defaultValue?: boolean | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface CodebookModelApiResultSuccess {
    returnValue?: CodebookModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface CodebookModelIEnumerableApiResultSuccess {
    returnValue?: CodebookModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

/**
 * @format int32
 */
export type CodebookTypeEnum = number;

export enum ConditionalQueryOperator {
    Eq = 'eq',
    Ne = 'ne',
    Gt = 'gt',
    Gte = 'gte',
    Lt = 'lt',
    Lte = 'lte',
}

export interface ConfirmEmailModel {
    /** @format email */
    email: string;
    token?: string | null;
}

export interface ConfirmResetPasswordModel {
    /** @format email */
    email: string;
    token?: string | null;
    /** @format password */
    password: string;
    deactivateMfa?: boolean;
}

export enum ConvertFunctionEnum {
    None = 'none',
    Date = 'date',
    Day = 'day',
    Month = 'month',
    Year = 'year',
    Hour = 'hour',
    Minute = 'minute',
    Second = 'second',
}

export interface CorrectionManagerModel {
    /** @format uuid */
    categoryId?: string;
    /** @format uuid */
    tenantUserId?: string;
    tenantUser?: TenantUserBaseModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface CorrectionManagerModelApiResultSuccess {
    returnValue?: CorrectionManagerModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface CorrectionManagerModelIEnumerableApiResultSuccess {
    returnValue?: CorrectionManagerModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export enum CustomFieldGroupTypeEnum {
    Flat = 'Flat',
    Array = 'Array',
}

export enum CustomFieldTypeEnum {
    String = 'String',
    Integer = 'Integer',
    Double = 'Double',
    Date = 'Date',
    DateTime = 'DateTime',
    Boolean = 'Boolean',
    TextArea = 'TextArea',
}

export enum CustomFieldUsageTypeEnum {
    None = 'None',
    ByCategory = 'ByCategory',
    ByAudit = 'ByAudit',
    ByCategoryAndAudit = 'ByCategoryAndAudit',
}

export interface CustomerModel {
    code?: string | null;
    name?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface CustomerModelApiResultSuccess {
    returnValue?: CustomerModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface CustomerModelIEnumerableApiResultSuccess {
    returnValue?: CustomerModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface CycleTimeModel {
    cycleTimeType?: CycleTimeTypeEnum;
    /** @format uuid */
    locationId?: string | null;
    location?: LocationBasicModel;
    /** @format uuid */
    workplaceId?: string | null;
    workplace?: WorkplaceModel;
    /** @format uuid */
    productCollectionId?: string | null;
    productCollection?: ProductCollectionModel;
    /** @format uuid */
    productId?: string | null;
    product?: ProductModel;
    /** @format date-span */
    timePerUnit?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface CycleTimeModelApiResultSuccess {
    returnValue?: CycleTimeModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface CycleTimeModelIEnumerableApiResultSuccess {
    returnValue?: CycleTimeModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export enum CycleTimeTypeEnum {
    ByWorkplace = 'ByWorkplace',
    ByProductAndWorkplace = 'ByProductAndWorkplace',
    ByProductCollectionAndWorkplace = 'ByProductCollectionAndWorkplace',
    ByProductAndLocation = 'ByProductAndLocation',
    ByProductCollectionAndLocation = 'ByProductCollectionAndLocation',
}

export interface DefectModel {
    code?: string | null;
    name?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface DefectModelApiResultSuccess {
    returnValue?: DefectModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface DefectModelIEnumerableApiResultSuccess {
    returnValue?: DefectModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface DefectStationModel {
    /** @format uuid */
    defectId?: string;
    /** @format uuid */
    stationId?: string;
    station?: StationModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface DefectStationModelApiResultSuccess {
    returnValue?: DefectStationModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface DefectStationModelIEnumerableApiResultSuccess {
    returnValue?: DefectStationModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface DefectWorkplaceModel {
    /** @format uuid */
    defectId?: string;
    /** @format uuid */
    workplaceId?: string;
    workplace?: WorkplaceModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface DefectWorkplaceModelApiResultSuccess {
    returnValue?: DefectWorkplaceModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface DefectWorkplaceModelIEnumerableApiResultSuccess {
    returnValue?: DefectWorkplaceModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface DepartmentBasicModel {
    name?: string | null;
    /** @format uuid */
    parentalDepartmentId?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface DepartmentManagerModel {
    /** @format uuid */
    departmentId?: string;
    /** @format uuid */
    tenantUserId?: string;
    tenantUser?: TenantUserBaseModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface DepartmentModel {
    departmentParents?: DepartmentParentModel[] | null;
    departmentManagers?: DepartmentManagerModel[] | null;
    name?: string | null;
    /** @format uuid */
    parentalDepartmentId?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface DepartmentModelApiResultSuccess {
    returnValue?: DepartmentModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface DepartmentModelIEnumerableApiResultSuccess {
    returnValue?: DepartmentModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface DepartmentParentModel {
    /** @format uuid */
    parentalDepartmentId?: string;
    parentalDepartment?: DepartmentBasicModel;
    /** @format uuid */
    childDepartmentId?: string;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export enum DeviceTypeEnum {
    Browser = 'Browser',
    Android = 'Android',
    IOS = 'iOS',
}

export enum EscalationGroupTypeEnum {
    IssueEscalation = 'IssueEscalation',
    FindingEscalation = 'FindingEscalation',
    MeasureImplementationEscalation = 'MeasureImplementationEscalation',
    VerificationImplementationEscalation = 'VerificationImplementationEscalation',
}

export enum EscalationTypeEnum {
    NoEscalation = 'NoEscalation',
    OptionalEscalation = 'OptionalEscalation',
    RequiredEscalation = 'RequiredEscalation',
}

export interface EventList {
    items?: EventListItem[] | null;
}

export interface EventListItem {
    eventType?: string | null;
    correlationId?: string | null;
    data?: string | null;
}

export interface FileDownloadModel {
    filename?: string | null;
    contentType?: string | null;
    base64?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface FileDownloadModelApiResultSuccess {
    returnValue?: FileDownloadModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface FileModel {
    /** @format uuid */
    ownerId?: string | null;
    description?: string | null;
    fileName?: string | null;
    /** @format int64 */
    fileSize?: number;
    contentType?: string | null;
    blobName?: string | null;
    thumbnailBlobName?: string | null;
    /** @format date-time */
    lastModifiedAt?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface FileModelApiResultSuccess {
    returnValue?: FileModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export enum FilterGranularityEnum {
    Daily = 'Daily',
    Weekly = 'Weekly',
    Monthly = 'Monthly',
}

export interface FilterModel {
    name?: string | null;
    isPublic?: boolean;
    filterType?: FilterTypeEnum;
    area?: string | null;
    settings?: FilterStructureModel;
    filterOwners?: FilterOwnerModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface FilterModelApiResultSuccess {
    returnValue?: FilterModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface FilterModelIEnumerableApiResultSuccess {
    returnValue?: FilterModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface FilterOwnerModel {
    /** @format uuid */
    filterId?: string;
    /** @format uuid */
    tenantUserId?: string;
    tenantUser?: TenantUserBaseModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface FilterStructureItemModel {
    propertyName?: string | null;
    operator?: QueryOperator;
    comparand?: string | null;
}

export interface FilterStructureModel {
    period?: string | null;
    granularity?: FilterGranularityEnum;
    items?: FilterStructureItemModel[] | null;
}

export enum FilterTypeEnum {
    TpmAnalytics = 'TpmAnalytics',
}

export interface FindingBasicModel {
    /** @format uuid */
    responseId?: string;
    response?: ResponseBasicModel;
    description?: string | null;
    cause?: string | null;
    useDefinedManagers?: boolean;
    /** @format int32 */
    sequenceIndex?: number | null;
    isClosed?: boolean;
    /** @format date-time */
    processUntil?: string | null;
    /** @format date-time */
    processedAt?: string | null;
    /** @format int32 */
    measureCount?: number;
    /** @format double */
    processDelayDays?: number | null;
    /** @format date-time */
    closedAt?: string | null;
    /** @format uuid */
    closedById?: string | null;
    closedBy?: TenantUserBaseModel;
    closeReason?: string | null;
    findingManagers?: FindingManagerModel[] | null;
    findingFiles?: FindingFileModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface FindingBasicModelIEnumerableApiResultSuccess {
    returnValue?: FindingBasicModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface FindingFileModel {
    /** @format uuid */
    findingId?: string;
    /** @format uuid */
    fileId?: string;
    file?: FileModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface FindingManagerModel {
    /** @format uuid */
    findingId?: string;
    /** @format uuid */
    tenantUserId?: string;
    tenantUser?: TenantUserBaseModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface FindingModel {
    measures?: MeasureModel[] | null;
    /** @format uuid */
    responseId?: string;
    response?: ResponseBasicModel;
    description?: string | null;
    cause?: string | null;
    useDefinedManagers?: boolean;
    /** @format int32 */
    sequenceIndex?: number | null;
    isClosed?: boolean;
    /** @format date-time */
    processUntil?: string | null;
    /** @format date-time */
    processedAt?: string | null;
    /** @format int32 */
    measureCount?: number;
    /** @format double */
    processDelayDays?: number | null;
    /** @format date-time */
    closedAt?: string | null;
    /** @format uuid */
    closedById?: string | null;
    closedBy?: TenantUserBaseModel;
    closeReason?: string | null;
    findingManagers?: FindingManagerModel[] | null;
    findingFiles?: FindingFileModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface FindingModelApiResultSuccess {
    returnValue?: FindingModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface FindingModelIEnumerableApiResultSuccess {
    returnValue?: FindingModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface GroupBasicModel {
    name?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface GroupByDefinition {
    field?: string | null;
    convert?: ConvertFunctionEnum;
}

export interface GroupByProjectionDefinition {
    field?: string | null;
    aggregation?: ProjectionAggregationEnum;
    outputField?: string | null;
    conditional?: boolean;
    op?: ConditionalQueryOperator;
    comparand?: any;
}

export interface GroupModel {
    groupUsers?: GroupUserModel[] | null;
    name?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface GroupModelApiResultSuccess {
    returnValue?: GroupModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface GroupModelIEnumerableApiResultSuccess {
    returnValue?: GroupModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface GroupUserModel {
    /** @format uuid */
    groupId?: string;
    group?: GroupBasicModel;
    /** @format uuid */
    tenantUserId?: string;
    tenantUser?: TenantUserModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface GroupUserModelApiResultSuccess {
    returnValue?: GroupUserModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface GroupUserModelIEnumerableApiResultSuccess {
    returnValue?: GroupUserModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface GrouppedQueryModel {
    groupby?: GroupByDefinition[] | null;
    projections?: GroupByProjectionDefinition[] | null;
    predicates?: PredicateDefinition[] | null;
    orderby?: OrderByDefinition[] | null;
}

export enum HourlyPlanTypeEnum {
    ByEntry = 'ByEntry',
    ByCycleTime = 'ByCycleTime',
}

export enum HttpStatusCode {
    Continue = 'Continue',
    SwitchingProtocols = 'SwitchingProtocols',
    Processing = 'Processing',
    EarlyHints = 'EarlyHints',
    OK = 'OK',
    Created = 'Created',
    Accepted = 'Accepted',
    NonAuthoritativeInformation = 'NonAuthoritativeInformation',
    NoContent = 'NoContent',
    ResetContent = 'ResetContent',
    PartialContent = 'PartialContent',
    MultiStatus = 'MultiStatus',
    AlreadyReported = 'AlreadyReported',
    IMUsed = 'IMUsed',
    MultipleChoices = 'MultipleChoices',
    MovedPermanently = 'MovedPermanently',
    Found = 'Found',
    SeeOther = 'SeeOther',
    NotModified = 'NotModified',
    UseProxy = 'UseProxy',
    Unused = 'Unused',
    RedirectKeepVerb = 'RedirectKeepVerb',
    PermanentRedirect = 'PermanentRedirect',
    BadRequest = 'BadRequest',
    Unauthorized = 'Unauthorized',
    PaymentRequired = 'PaymentRequired',
    Forbidden = 'Forbidden',
    NotFound = 'NotFound',
    MethodNotAllowed = 'MethodNotAllowed',
    NotAcceptable = 'NotAcceptable',
    ProxyAuthenticationRequired = 'ProxyAuthenticationRequired',
    RequestTimeout = 'RequestTimeout',
    Conflict = 'Conflict',
    Gone = 'Gone',
    LengthRequired = 'LengthRequired',
    PreconditionFailed = 'PreconditionFailed',
    RequestEntityTooLarge = 'RequestEntityTooLarge',
    RequestUriTooLong = 'RequestUriTooLong',
    UnsupportedMediaType = 'UnsupportedMediaType',
    RequestedRangeNotSatisfiable = 'RequestedRangeNotSatisfiable',
    ExpectationFailed = 'ExpectationFailed',
    MisdirectedRequest = 'MisdirectedRequest',
    UnprocessableEntity = 'UnprocessableEntity',
    Locked = 'Locked',
    FailedDependency = 'FailedDependency',
    UpgradeRequired = 'UpgradeRequired',
    PreconditionRequired = 'PreconditionRequired',
    TooManyRequests = 'TooManyRequests',
    RequestHeaderFieldsTooLarge = 'RequestHeaderFieldsTooLarge',
    UnavailableForLegalReasons = 'UnavailableForLegalReasons',
    InternalServerError = 'InternalServerError',
    NotImplemented = 'NotImplemented',
    BadGateway = 'BadGateway',
    ServiceUnavailable = 'ServiceUnavailable',
    GatewayTimeout = 'GatewayTimeout',
    HttpVersionNotSupported = 'HttpVersionNotSupported',
    VariantAlsoNegotiates = 'VariantAlsoNegotiates',
    InsufficientStorage = 'InsufficientStorage',
    LoopDetected = 'LoopDetected',
    NotExtended = 'NotExtended',
    NetworkAuthenticationRequired = 'NetworkAuthenticationRequired',
}

export type IActionResult = object;

export interface IdentityError {
    code?: string | null;
    description?: string | null;
}

export interface IdentityResult {
    succeeded?: boolean;
    errors?: IdentityError[] | null;
}

export enum ImplementationStateEnum {
    None = 'None',
    New = 'New',
    InProgress = 'InProgress',
    WaitingForVerification = 'WaitingForVerification',
    Verified = 'Verified',
}

export interface ImportModel {
    importType?: ImportTypeEnum;
    /** @format uuid */
    fileId?: string;
    file?: FileModel;
    /** @format double */
    progress?: number;
    /** @format date-time */
    finishedTime?: string | null;
    errorMessage?: string | null;
    warningMessage?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ImportModelApiResultSuccess {
    returnValue?: ImportModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ImportModelIEnumerableApiResultSuccess {
    returnValue?: ImportModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export enum ImportTypeEnum {
    Audit = 'Audit',
    User = 'User',
    Customer = 'Customer',
    Project = 'Project',
    Product = 'Product',
    CycleTime = 'CycleTime',
    BillOfMaterial = 'BillOfMaterial',
    PantherV1 = 'PantherV1',
}

export interface IpResponse {
    ip?: string | null;
}

export enum IpRestrictionTypeEnum {
    QuickLogin = 'QuickLogin',
}

export enum JunctionOperator {
    And = 'and',
    Or = 'or',
}

export interface LdapSignInModel {
    username?: string | null;
    password?: string | null;
}

export interface LinearAlertModel {
    name?: string | null;
    /** @format int32 */
    daysDelay?: number;
    /** @format int32 */
    daysDelayTo?: number | null;
    type?: AlertTypeEnum;
    alertTiming?: AlertTimingEnum;
    everyDay?: boolean;
    alertEscalations?: AlertEscalationModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface LinearAlertModelApiResultSuccess {
    returnValue?: LinearAlertModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface LinearAlertModelIEnumerableApiResultSuccess {
    returnValue?: LinearAlertModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface LocationBasicModel {
    code?: string | null;
    name?: string | null;
    canPlanShifts?: boolean;
    /** @format uuid */
    parentalLocationId?: string | null;
    /** @format double */
    hourlyMaintenanceCosts?: number | null;
    /** @format double */
    hourlyDowntimeCosts?: number | null;
    /** @format double */
    hourlyDowntimeLostProfit?: number | null;
    isRegion?: boolean;
    timeZone?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface LocationGroupModel {
    /** @format uuid */
    locationId?: string;
    /** @format uuid */
    groupId?: string;
    group?: GroupBasicModel;
    locationGroupType?: LocationGroupTypeEnum;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export enum LocationGroupTypeEnum {
    Officer = 'Officer',
}

export interface LocationModel {
    locationParents?: LocationParentModel[] | null;
    locationGroups?: LocationGroupModel[] | null;
    code?: string | null;
    name?: string | null;
    canPlanShifts?: boolean;
    /** @format uuid */
    parentalLocationId?: string | null;
    /** @format double */
    hourlyMaintenanceCosts?: number | null;
    /** @format double */
    hourlyDowntimeCosts?: number | null;
    /** @format double */
    hourlyDowntimeLostProfit?: number | null;
    isRegion?: boolean;
    timeZone?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface LocationModelApiResultSuccess {
    returnValue?: LocationModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface LocationModelIEnumerableApiResultSuccess {
    returnValue?: LocationModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface LocationParentModel {
    /** @format uuid */
    parentalLocationId?: string;
    parentalLocation?: LocationBasicModel;
    /** @format uuid */
    childLocationId?: string;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface LocationParentModelApiResultSuccess {
    returnValue?: LocationParentModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface LocationParentModelIEnumerableApiResultSuccess {
    returnValue?: LocationParentModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface MachineComponentModel {
    code?: string | null;
    name?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface MachineComponentModelApiResultSuccess {
    returnValue?: MachineComponentModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface MachineComponentModelIEnumerableApiResultSuccess {
    returnValue?: MachineComponentModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface MachineComponentStationModel {
    /** @format uuid */
    machineComponentId?: string;
    /** @format uuid */
    stationId?: string;
    station?: StationModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface MachineComponentStationModelApiResultSuccess {
    returnValue?: MachineComponentStationModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface MachineComponentStationModelIEnumerableApiResultSuccess {
    returnValue?: MachineComponentStationModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface MachineComponentWorkplaceModel {
    /** @format uuid */
    machineComponentId?: string;
    /** @format uuid */
    workplaceId?: string;
    workplace?: WorkplaceModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface MachineComponentWorkplaceModelApiResultSuccess {
    returnValue?: MachineComponentWorkplaceModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface MachineComponentWorkplaceModelIEnumerableApiResultSuccess {
    returnValue?: MachineComponentWorkplaceModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface MaterialModel {
    code?: string | null;
    name?: string | null;
    /** @format double */
    costs?: number | null;
    /** @format uuid */
    unitOfMeasureId?: string | null;
    unitOfMeasure?: UnitOfMeasureModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface MaterialModelApiResultSuccess {
    returnValue?: MaterialModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface MaterialModelIEnumerableApiResultSuccess {
    returnValue?: MaterialModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface MeasureFileModel {
    /** @format uuid */
    measureId?: string;
    /** @format uuid */
    fileId?: string;
    file?: FileModel;
    type?: MeasureFileTypeEnum;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export enum MeasureFileTypeEnum {
    Measure = 'Measure',
    Perform = 'Perform',
    Verification = 'Verification',
}

export interface MeasureImplementationUserModel {
    /** @format uuid */
    measureId?: string;
    /** @format uuid */
    tenantUserId?: string;
    tenantUser?: TenantUserBaseModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface MeasureModel {
    /** @format uuid */
    findingId?: string;
    finding?: FindingBasicModel;
    measureType?: MeasureTypeEnum;
    /** @format date-time */
    implementUntil?: string | null;
    /** @format uuid */
    implementerUserId?: string | null;
    implementerUser?: TenantUserBaseModel;
    implementationState?: ImplementationStateEnum;
    implementationDescription?: string | null;
    implementationComment?: string | null;
    /** @format date-time */
    implementationTime?: string | null;
    verificationComment?: string | null;
    /** @format uuid */
    verificationUserId?: string | null;
    verificationUser?: TenantUserBaseModel;
    /** @format int32 */
    sequenceIndex?: number | null;
    /** @format double */
    implementationDelayDays?: number | null;
    immediateImplementation?: boolean;
    immediateVerification?: boolean;
    isPerfomedWhenCreated?: boolean;
    /** @format date-time */
    perfomedWhenCreatedAt?: string | null;
    /** @format uuid */
    perfomedWhenCreatedByUserId?: string | null;
    perfomedWhenCreatedByUser?: TenantUserBaseModel;
    isVerifiedWhenCreated?: boolean;
    /** @format date-time */
    verifiedWhenCreatedAt?: string | null;
    /** @format uuid */
    verifiedWhenCreatedByUserId?: string | null;
    verifiedWhenCreatedByUser?: TenantUserBaseModel;
    measureVerificationUsers?: MeasureVerificationUserModel[] | null;
    measureImplementationUsers?: MeasureImplementationUserModel[] | null;
    measureFiles?: MeasureFileModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface MeasureModelApiResultSuccess {
    returnValue?: MeasureModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface MeasureModelIEnumerableApiResultSuccess {
    returnValue?: MeasureModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export enum MeasureTypeEnum {
    Immediate = 'Immediate',
    Corrective = 'Corrective',
    Preventive = 'Preventive',
}

export interface MeasureVerificationUserModel {
    /** @format uuid */
    measureId?: string;
    /** @format uuid */
    tenantUserId?: string;
    tenantUser?: TenantUserBaseModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export enum MeasureVerificationUserTypeEnum {
    AuditPerformer = 'AuditPerformer',
    UserSelect = 'UserSelect',
}

export interface NotRatedOptionReasonModel {
    name?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface NotRatedOptionReasonModelApiResultSuccess {
    returnValue?: NotRatedOptionReasonModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface NotRatedOptionReasonModelIEnumerableApiResultSuccess {
    returnValue?: NotRatedOptionReasonModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface NotificationModel {
    /** @format uuid */
    tenantUserId?: string;
    notificationType?: NotificationTypeEnum;
    entityName?: string | null;
    /** @format uuid */
    entityId?: string;
    isDelivered?: boolean;
    /** @format date-time */
    deliveredAt?: string | null;
    isCompleted?: boolean;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface NotificationModelApiResultSuccess {
    returnValue?: NotificationModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface NotificationModelIEnumerableApiResultSuccess {
    returnValue?: NotificationModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export enum NotificationTypeEnum {
    IssueEscalation = 'IssueEscalation',
}

export type Null = object;

export interface ObjectApiResultSuccess {
    returnValue?: any;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ObjectIEnumerableApiResultSuccess {
    returnValue?: any[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export enum OpResultStatus {
    None = 'none',
    Succeeded = 'succeeded',
    Canceled = 'canceled',
    Faulted = 'faulted',
}

export interface Operation {
    value?: any;
    path?: string | null;
    op?: string | null;
    from?: string | null;
}

export interface OrderByDefinition {
    field?: string | null;
    /** @format int32 */
    index?: number | null;
    order?: SortOrder;
}

export enum PanelDashboardLayoutTypeEnum {
    TableWithOee = 'TableWithOee',
    OnlyOee = 'OnlyOee',
    OnlyTable = 'OnlyTable',
    OeeTable = 'OeeTable',
}

export interface PanelDashboardModel {
    name?: string | null;
    locationScope?: string | null;
    isActive?: boolean;
    language?: string | null;
    sortType?: PanelDashboardSortTypeEnum;
    sortAscending?: boolean;
    layoutType?: PanelDashboardLayoutTypeEnum;
    showOeeInTable?: boolean;
    showOverallOee?: boolean;
    showOeeAvailability?: boolean;
    showOeePerformance?: boolean;
    showOeeQuality?: boolean;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PanelDashboardModelApiResultSuccess {
    returnValue?: PanelDashboardModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface PanelDashboardModelIEnumerableApiResultSuccess {
    returnValue?: PanelDashboardModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export enum PanelDashboardSortTypeEnum {
    ByWorkplace = 'ByWorkplace',
    ByReportTime = 'ByReportTime',
    ByShutdownDuration = 'ByShutdownDuration',
    ByFaultPriority = 'ByFaultPriority',
}

export interface PartModel {
    /** @format uuid */
    auditId?: string;
    name?: string | null;
    /** @format int32 */
    position?: number;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PermissionModel {
    /** @format uuid */
    roleId?: string;
    permissionType?: PermissionTypeEnum;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PermissionModelApiResultSuccess {
    returnValue?: PermissionModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface PermissionModelIEnumerableApiResultSuccess {
    returnValue?: PermissionModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export enum PermissionTypeEnum {
    Admin = 'Admin',
    Audits = 'Audits',
    Plan = 'Plan',
    EditAllAudits = 'EditAllAudits',
    EditOwnedAudit = 'EditOwnedAudit',
    PerformAudit = 'PerformAudit',
    Response = 'Response',
    Findings = 'Findings',
    Measures = 'Measures',
    MistakeCorrection = 'MistakeCorrection',
    AdminGroups = 'AdminGroups',
    MeasureVerification = 'MeasureVerification',
    PlanItemReview = 'PlanItemReview',
    MeasuresAllUsers = 'MeasuresAllUsers',
    ReportIssueSolving = 'ReportIssueSolving',
    PanelDashboardEdit = 'PanelDashboardEdit',
    PanelDashboardView = 'PanelDashboardView',
    PerformProductInspection = 'PerformProductInspection',
    ProductInspections = 'ProductInspections',
    ShiftManagement = 'ShiftManagement',
    ShiftWork = 'ShiftWork',
    ShiftWorkLimited = 'ShiftWorkLimited',
    ShiftOverview = 'ShiftOverview',
    AuditSchedule = 'AuditSchedule',
    FindingManager = 'FindingManager',
    MeasureView = 'MeasureView',
    ResponseCorrection = 'ResponseCorrection',
    TpmAnalytics = 'TpmAnalytics',
    AmsAnalytics = 'AmsAnalytics',
}

export interface PlanItemAuditTenantUserModel {
    /** @format uuid */
    planItemId?: string;
    /** @format uuid */
    tenantUserId?: string;
    tenantUser?: TenantUserBaseModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PlanItemBasicModel {
    processType?: ProcessTypeEnum;
    evidenceNumber?: string | null;
    /** @format int32 */
    autoNumber?: number | null;
    /** @format uuid */
    auditId?: string;
    audit?: AuditBasicModel;
    /** @format uuid */
    tenantUserId?: string | null;
    isDeactivated?: boolean;
    /** @format uuid */
    groupId?: string | null;
    group?: GroupBasicModel;
    auditTimingType?: AuditTimingTypeEnum;
    tenantUser?: TenantUserBaseModel;
    /** @format date-time */
    since?: string;
    /** @format date-time */
    until?: string;
    /** @format date-time */
    time?: string;
    isAnswered?: boolean;
    /** @format date-time */
    startedAt?: string | null;
    /** @format date-time */
    answeredTime?: string | null;
    isImplementationClosed?: boolean;
    /** @format date-time */
    implementationClosedTime?: string | null;
    /** @format uuid */
    workplaceId?: string | null;
    workplace?: WorkplaceModel;
    /** @format uuid */
    stationId?: string | null;
    station?: StationModel;
    /** @format uuid */
    customerId?: string | null;
    customer?: CustomerModel;
    /** @format uuid */
    productId?: string | null;
    product?: ProductModel;
    /** @format uuid */
    projectId?: string | null;
    project?: ProjectModel;
    /** @format int32 */
    okCount?: number;
    /** @format int32 */
    okWarningCount?: number | null;
    /** @format int32 */
    nokCount?: number;
    /** @format int32 */
    disagreementCount?: number;
    /** @format int32 */
    scoreZeroCount?: number | null;
    /** @format int32 */
    scoreOneCount?: number | null;
    /** @format int32 */
    scoreTwoCount?: number | null;
    /** @format int32 */
    scoreThreeCount?: number | null;
    /** @format int32 */
    scoreFourCount?: number | null;
    /** @format int32 */
    scoreFiveCount?: number | null;
    /** @format int32 */
    scoreSixCount?: number | null;
    /** @format int32 */
    scoreEightCount?: number | null;
    /** @format int32 */
    scoreTenCount?: number | null;
    /** @format int32 */
    notAnsweredCount?: number | null;
    /** @format int32 */
    scoreValue?: number | null;
    /** @format int32 */
    scoreMaxValue?: number | null;
    /** @format int32 */
    responseCount?: number;
    hasCorrection?: boolean;
    /** @format date-time */
    correctionAssignedTime?: string | null;
    /** @format int32 */
    indexInDay?: number | null;
    isRequestedResponseLock?: boolean | null;
    responseLock?: boolean;
    fullLock?: boolean;
    planItemState?: PlanItemStateEnum;
    /** @format uuid */
    reviewedById?: string | null;
    reviewedBy?: TenantUserBaseModel;
    /** @format uuid */
    closedById?: string | null;
    closedBy?: TenantUserBaseModel;
    /** @format date-time */
    closedAt?: string | null;
    /** @format date-time */
    reviewedOn?: string | null;
    reviewDeclineReason?: string | null;
    /** @format uuid */
    requestReviewById?: string | null;
    requestReviewBy?: TenantUserBaseModel;
    /** @format date-time */
    requestReviewOn?: string | null;
    /** @format uuid */
    reportedById?: string | null;
    reportedBy?: TenantUserBaseModel;
    /** @format uuid */
    auditTimingId?: string | null;
    auditTiming?: AuditTimingModel;
    classification?: string | null;
    aiDisagreementSummary?: string | null;
    aiIdentifiedCauses?: string | null;
    aiIdentifiedRisks?: string | null;
    aiRecommendations?: string | null;
    aiConclusion?: string | null;
    aiIsReportGenerated?: boolean | null;
    productName?: string | null;
    productNumber?: string | null;
    /** @format date-time */
    drawingDate?: string | null;
    /** @format date-time */
    productionDate?: string | null;
    toolNumber?: string | null;
    /** @format uuid */
    shiftTypeId?: string | null;
    shiftType?: ShiftTypeModel;
    /** @format uuid */
    shiftId?: string | null;
    /** @format uuid */
    auditFaultTypeId?: string | null;
    auditFaultType?: AuditFaultTypeModel;
    /** @format uuid */
    defectId?: string | null;
    defect?: DefectModel;
    /** @format uuid */
    machineComponentId?: string | null;
    machineComponent?: MachineComponentModel;
    isReleased?: boolean | null;
    isWorkplaceShutdown?: boolean;
    /** @format date-time */
    shutdownFromDate?: string | null;
    /** @format date-time */
    shutdownToDate?: string | null;
    /** @format double */
    shutdownDuration?: number | null;
    /** @format date-time */
    reactionTime?: string | null;
    /** @format double */
    reactionDuration?: number | null;
    /** @format double */
    delayDays?: number | null;
    /** @format double */
    hourlyMaintenanceCosts?: number | null;
    /** @format double */
    hourlyDowntimeCosts?: number | null;
    /** @format double */
    hourlyDowntimeLostProfit?: number | null;
    /** @format double */
    repairDuration?: number | null;
    findingManagers?: PlanItemFindingManagerModel[] | null;
    escalations?: PlanItemEscalationModel[] | null;
    auditTenantUsers?: PlanItemAuditTenantUserModel[] | null;
    performations?: PlanItemPerformationModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PlanItemBasicModelIEnumerableApiResultSuccess {
    returnValue?: PlanItemBasicModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface PlanItemClassificationModel {
    /** @format uuid */
    planItemId?: string;
    /** @format uuid */
    productGroupId?: string | null;
    classificationValue?: string | null;
    /** @format int32 */
    scoreValue?: number | null;
    /** @format int32 */
    scoreMaxValue?: number | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export enum PlanItemCloseTypeEnum {
    ByAuditor = 'ByAuditor',
    ByReviewer = 'ByReviewer',
    ByAuditorOrReviewer = 'ByAuditorOrReviewer',
}

export interface PlanItemCustomFieldGroupModel {
    name?: string | null;
    /** @format int32 */
    position?: number;
    customFieldGroupType?: CustomFieldGroupTypeEnum;
    /** @format uuid */
    planItemId?: string;
    /** @format uuid */
    customFieldGroupId?: string;
    planItemCustomValues?: PlanItemCustomValueModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PlanItemCustomValueModel {
    name?: string | null;
    value?: string | null;
    /** @format int32 */
    rowNumber?: number | null;
    /** @format int32 */
    position?: number;
    /** @format uuid */
    planItemCustomFieldGroupId?: string;
    /** @format uuid */
    customFieldId?: string;
    type?: CustomFieldTypeEnum;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PlanItemEscalationModel {
    /** @format uuid */
    planItemId?: string;
    /** @format uuid */
    tenantUserId?: string | null;
    tenantUser?: TenantUserBaseModel;
    /** @format uuid */
    groupId?: string | null;
    group?: GroupBasicModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PlanItemFindingManagerModel {
    /** @format uuid */
    planItemId?: string;
    /** @format uuid */
    tenantUserId?: string;
    tenantUser?: TenantUserBaseModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PlanItemModel {
    isIntructionsConfirmed?: boolean | null;
    /** @format date-time */
    instructionsConfirmedOn?: string | null;
    /** @format uuid */
    correctionManagerId?: string | null;
    correctionManager?: UserBaseModel;
    responses?: ResponseModel[] | null;
    summarizations?: PlanItemSummarizationModel[] | null;
    classifications?: PlanItemClassificationModel[] | null;
    productGroupProcessSteps?: PlanItemProductGroupProcessStepModel[] | null;
    relations?: PlanItemRelationModel[] | null;
    planItemCustomFieldGroups?: PlanItemCustomFieldGroupModel[] | null;
    planItemProcessSteps?: PlanItemProcessStepModel[] | null;
    planItemProductGroups?: PlanItemProductGroupModel[] | null;
    planItemUsedMaterials?: PlanItemUsedMaterialModel[] | null;
    processType?: ProcessTypeEnum;
    evidenceNumber?: string | null;
    /** @format int32 */
    autoNumber?: number | null;
    /** @format uuid */
    auditId?: string;
    audit?: AuditBasicModel;
    /** @format uuid */
    tenantUserId?: string | null;
    isDeactivated?: boolean;
    /** @format uuid */
    groupId?: string | null;
    group?: GroupBasicModel;
    auditTimingType?: AuditTimingTypeEnum;
    tenantUser?: TenantUserBaseModel;
    /** @format date-time */
    since?: string;
    /** @format date-time */
    until?: string;
    /** @format date-time */
    time?: string;
    isAnswered?: boolean;
    /** @format date-time */
    startedAt?: string | null;
    /** @format date-time */
    answeredTime?: string | null;
    isImplementationClosed?: boolean;
    /** @format date-time */
    implementationClosedTime?: string | null;
    /** @format uuid */
    workplaceId?: string | null;
    workplace?: WorkplaceModel;
    /** @format uuid */
    stationId?: string | null;
    station?: StationModel;
    /** @format uuid */
    customerId?: string | null;
    customer?: CustomerModel;
    /** @format uuid */
    productId?: string | null;
    product?: ProductModel;
    /** @format uuid */
    projectId?: string | null;
    project?: ProjectModel;
    /** @format int32 */
    okCount?: number;
    /** @format int32 */
    okWarningCount?: number | null;
    /** @format int32 */
    nokCount?: number;
    /** @format int32 */
    disagreementCount?: number;
    /** @format int32 */
    scoreZeroCount?: number | null;
    /** @format int32 */
    scoreOneCount?: number | null;
    /** @format int32 */
    scoreTwoCount?: number | null;
    /** @format int32 */
    scoreThreeCount?: number | null;
    /** @format int32 */
    scoreFourCount?: number | null;
    /** @format int32 */
    scoreFiveCount?: number | null;
    /** @format int32 */
    scoreSixCount?: number | null;
    /** @format int32 */
    scoreEightCount?: number | null;
    /** @format int32 */
    scoreTenCount?: number | null;
    /** @format int32 */
    notAnsweredCount?: number | null;
    /** @format int32 */
    scoreValue?: number | null;
    /** @format int32 */
    scoreMaxValue?: number | null;
    /** @format int32 */
    responseCount?: number;
    hasCorrection?: boolean;
    /** @format date-time */
    correctionAssignedTime?: string | null;
    /** @format int32 */
    indexInDay?: number | null;
    isRequestedResponseLock?: boolean | null;
    responseLock?: boolean;
    fullLock?: boolean;
    planItemState?: PlanItemStateEnum;
    /** @format uuid */
    reviewedById?: string | null;
    reviewedBy?: TenantUserBaseModel;
    /** @format uuid */
    closedById?: string | null;
    closedBy?: TenantUserBaseModel;
    /** @format date-time */
    closedAt?: string | null;
    /** @format date-time */
    reviewedOn?: string | null;
    reviewDeclineReason?: string | null;
    /** @format uuid */
    requestReviewById?: string | null;
    requestReviewBy?: TenantUserBaseModel;
    /** @format date-time */
    requestReviewOn?: string | null;
    /** @format uuid */
    reportedById?: string | null;
    reportedBy?: TenantUserBaseModel;
    /** @format uuid */
    auditTimingId?: string | null;
    auditTiming?: AuditTimingModel;
    classification?: string | null;
    aiDisagreementSummary?: string | null;
    aiIdentifiedCauses?: string | null;
    aiIdentifiedRisks?: string | null;
    aiRecommendations?: string | null;
    aiConclusion?: string | null;
    aiIsReportGenerated?: boolean | null;
    productName?: string | null;
    productNumber?: string | null;
    /** @format date-time */
    drawingDate?: string | null;
    /** @format date-time */
    productionDate?: string | null;
    toolNumber?: string | null;
    /** @format uuid */
    shiftTypeId?: string | null;
    shiftType?: ShiftTypeModel;
    /** @format uuid */
    shiftId?: string | null;
    /** @format uuid */
    auditFaultTypeId?: string | null;
    auditFaultType?: AuditFaultTypeModel;
    /** @format uuid */
    defectId?: string | null;
    defect?: DefectModel;
    /** @format uuid */
    machineComponentId?: string | null;
    machineComponent?: MachineComponentModel;
    isReleased?: boolean | null;
    isWorkplaceShutdown?: boolean;
    /** @format date-time */
    shutdownFromDate?: string | null;
    /** @format date-time */
    shutdownToDate?: string | null;
    /** @format double */
    shutdownDuration?: number | null;
    /** @format date-time */
    reactionTime?: string | null;
    /** @format double */
    reactionDuration?: number | null;
    /** @format double */
    delayDays?: number | null;
    /** @format double */
    hourlyMaintenanceCosts?: number | null;
    /** @format double */
    hourlyDowntimeCosts?: number | null;
    /** @format double */
    hourlyDowntimeLostProfit?: number | null;
    /** @format double */
    repairDuration?: number | null;
    findingManagers?: PlanItemFindingManagerModel[] | null;
    escalations?: PlanItemEscalationModel[] | null;
    auditTenantUsers?: PlanItemAuditTenantUserModel[] | null;
    performations?: PlanItemPerformationModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PlanItemModelApiResultSuccess {
    returnValue?: PlanItemModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface PlanItemModelIEnumerableApiResultSuccess {
    returnValue?: PlanItemModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface PlanItemPerformationModel {
    /** @format uuid */
    planItemId?: string;
    /** @format uuid */
    tenantUserId?: string;
    tenantUser?: TenantUserBaseModel;
    /** @format date-time */
    fromDate?: string;
    /** @format date-time */
    toDate?: string | null;
    /** @format int32 */
    sequenceIndex?: number;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PlanItemProcessStepModel {
    /** @format uuid */
    planItemId?: string;
    /** @format uuid */
    processStepId?: string;
    processStep?: ProcessStepModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PlanItemProductGroupModel {
    /** @format uuid */
    planItemId?: string;
    /** @format uuid */
    productGroupId?: string;
    productGroup?: ProductGroupModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PlanItemProductGroupProcessStepModel {
    /** @format uuid */
    planItemId?: string;
    /** @format uuid */
    productGroupId?: string;
    productGroup?: ProductGroupModel;
    /** @format uuid */
    processStepId?: string;
    processStep?: ProcessStepModel;
    /** @format int32 */
    position?: number;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PlanItemRelationModel {
    relationType?: PlanItemRelationTypeEnum;
    /** @format uuid */
    fromPlanItemId?: string;
    /** @format uuid */
    responseId?: string;
    /** @format uuid */
    toPlanItemId?: string;
    toPlanItem?: PlanItemBasicModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export enum PlanItemRelationTypeEnum {
    IssueEscalation = 'IssueEscalation',
}

export enum PlanItemStateEnum {
    WaitingToPerform = 'WaitingToPerform',
    ClosedWithoutFindings = 'ClosedWithoutFindings',
    NeedsToCreateMeasures = 'NeedsToCreateMeasures',
    NeedsToPerformMeasures = 'NeedsToPerformMeasures',
    NeedsToVerifyMeasures = 'NeedsToVerifyMeasures',
    AllMeasuresVerified = 'AllMeasuresVerified',
    Closed = 'Closed',
    WaitingForApproval = 'WaitingForApproval',
    Approved = 'Approved',
    Declined = 'Declined',
    PerformedWithoutFindings = 'PerformedWithoutFindings',
    Reported = 'Reported',
    ClosedWithIssueEscalation = 'ClosedWithIssueEscalation',
}

export interface PlanItemSummarizationModel {
    identifier?: string | null;
    /** @format int32 */
    rowIndex?: number;
    summarizationType?: SummarizationTypeEnum;
    /** @format uuid */
    planItemId?: string;
    processElement?: string | null;
    processSubElement?: string | null;
    /** @format uuid */
    productGroupId?: string | null;
    productGroup?: ProductGroupModel;
    /** @format uuid */
    processStepId?: string | null;
    processStep?: ProcessStepModel;
    /** @format double */
    value?: number | null;
    isClassificationChange?: boolean | null;
    classificationChangeValue?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PlanItemUsedMaterialModel {
    /** @format uuid */
    planItemId?: string;
    /** @format uuid */
    materialId?: string;
    material?: MaterialModel;
    /** @format double */
    quantity?: number;
    /** @format double */
    costsPerUnit?: number | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PositionModel {
    name?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface PositionModelApiResultSuccess {
    returnValue?: PositionModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface PositionModelIEnumerableApiResultSuccess {
    returnValue?: PositionModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface PredicateDefinition {
    junction?: JunctionOperator;
    field?: string | null;
    op?: QueryOperator;
    comparand?: any;
}

export interface PrintPlanItemRequestOptions {
    disableComments?: boolean;
    omitHighestScores?: boolean;
}

export interface ProcessStepModel {
    /** @format uuid */
    auditId?: string;
    stepNumber?: string | null;
    name?: string | null;
    /** @format int32 */
    position?: number;
    isHidden?: boolean;
    /** @format uuid */
    key?: string | null;
    isVirtual?: boolean;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export enum ProcessTypeEnum {
    Audit = 'Audit',
    Maintenance = 'Maintenance',
    IssueSolving = 'IssueSolving',
    Checklist = 'Checklist',
    ProductInspection = 'ProductInspection',
}

export interface ProductCollectionModel {
    name?: string | null;
    /** @format double */
    scrapCosts?: number | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ProductCollectionModelApiResultSuccess {
    returnValue?: ProductCollectionModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ProductCollectionModelIEnumerableApiResultSuccess {
    returnValue?: ProductCollectionModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ProductGroupModel {
    /** @format uuid */
    auditId?: string;
    name?: string | null;
    /** @format int32 */
    position?: number;
    /** @format uuid */
    key?: string | null;
    isVirtual?: boolean;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ProductGroupProcessStepModel {
    /** @format uuid */
    auditId?: string;
    /** @format uuid */
    productGroupId?: string;
    productGroup?: ProductGroupModel;
    /** @format uuid */
    processStepId?: string;
    processStep?: ProcessStepModel;
    isVirtual?: boolean;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ProductModel {
    /** @format uuid */
    projectId?: string | null;
    project?: ProjectModel;
    /** @format uuid */
    productCollectionId?: string | null;
    productCollection?: ProductCollectionModel;
    isScrapAutoEscalationEnabled?: boolean;
    /** @format double */
    scrapAutoEscalationCount?: number | null;
    /** @format uuid */
    scrapAutoEscalationAuditId?: string | null;
    /** @format uuid */
    scrapAutoEscalationFaultTypeId?: string | null;
    /** @format uuid */
    scrapAutoEscalationGroupId?: string | null;
    /** @format double */
    scrapCosts?: number | null;
    productScrapReasons?: ProductScrapReasonModel[] | null;
    billOfMaterialItems?: BillOfMaterialItemModel[] | null;
    code?: string | null;
    name?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ProductModelApiResultSuccess {
    returnValue?: ProductModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ProductModelIEnumerableApiResultSuccess {
    returnValue?: ProductModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ProductScrapReasonModel {
    /** @format uuid */
    productId?: string;
    /** @format uuid */
    scrapReasonId?: string;
    scrapReason?: ScrapReasonModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ProjectModel {
    code?: string | null;
    name?: string | null;
    isScrapAutoEscalationEnabled?: boolean;
    /** @format double */
    scrapAutoEscalationCount?: number | null;
    /** @format uuid */
    scrapAutoEscalationAuditId?: string | null;
    /** @format uuid */
    scrapAutoEscalationFaultTypeId?: string | null;
    /** @format uuid */
    scrapAutoEscalationGroupId?: string | null;
    projectScrapReasons?: ProjectScrapReasonModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ProjectModelApiResultSuccess {
    returnValue?: ProjectModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ProjectModelIEnumerableApiResultSuccess {
    returnValue?: ProjectModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ProjectScrapReasonModel {
    /** @format uuid */
    projectId?: string;
    /** @format uuid */
    scrapReasonId?: string;
    scrapReason?: ScrapReasonModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export enum ProjectionAggregationEnum {
    Count = 'count',
    Avg = 'avg',
    Sum = 'sum',
    Min = 'min',
    Max = 'max',
}

export interface QueryModel {
    predicates?: PredicateDefinition[] | null;
    orderby?: OrderByDefinition[] | null;
}

export enum QueryOperator {
    Eq = 'eq',
    Ne = 'ne',
    Gt = 'gt',
    Gte = 'gte',
    Lt = 'lt',
    Lte = 'lte',
    C = 'c',
    Sw = 'sw',
    Ew = 'ew',
    In = 'in',
    Wrap = 'wrap',
}

export interface QuestionBasicModel {
    /** @format uuid */
    questionGroupId?: string;
    processElementStep?: string | null;
    code?: string | null;
    name?: string | null;
    /** @format int32 */
    position?: number;
    questionGroup?: QuestionGroupBasicModel;
    description?: string | null;
    disagreementResponse?: string | null;
    isHighRisk?: boolean | null;
    aiGenerated?: boolean | null;
    isFileRequired?: boolean;
    /** @format uuid */
    escalationAuditId?: string | null;
    /** @format uuid */
    escalationFaultTypeId?: string | null;
    /** @format uuid */
    escalationGroupId?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface QuestionFileModel {
    /** @format uuid */
    questionId?: string;
    /** @format uuid */
    fileId?: string;
    file?: FileModel;
    /** @format int32 */
    position?: number | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface QuestionGroupBasicModel {
    /** @format uuid */
    auditId?: string;
    audit?: AuditModel;
    name?: string | null;
    /** @format int32 */
    position?: number;
    processElement?: string | null;
    processElementStep?: string | null;
    aiGenerated?: boolean | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface QuestionGroupExplanationModel {
    /** @format uuid */
    questionGroupId?: string;
    /** @format int32 */
    responseValue?: number;
    explanationDescription?: string | null;
    /** @format uuid */
    fileId?: string | null;
    file?: FileModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface QuestionGroupModel {
    questions?: QuestionModel[] | null;
    questionGroupExplanations?: QuestionGroupExplanationModel[] | null;
    /** @format uuid */
    auditId?: string;
    audit?: AuditModel;
    name?: string | null;
    /** @format int32 */
    position?: number;
    processElement?: string | null;
    processElementStep?: string | null;
    aiGenerated?: boolean | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface QuestionGroupModelApiResultSuccess {
    returnValue?: QuestionGroupModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface QuestionGroupModelIEnumerableApiResultSuccess {
    returnValue?: QuestionGroupModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface QuestionModel {
    questionFiles?: QuestionFileModel[] | null;
    /** @format uuid */
    questionGroupId?: string;
    processElementStep?: string | null;
    code?: string | null;
    name?: string | null;
    /** @format int32 */
    position?: number;
    questionGroup?: QuestionGroupBasicModel;
    description?: string | null;
    disagreementResponse?: string | null;
    isHighRisk?: boolean | null;
    aiGenerated?: boolean | null;
    isFileRequired?: boolean;
    /** @format uuid */
    escalationAuditId?: string | null;
    /** @format uuid */
    escalationFaultTypeId?: string | null;
    /** @format uuid */
    escalationGroupId?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface QuestionModelApiResultSuccess {
    returnValue?: QuestionModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface QuestionModelIEnumerableApiResultSuccess {
    returnValue?: QuestionModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export enum RepeatFrequencyEnum {
    Week = 'Week',
    Month = 'Month',
}

export interface ResetPasswordModel {
    /** @format email */
    email: string;
}

export interface ResponseBasicModel {
    planItem?: PlanItemBasicModel;
    /** @format uuid */
    planItemId?: string;
    /** @format uuid */
    questionId?: string;
    question?: QuestionBasicModel;
    hasDisagreement?: boolean | null;
    isOk?: boolean | null;
    /** @format int32 */
    okValue?: number | null;
    /** @format int32 */
    scoreValue?: number | null;
    /** @format int32 */
    systemAuditValue?: number | null;
    /** @format int32 */
    productAuditValue?: number | null;
    description?: string | null;
    escalationDescription?: string | null;
    immediateMeasures?: string | null;
    /** @format date-time */
    answeredTime?: string | null;
    hasCorrection?: boolean;
    correctionDescription?: string | null;
    /** @format date-time */
    correctionAssignedTime?: string | null;
    /** @format uuid */
    implementerUserId?: string | null;
    implementerUser?: TenantUserBaseModel;
    implementationState?: ImplementationStateEnum;
    implementationDescription?: string | null;
    /** @format date-time */
    implementationTime?: string | null;
    notRatedReason?: string | null;
    /** @format int32 */
    sequenceIndex?: number | null;
    /** @format uuid */
    processStepId?: string | null;
    processStep?: ProcessStepModel;
    checkAccordingTo?: string | null;
    specialCharacteristics?: string | null;
    problemDescription?: string | null;
    responseParts?: ResponsePartModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export enum ResponseDescriptionTypeEnum {
    Category = 'Category',
    Audit = 'Audit',
    Group = 'Group',
}

export interface ResponseFileModel {
    /** @format uuid */
    responseId?: string;
    /** @format uuid */
    fileId?: string;
    file?: FileModel;
    type?: ResponseFileType;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export enum ResponseFileType {
    Response = 'Response',
    CorrectiveMeasure = 'CorrectiveMeasure',
    CorrectiveMeasureImplementation = 'CorrectiveMeasureImplementation',
}

export interface ResponseModel {
    responseFiles?: ResponseFileModel[] | null;
    findings?: FindingModel[] | null;
    planItem?: PlanItemBasicModel;
    /** @format uuid */
    planItemId?: string;
    /** @format uuid */
    questionId?: string;
    question?: QuestionBasicModel;
    hasDisagreement?: boolean | null;
    isOk?: boolean | null;
    /** @format int32 */
    okValue?: number | null;
    /** @format int32 */
    scoreValue?: number | null;
    /** @format int32 */
    systemAuditValue?: number | null;
    /** @format int32 */
    productAuditValue?: number | null;
    description?: string | null;
    escalationDescription?: string | null;
    immediateMeasures?: string | null;
    /** @format date-time */
    answeredTime?: string | null;
    hasCorrection?: boolean;
    correctionDescription?: string | null;
    /** @format date-time */
    correctionAssignedTime?: string | null;
    /** @format uuid */
    implementerUserId?: string | null;
    implementerUser?: TenantUserBaseModel;
    implementationState?: ImplementationStateEnum;
    implementationDescription?: string | null;
    /** @format date-time */
    implementationTime?: string | null;
    notRatedReason?: string | null;
    /** @format int32 */
    sequenceIndex?: number | null;
    /** @format uuid */
    processStepId?: string | null;
    processStep?: ProcessStepModel;
    checkAccordingTo?: string | null;
    specialCharacteristics?: string | null;
    problemDescription?: string | null;
    responseParts?: ResponsePartModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ResponseModelApiResultSuccess {
    returnValue?: ResponseModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ResponseModelIEnumerableApiResultSuccess {
    returnValue?: ResponseModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ResponsePartModel {
    /** @format uuid */
    responseId?: string;
    /** @format uuid */
    partId?: string;
    part?: PartModel;
    isOk?: boolean | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export enum ResponseTypeEnum {
    Ok = 'Ok',
    OkNok = 'OkNok',
    OkNokWarning = 'OkNokWarning',
    NokWarning = 'NokWarning',
    ScoreZeroToOne = 'ScoreZeroToOne',
    ScoreZeroToTwo = 'ScoreZeroToTwo',
    ScoreOneToThree = 'ScoreOneToThree',
    ScoreZeroToFour = 'ScoreZeroToFour',
    ScoreZeroToFive = 'ScoreZeroToFive',
    ScoreOneToFive = 'ScoreOneToFive',
    VDA63 = 'VDA63',
    ScoreZeroToThree = 'ScoreZeroToThree',
    ScoreOneToFour = 'ScoreOneToFour',
    SystemAudit = 'SystemAudit',
    ProductAudit = 'ProductAudit',
}

export interface ResponseValueModel {
    /** @format uuid */
    categoryId?: string;
    /** @format int32 */
    value?: number;
    color?: string | null;
    escalationType?: EscalationTypeEnum;
    description?: string | null;
    explanationDescription?: string | null;
    label?: string | null;
    isCommentEnabled?: boolean;
    isDescriptionRequired?: boolean;
    isProblemDescriptionRequired?: boolean;
    /** @format int32 */
    timeLimitFromStart?: number | null;
    isPreventiveMeasureRequired?: boolean;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ResponseValueModelApiResultSuccess {
    returnValue?: ResponseValueModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ResponseValueModelIEnumerableApiResultSuccess {
    returnValue?: ResponseValueModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface RoleModel {
    name?: string | null;
    onlyDashboard?: boolean;
    onlyDashboardAndCalendar?: boolean;
    disableDashboard?: boolean;
    permissions?: PermissionModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface RoleModelApiResultSuccess {
    returnValue?: RoleModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface RoleModelIEnumerableApiResultSuccess {
    returnValue?: RoleModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ScrapCauseModel {
    name?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ScrapCauseModelApiResultSuccess {
    returnValue?: ScrapCauseModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ScrapCauseModelIEnumerableApiResultSuccess {
    returnValue?: ScrapCauseModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ScrapReasonModel {
    code?: string | null;
    name?: string | null;
    useWorkplaceLimitation?: boolean;
    /** @format uuid */
    scrapCauseId?: string | null;
    scrapCause?: ScrapCauseModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ScrapReasonModelApiResultSuccess {
    returnValue?: ScrapReasonModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ScrapReasonModelIEnumerableApiResultSuccess {
    returnValue?: ScrapReasonModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ScrapReasonWorkplaceModel {
    /** @format uuid */
    scrapReasonId?: string;
    /** @format uuid */
    workplaceId?: string;
    workplace?: WorkplaceModel;
    useStationLimitation?: boolean;
    scrapReasonWorkplaceStations?: ScrapReasonWorkplaceStationModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ScrapReasonWorkplaceModelApiResultSuccess {
    returnValue?: ScrapReasonWorkplaceModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ScrapReasonWorkplaceModelIEnumerableApiResultSuccess {
    returnValue?: ScrapReasonWorkplaceModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ScrapReasonWorkplaceStationModel {
    /** @format uuid */
    scrapReasonWorkplaceId?: string;
    /** @format uuid */
    stationId?: string;
    station?: StationModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export enum ServiceQueueActionEnum {
    AuditTimingInserted = 'AuditTimingInserted',
    AuditTimingUpdated = 'AuditTimingUpdated',
    AuditTimingDeleted = 'AuditTimingDeleted',
    AuditInserted = 'AuditInserted',
    AuditDeactivated = 'AuditDeactivated',
    AuditActivated = 'AuditActivated',
    AuditDeleted = 'AuditDeleted',
    AuditUpdated = 'AuditUpdated',
    AgendaMove = 'AgendaMove',
    CategoryCorrectionManagersUpdated = 'CategoryCorrectionManagersUpdated',
}

export interface ServiceQueueItemFilterModel {
    filterTypes?: ServiceQueueItemFilterTypeEnum[] | null;
    /** @format date-time */
    fromDate?: string;
    /** @format date-time */
    toDate?: string;
    fromValue?: string | null;
    fromValueName?: string | null;
}

export enum ServiceQueueItemFilterTypeEnum {
    Plan = 'Plan',
    Findings = 'Findings',
    Measures = 'Measures',
    Verification = 'Verification',
    Review = 'Review',
}

export interface ServiceQueueItemModel {
    action?: ServiceQueueActionEnum;
    isDone?: boolean;
    /** @format date-time */
    doneAt?: string | null;
    /** @format uuid */
    categoryId?: string | null;
    /** @format uuid */
    auditId?: string | null;
    /** @format uuid */
    auditTimingId?: string | null;
    /** @format uuid */
    planItemId?: string | null;
    filters?: ServiceQueueItemFilterModel;
    newValue?: string | null;
    newValueName?: string | null;
    hasError?: boolean;
    errorMessage?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ServiceQueueItemModelApiResultSuccess {
    returnValue?: ServiceQueueItemModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ServiceQueueItemModelIEnumerableApiResultSuccess {
    returnValue?: ServiceQueueItemModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface SetPasswordModel {
    currentPassword: string;
    newPassword: string;
}

export interface ShiftBasicModel {
    /** @format date-time */
    fromDate?: string;
    /** @format date-time */
    toDate?: string;
    /** @format uuid */
    shiftTypeId?: string;
    shiftType?: ShiftTypeModel;
    /** @format uuid */
    shiftTeamTypeId?: string | null;
    shiftTeamType?: ShiftTeamTypeModel;
    /** @format uuid */
    workplaceId?: string;
    workplace?: WorkplaceModel;
    /** @format uuid */
    declaredById?: string | null;
    declaredBy?: TenantUserBaseModel;
    /** @format double */
    scrapRate?: number | null;
    /** @format double */
    nokCount?: number | null;
    /** @format double */
    okCount?: number | null;
    /** @format double */
    planCount?: number | null;
    /** @format double */
    hourlyPlan?: number | null;
    /** @format double */
    hourlyPlanCycleTime?: number | null;
    hasChecklist?: boolean;
    shiftState?: ShiftStateEnum;
    hourlyPlanType?: HourlyPlanTypeEnum;
    /** @format date-time */
    openedAt?: string | null;
    /** @format uuid */
    openedById?: string | null;
    openedBy?: TenantUserBaseModel;
    /** @format date-time */
    closedAt?: string | null;
    /** @format uuid */
    closedById?: string | null;
    closedBy?: TenantUserBaseModel;
    /** @format uuid */
    officerId?: string | null;
    officer?: TenantUserBaseModel;
    comment?: string | null;
    /** @format int32 */
    checklistDoneCount?: number;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ShiftBasicModelIEnumerableApiResultSuccess {
    returnValue?: ShiftBasicModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ShiftFileModel {
    /** @format uuid */
    shiftId?: string;
    /** @format uuid */
    fileId?: string;
    file?: FileModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ShiftFileModelApiResultSuccess {
    returnValue?: ShiftFileModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ShiftFileModelIEnumerableApiResultSuccess {
    returnValue?: ShiftFileModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ShiftModel {
    shiftProductions?: ShiftProductionModel[] | null;
    /** @format date-time */
    fromDate?: string;
    /** @format date-time */
    toDate?: string;
    /** @format uuid */
    shiftTypeId?: string;
    shiftType?: ShiftTypeModel;
    /** @format uuid */
    shiftTeamTypeId?: string | null;
    shiftTeamType?: ShiftTeamTypeModel;
    /** @format uuid */
    workplaceId?: string;
    workplace?: WorkplaceModel;
    /** @format uuid */
    declaredById?: string | null;
    declaredBy?: TenantUserBaseModel;
    /** @format double */
    scrapRate?: number | null;
    /** @format double */
    nokCount?: number | null;
    /** @format double */
    okCount?: number | null;
    /** @format double */
    planCount?: number | null;
    /** @format double */
    hourlyPlan?: number | null;
    /** @format double */
    hourlyPlanCycleTime?: number | null;
    hasChecklist?: boolean;
    shiftState?: ShiftStateEnum;
    hourlyPlanType?: HourlyPlanTypeEnum;
    /** @format date-time */
    openedAt?: string | null;
    /** @format uuid */
    openedById?: string | null;
    openedBy?: TenantUserBaseModel;
    /** @format date-time */
    closedAt?: string | null;
    /** @format uuid */
    closedById?: string | null;
    closedBy?: TenantUserBaseModel;
    /** @format uuid */
    officerId?: string | null;
    officer?: TenantUserBaseModel;
    comment?: string | null;
    /** @format int32 */
    checklistDoneCount?: number;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ShiftModelApiResultSuccess {
    returnValue?: ShiftModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ShiftModelIEnumerableApiResultSuccess {
    returnValue?: ShiftModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ShiftProductionModel {
    /** @format uuid */
    shiftId?: string;
    /** @format uuid */
    productId?: string;
    product?: ProductModel;
    /** @format uuid */
    customerId?: string | null;
    customer?: CustomerModel;
    /** @format uuid */
    projectId?: string | null;
    project?: ProjectModel;
    /** @format double */
    planCount?: number | null;
    /** @format double */
    nokCount?: number | null;
    /** @format double */
    okCount?: number | null;
    /** @format double */
    scrapRate?: number | null;
    /** @format int32 */
    sequenceIndex?: number;
    shiftProductionRecords?: ShiftProductionRecordModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ShiftProductionRecordModel {
    /** @format uuid */
    shiftProductionId?: string;
    /** @format date-time */
    recordTime?: string;
    /** @format double */
    okCount?: number | null;
    /** @format double */
    nokCount?: number | null;
    /** @format double */
    scrapRate?: number | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ShiftScrapRecordModel {
    /** @format uuid */
    shiftId?: string;
    /** @format uuid */
    stationId?: string | null;
    station?: StationModel;
    /** @format uuid */
    productId?: string;
    product?: ProductModel;
    /** @format uuid */
    scrapReasonId?: string | null;
    scrapReason?: ScrapReasonModel;
    /** @format date-time */
    recordTime?: string;
    /** @format double */
    scrapCount?: number;
    /** @format double */
    scrapCostsPerUnit?: number | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ShiftScrapRecordModelApiResultSuccess {
    returnValue?: ShiftScrapRecordModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ShiftScrapRecordModelIEnumerableApiResultSuccess {
    returnValue?: ShiftScrapRecordModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export enum ShiftStateEnum {
    Waiting = 'Waiting',
    Opened = 'Opened',
    Closed = 'Closed',
}

export interface ShiftStationModel {
    /** @format uuid */
    shiftId?: string;
    shift?: ShiftBasicModel;
    /** @format uuid */
    stationId?: string;
    station?: StationModel;
    /** @format uuid */
    workerId?: string | null;
    worker?: TenantUserBaseModel;
    /** @format int32 */
    checklistDoneCount?: number;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ShiftStationModelApiResultSuccess {
    returnValue?: ShiftStationModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ShiftStationModelIEnumerableApiResultSuccess {
    returnValue?: ShiftStationModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ShiftTeamTypeModel {
    code?: string | null;
    name?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ShiftTeamTypeModelApiResultSuccess {
    returnValue?: ShiftTeamTypeModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ShiftTeamTypeModelIEnumerableApiResultSuccess {
    returnValue?: ShiftTeamTypeModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ShiftTypeModel {
    code?: string | null;
    name?: string | null;
    /** @format date-span */
    fromTime?: string | null;
    /** @format date-span */
    toTime?: string | null;
    /** @format int32 */
    shiftNumber?: number | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface ShiftTypeModelApiResultSuccess {
    returnValue?: ShiftTypeModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ShiftTypeModelIEnumerableApiResultSuccess {
    returnValue?: ShiftTypeModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface SignUpModel {
    /** @format email */
    email: string;
    /** @format password */
    password: string;
    firstName: string;
    lastName: string;
    language: string;
    phoneNumber: string;
    /** @format uuid */
    invitationToken?: string | null;
}

export enum SortOrder {
    Asc = 'asc',
    Desc = 'desc',
}

export interface StationModel {
    name?: string | null;
    /** @format uuid */
    workplaceId?: string;
    workplace?: WorkplaceModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface StationModelApiResultSuccess {
    returnValue?: StationModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface StationModelIEnumerableApiResultSuccess {
    returnValue?: StationModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export enum SummarizationTypeEnum {
    Question = 'Question',
    ProcessElement = 'ProcessElement',
    ProcessSubElement = 'ProcessSubElement',
    ProcessStep = 'ProcessStep',
    HighRiskQuestion = 'HighRiskQuestion',
}

export interface SystemUserModel {
    /** @format uuid */
    userId?: string;
    user?: UserBaseModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface SystemUserModelApiResultSuccess {
    returnValue?: SystemUserModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface SystemUserModelIEnumerableApiResultSuccess {
    returnValue?: SystemUserModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TargetModel {
    /** @format uuid */
    locationId?: string | null;
    location?: LocationBasicModel;
    /** @format uuid */
    workplaceId?: string | null;
    workplace?: WorkplaceModel;
    /** @format date-time */
    fromDate?: string | null;
    /** @format date-time */
    toDate?: string | null;
    /** @format double */
    worldClassOee?: number | null;
    /** @format double */
    targetOee?: number | null;
    /** @format double */
    targetOeeAvailability?: number | null;
    /** @format double */
    targetOeePerformance?: number | null;
    /** @format double */
    targetOeeQuality?: number | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface TargetModelApiResultSuccess {
    returnValue?: TargetModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TargetModelIEnumerableApiResultSuccess {
    returnValue?: TargetModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TenantBaseModel {
    name?: string | null;
    domainName?: string | null;
    currency?: string | null;
    timeZone?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface TenantDeviceModel {
    deviceId?: string | null;
    deviceType?: DeviceTypeEnum;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface TenantDeviceModelApiResultSuccess {
    returnValue?: TenantDeviceModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TenantDeviceModelIEnumerableApiResultSuccess {
    returnValue?: TenantDeviceModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TenantDeviceSubscriptionModel {
    /** @format uuid */
    tenantDeviceId?: string;
    tenantDevice?: TenantDeviceModel;
    subscription?: string | null;
    /** @format uuid */
    tenantUserId?: string | null;
    tenantUser?: TenantUserBaseModel;
    isUnavailable?: boolean;
    /** @format int32 */
    unavailabilityCount?: number;
    /** @format date-time */
    unavailableSince?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface TenantDeviceSubscriptionModelApiResultSuccess {
    returnValue?: TenantDeviceSubscriptionModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TenantDeviceSubscriptionModelIEnumerableApiResultSuccess {
    returnValue?: TenantDeviceSubscriptionModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TenantInvitationCategoryUserModel {
    /** @format uuid */
    tenantInvitationId?: string;
    /** @format uuid */
    categoryId?: string;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface TenantInvitationLocationModel {
    /** @format uuid */
    tenantInvitationId?: string;
    /** @format uuid */
    locationId?: string;
    location?: LocationModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface TenantInvitationModel {
    emailAddress?: string | null;
    isActive?: boolean;
    isAccepted?: boolean | null;
    language?: string | null;
    accessAllCategories?: boolean | null;
    employeeId?: string | null;
    /** @format uuid */
    positionId?: string | null;
    /** @format uuid */
    departmentId?: string | null;
    /** @format date-time */
    acceptedOn?: string | null;
    tenant?: TenantBaseModel;
    isExternal?: boolean;
    tenantInvitationRoles?: TenantInvitationRoleModel[] | null;
    tenantInvitationCategoryUsers?: TenantInvitationCategoryUserModel[] | null;
    locations?: TenantInvitationLocationModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface TenantInvitationModelApiResultSuccess {
    returnValue?: TenantInvitationModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TenantInvitationModelIEnumerableApiResultSuccess {
    returnValue?: TenantInvitationModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TenantInvitationRoleModel {
    /** @format uuid */
    tenantInvitationId?: string;
    /** @format uuid */
    roleId?: string;
    role?: RoleModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface TenantIpRestrictionModel {
    ipRestrictionType?: IpRestrictionTypeEnum;
    ip?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface TenantIpRestrictionModelApiResultSuccess {
    returnValue?: TenantIpRestrictionModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TenantIpRestrictionModelIEnumerableApiResultSuccess {
    returnValue?: TenantIpRestrictionModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TenantModel {
    identificationNumber?: string | null;
    address?: string | null;
    vat?: string | null;
    addressStreet?: string | null;
    addressCity?: string | null;
    addressZip?: string | null;
    /** @format double */
    evaluationRepeatEach?: number | null;
    evaluationRepeatFrequency?: RepeatFrequencyEnum;
    /** @format uuid */
    avatar?: string | null;
    /** @format int32 */
    maxUploadFileSize?: number;
    /** @format date-time */
    licenceToDate?: string | null;
    /** @format int32 */
    licenceUserCount?: number | null;
    isEnabledCommentOnOkResponse?: boolean | null;
    isRequiredTwoFactor?: boolean | null;
    imageUploadUseCompression?: boolean | null;
    /** @format double */
    imageUploadMaxFileSize?: number | null;
    /** @format int32 */
    imageUploadMaxResolution?: number | null;
    /** @format double */
    imageUploadQuality?: number | null;
    isQuickLoginEnabled?: boolean;
    /** @format int32 */
    quickLoginTimeout?: number | null;
    /** @format int32 */
    quickLoginPersonalNumberPositionCount?: number;
    /** @format date-span */
    dayStart?: string | null;
    name?: string | null;
    domainName?: string | null;
    currency?: string | null;
    timeZone?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface TenantModelApiResultSuccess {
    returnValue?: TenantModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TenantModelIEnumerableApiResultSuccess {
    returnValue?: TenantModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TenantUserBaseModel {
    tenant?: TenantBaseModel;
    /** @format uuid */
    userId?: string;
    user?: UserModel;
    /** @format uuid */
    positionId?: string | null;
    position?: PositionModel;
    /** @format uuid */
    departmentId?: string | null;
    department?: DepartmentBasicModel;
    isActive?: boolean;
    externalSystemId?: string | null;
    /** @format uuid */
    iCalIdentifier?: string | null;
    accessAllCategories?: boolean | null;
    employeeId?: string | null;
    hasQuickLogin?: boolean;
    locations?: TenantUserLocationModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface TenantUserLocationModel {
    /** @format uuid */
    tenantUserId?: string;
    /** @format uuid */
    locationId?: string;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface TenantUserModel {
    userRoles?: UserRoleModel[] | null;
    categories?: CategoryUserModel[] | null;
    pwRequest?: string | null;
    language?: string | null;
    isExternal?: boolean;
    tenant?: TenantBaseModel;
    /** @format uuid */
    userId?: string;
    user?: UserModel;
    /** @format uuid */
    positionId?: string | null;
    position?: PositionModel;
    /** @format uuid */
    departmentId?: string | null;
    department?: DepartmentBasicModel;
    isActive?: boolean;
    externalSystemId?: string | null;
    /** @format uuid */
    iCalIdentifier?: string | null;
    accessAllCategories?: boolean | null;
    employeeId?: string | null;
    hasQuickLogin?: boolean;
    locations?: TenantUserLocationModel[] | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface TenantUserModelApiResultSuccess {
    returnValue?: TenantUserModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TenantUserModelIEnumerableApiResultSuccess {
    returnValue?: TenantUserModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TokenErrorResponse {
    error?: string | null;
    errorDescription?: string | null;
    custom?: Record<string, any>;
}

export interface TokenErrorResponseApiResultFailed {
    returnValue?: TokenErrorResponse;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface TokenResponse {
    identityToken?: string | null;
    accessToken?: string | null;
    /** @format int32 */
    accessTokenLifetime?: number;
    refreshToken?: string | null;
    scope?: string | null;
    custom?: Record<string, any>;
}

export interface TokenResponseApiResultSuccess {
    returnValue?: TokenResponse;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface UnitOfMeasureModel {
    code?: string | null;
    name?: string | null;
    shortCode?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface UnitOfMeasureModelApiResultSuccess {
    returnValue?: UnitOfMeasureModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface UnitOfMeasureModelIEnumerableApiResultSuccess {
    returnValue?: UnitOfMeasureModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface UserBaseModel {
    userName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    language?: string | null;
    displayName?: string | null;
    /** @format uuid */
    avatar?: string | null;
    notifyWeeklyAudits?: boolean | null;
    notifyIdleMeasures?: boolean;
    notifyCorrectionManagerUpdate?: boolean | null;
    notifyCorrectionImplementerUpdate?: boolean | null;
    email?: string | null;
    /** @format date-time */
    registrationDate?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface UserModel {
    language?: string | null;
    phoneNumber?: string | null;
    userName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    displayName?: string | null;
    /** @format uuid */
    avatar?: string | null;
    notifyWeeklyAudits?: boolean | null;
    notifyIdleMeasures?: boolean;
    notifyCorrectionManagerUpdate?: boolean | null;
    notifyCorrectionImplementerUpdate?: boolean | null;
    email?: string | null;
    /** @format date-time */
    registrationDate?: string | null;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface UserRoleModel {
    /** @format uuid */
    tenantUserId?: string;
    /** @format uuid */
    roleId?: string;
    role?: RoleModel;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface UserRoleModelApiResultSuccess {
    returnValue?: UserRoleModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface UserRoleModelIEnumerableApiResultSuccess {
    returnValue?: UserRoleModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface ValidateQuickLoginModel {
    employeeId?: string | null;
    pin?: string | null;
}

export interface WorkplaceModel {
    code?: string | null;
    name?: string | null;
    skipShiftImport?: boolean;
    /** @format uuid */
    locationId?: string | null;
    location?: LocationBasicModel;
    /** @format double */
    hourlyMaintenanceCosts?: number | null;
    /** @format double */
    hourlyDowntimeCosts?: number | null;
    /** @format double */
    hourlyDowntimeLostProfit?: number | null;
    hourlyPlanType?: HourlyPlanTypeEnum;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface WorkplaceModelApiResultSuccess {
    returnValue?: WorkplaceModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface WorkplaceModelIEnumerableApiResultSuccess {
    returnValue?: WorkplaceModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface WorkplaceShutdownModel {
    /** @format uuid */
    workplaceId?: string;
    workplace?: WorkplaceModel;
    /** @format date-time */
    fromDate?: string;
    /** @format date-time */
    toDate?: string;
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string | null;
    /** @format uuid */
    createdById?: string;
    /** @format uuid */
    tenantId?: string;
    isDeleted?: boolean;
}

export interface WorkplaceShutdownModelApiResultSuccess {
    returnValue?: WorkplaceShutdownModel;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export interface WorkplaceShutdownModelIEnumerableApiResultSuccess {
    returnValue?: WorkplaceShutdownModel[] | null;
    version?: string | null;
    operationResult?: OpResultStatus;
    httpStatusCode?: HttpStatusCode;
    innerResult?: ApiResultBase;
    error?: ApiResultException;
    message?: string | null;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseFormat;
    /** request body */
    body?: unknown;
    /** base url */
    baseUrl?: string;
    /** request cancellation token */
    cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
    baseUrl?: string;
    baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
    securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
    customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
    data: D;
    error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
}

export class HttpClient<SecurityDataType = unknown> {
    public baseUrl: string = '';
    private securityData: SecurityDataType | null = null;
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
    private abortControllers = new Map<CancelToken, AbortController>();
    private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

    private baseApiParams: RequestParams = {
        credentials: 'same-origin',
        headers: {},
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
    };

    constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
        Object.assign(this, apiConfig);
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data;
    };

    protected encodeQueryParam(key: string, value: any) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
    }

    protected addQueryParam(query: QueryParamsType, key: string) {
        return this.encodeQueryParam(key, query[key]);
    }

    protected addArrayQueryParam(query: QueryParamsType, key: string) {
        const value = query[key];
        return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
    }

    protected toQueryString(rawQuery?: QueryParamsType): string {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
        return keys
            .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
            .join('&');
    }

    protected addQueryParams(rawQuery?: QueryParamsType): string {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : '';
    }

    private contentFormatters: Record<ContentType, (input: any) => any> = {
        [ContentType.Json]: (input: any) =>
            input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
        [ContentType.FormData]: (input: any) =>
            Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key];
                formData.append(
                    key,
                    property instanceof Blob
                        ? property
                        : typeof property === 'object' && property !== null
                        ? JSON.stringify(property)
                        : `${property}`
                );
                return formData;
            }, new FormData()),
        [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
    };

    protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }

    protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                return abortController.signal;
            }
            return void 0;
        }

        const abortController = new AbortController();
        this.abortControllers.set(cancelToken, abortController);
        return abortController.signal;
    };

    public abortRequest = (cancelToken: CancelToken) => {
        const abortController = this.abortControllers.get(cancelToken);

        if (abortController) {
            abortController.abort();
            this.abortControllers.delete(cancelToken);
        }
    };

    public request = async <T = any, E = any>({
        body,
        secure,
        path,
        type,
        query,
        format,
        baseUrl,
        cancelToken,
        ...params
    }: FullRequestParams): Promise<HttpResponse<T, E>> => {
        const secureParams =
            ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const queryString = query && this.toQueryString(query);
        const payloadFormatter = this.contentFormatters[type || ContentType.Json];
        const responseFormat = format || requestParams.format;

        return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
            },
            signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
            body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
        }).then(async (response) => {
            const r = response as HttpResponse<T, E>;
            r.data = null as unknown as T;
            r.error = null as unknown as E;

            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                      .then((data) => {
                          if (r.ok) {
                              r.data = data;
                          } else {
                              r.error = data;
                          }
                          return r;
                      })
                      .catch((e) => {
                          r.error = e;
                          return r;
                      });

            if (cancelToken) {
                this.abortControllers.delete(cancelToken);
            }

            if (!response.ok) throw data;
            return data;
        });
    };
}

/**
 * @title AMS API
 * @version 1.0
 * @license MIT (https://opensource.org/licenses/MIT)
 * @contact Support <info@nordelo.cz>
 *
 * A REST API service with Swagger, Swashbuckle, and API versioning.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
    api = {
        /**
         * No description
         *
         * @tags AdminActions
         * @name RunNotificationAlerts
         * @request GET:/api/admin/actions/run-notification-alerts
         * @secure
         */
        runNotificationAlerts: (params: RequestParams = {}) =>
            this.request<ApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/actions/run-notification-alerts`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminActions
         * @name RunUpcomingAlerts
         * @request GET:/api/admin/actions/run-upcoming-alerts
         * @secure
         */
        runUpcomingAlerts: (params: RequestParams = {}) =>
            this.request<ApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/actions/run-upcoming-alerts`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminSystemUsers
         * @name AdminDeleteSystemUsers
         * @request DELETE:/api/admin/system-users
         * @secure
         */
        adminDeleteSystemUsers: (data: QueryModel, params: RequestParams = {}) =>
            this.request<SystemUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/system-users`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminSystemUsers
         * @name AdminInsertSystemUser
         * @request POST:/api/admin/system-users
         * @secure
         */
        adminInsertSystemUser: (data: SystemUserModel, params: RequestParams = {}) =>
            this.request<SystemUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/system-users`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminSystemUsers
         * @name AdminGetSystemUserById
         * @request GET:/api/admin/system-users/{id}
         * @secure
         */
        adminGetSystemUserById: (id: string, params: RequestParams = {}) =>
            this.request<SystemUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/system-users/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminSystemUsers
         * @name AdminPatchSystemUser
         * @request PATCH:/api/admin/system-users/{id}
         * @secure
         */
        adminPatchSystemUser: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<SystemUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/system-users/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminSystemUsers
         * @name AdminUpdateSystemUser
         * @request PUT:/api/admin/system-users/{id}
         * @secure
         */
        adminUpdateSystemUser: (id: string, data: SystemUserModel, params: RequestParams = {}) =>
            this.request<SystemUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/system-users/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminSystemUsers
         * @name AdminAggregationSystemUser
         * @request POST:/api/admin/system-users/aggregation
         * @secure
         */
        adminAggregationSystemUser: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/system-users/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminSystemUsers
         * @name AdminGetSystemUserGroupped
         * @request POST:/api/admin/system-users/groupped
         * @secure
         */
        adminGetSystemUserGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/system-users/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminSystemUsers
         * @name AdminGetSystemUserBatch
         * @request POST:/api/admin/system-users/{pageIndex},{pageSize}
         * @secure
         */
        adminGetSystemUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<SystemUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/system-users/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminTenants
         * @name AdminGetTenantById
         * @request GET:/api/admin/tenants/{id}
         * @secure
         */
        adminGetTenantById: (id: string, params: RequestParams = {}) =>
            this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/tenants/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminTenants
         * @name AdminPatchTenant
         * @request PATCH:/api/admin/tenants/{id}
         * @secure
         */
        adminPatchTenant: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<void, ApiResultFailed | void>({
                path: `/api/admin/tenants/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminTenants
         * @name AdminUpdateTenant
         * @request PUT:/api/admin/tenants/{id}
         * @secure
         */
        adminUpdateTenant: (id: string, data: TenantModel, params: RequestParams = {}) =>
            this.request<void, ApiResultFailed | void>({
                path: `/api/admin/tenants/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminTenants
         * @name AdminInsertTenant
         * @request POST:/api/admin/tenants
         * @secure
         */
        adminInsertTenant: (data: TenantModel, params: RequestParams = {}) =>
            this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/tenants`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminTenants
         * @name AdminGetTenantBatch
         * @request POST:/api/admin/tenants/{pageIndex},{pageSize}
         * @secure
         */
        adminGetTenantBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/tenants/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminTenantUsers
         * @name AdminDeleteTenantUsers
         * @request DELETE:/api/admin/tenant-users
         * @secure
         */
        adminDeleteTenantUsers: (data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/tenant-users`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminTenantUsers
         * @name AdminInsertTenantUser
         * @request POST:/api/admin/tenant-users
         * @secure
         */
        adminInsertTenantUser: (data: TenantUserModel, params: RequestParams = {}) =>
            this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/tenant-users`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminTenantUsers
         * @name AdminGetTenantUserById
         * @request GET:/api/admin/tenant-users/{id}
         * @secure
         */
        adminGetTenantUserById: (id: string, params: RequestParams = {}) =>
            this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/tenant-users/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminTenantUsers
         * @name AdminUpdateTenantUser
         * @request PUT:/api/admin/tenant-users/{id}
         * @secure
         */
        adminUpdateTenantUser: (id: string, data: TenantUserModel, params: RequestParams = {}) =>
            this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/tenant-users/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminTenantUsers
         * @name AdminAggregationTenantUser
         * @request POST:/api/admin/tenant-users/aggregation
         * @secure
         */
        adminAggregationTenantUser: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/tenant-users/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminTenantUsers
         * @name AdminGetTenantUserBatch
         * @request POST:/api/admin/tenant-users/{pageIndex},{pageSize}
         * @secure
         */
        adminGetTenantUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/tenant-users/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminUsers
         * @name GetAdminUserById
         * @request GET:/api/admin/users/{id}
         * @secure
         */
        getAdminUserById: (id: string, params: RequestParams = {}) =>
            this.request<AdminUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/users/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdminUsers
         * @name GetAdminUserBatch
         * @request POST:/api/admin/users/{pageIndex},{pageSize}
         * @secure
         */
        getAdminUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<AdminUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/admin/users/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AiServiceQueueItems
         * @name GetAiServiceQueueItemById
         * @request GET:/api/ai-service-queue-items/{id}
         * @secure
         */
        getAiServiceQueueItemById: (id: string, params: RequestParams = {}) =>
            this.request<AiServiceQueueItemModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/ai-service-queue-items/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AiServiceQueueItems
         * @name GetAiServiceQueueItemBatch
         * @request POST:/api/ai-service-queue-items/{pageIndex},{pageSize}
         * @secure
         */
        getAiServiceQueueItemBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<AiServiceQueueItemModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/ai-service-queue-items/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditEscalationGroups
         * @name DeleteAuditEscalationGroups
         * @request DELETE:/api/audit-escalation-groups
         * @secure
         */
        deleteAuditEscalationGroups: (data: QueryModel, params: RequestParams = {}) =>
            this.request<AuditEscalationGroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-escalation-groups`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditEscalationGroups
         * @name InsertAuditEscalationGroup
         * @request POST:/api/audit-escalation-groups
         * @secure
         */
        insertAuditEscalationGroup: (data: AuditEscalationGroupModel, params: RequestParams = {}) =>
            this.request<AuditEscalationGroupModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-escalation-groups`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditEscalationGroups
         * @name GetAuditEscalationGroupById
         * @request GET:/api/audit-escalation-groups/{id}
         * @secure
         */
        getAuditEscalationGroupById: (id: string, params: RequestParams = {}) =>
            this.request<AuditEscalationGroupModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-escalation-groups/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditEscalationGroups
         * @name PatchAuditEscalationGroup
         * @request PATCH:/api/audit-escalation-groups/{id}
         * @secure
         */
        patchAuditEscalationGroup: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<AuditEscalationGroupModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-escalation-groups/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditEscalationGroups
         * @name UpdateAuditEscalationGroup
         * @request PUT:/api/audit-escalation-groups/{id}
         * @secure
         */
        updateAuditEscalationGroup: (id: string, data: AuditEscalationGroupModel, params: RequestParams = {}) =>
            this.request<AuditEscalationGroupModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-escalation-groups/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditEscalationGroups
         * @name AggregationAuditEscalationGroup
         * @request POST:/api/audit-escalation-groups/aggregation
         * @secure
         */
        aggregationAuditEscalationGroup: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-escalation-groups/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditEscalationGroups
         * @name GetAuditEscalationGroupGroupped
         * @request POST:/api/audit-escalation-groups/groupped
         * @secure
         */
        getAuditEscalationGroupGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-escalation-groups/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditEscalationGroups
         * @name GetAuditEscalationGroupBatch
         * @request POST:/api/audit-escalation-groups/{pageIndex},{pageSize}
         * @secure
         */
        getAuditEscalationGroupBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<AuditEscalationGroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-escalation-groups/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditFaultTypes
         * @name DeleteAuditFaultTypes
         * @request DELETE:/api/audit-fault-types
         * @secure
         */
        deleteAuditFaultTypes: (data: QueryModel, params: RequestParams = {}) =>
            this.request<AuditFaultTypeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-fault-types`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditFaultTypes
         * @name InsertAuditFaultType
         * @request POST:/api/audit-fault-types
         * @secure
         */
        insertAuditFaultType: (data: AuditFaultTypeModel, params: RequestParams = {}) =>
            this.request<AuditFaultTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-fault-types`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditFaultTypes
         * @name GetAuditFaultTypeById
         * @request GET:/api/audit-fault-types/{id}
         * @secure
         */
        getAuditFaultTypeById: (id: string, params: RequestParams = {}) =>
            this.request<AuditFaultTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-fault-types/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditFaultTypes
         * @name PatchAuditFaultType
         * @request PATCH:/api/audit-fault-types/{id}
         * @secure
         */
        patchAuditFaultType: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<AuditFaultTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-fault-types/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditFaultTypes
         * @name UpdateAuditFaultType
         * @request PUT:/api/audit-fault-types/{id}
         * @secure
         */
        updateAuditFaultType: (id: string, data: AuditFaultTypeModel, params: RequestParams = {}) =>
            this.request<AuditFaultTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-fault-types/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditFaultTypes
         * @name AggregationAuditFaultType
         * @request POST:/api/audit-fault-types/aggregation
         * @secure
         */
        aggregationAuditFaultType: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-fault-types/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditFaultTypes
         * @name GetAuditFaultTypeGroupped
         * @request POST:/api/audit-fault-types/groupped
         * @secure
         */
        getAuditFaultTypeGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-fault-types/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditFaultTypes
         * @name GetAuditFaultTypeBatch
         * @request POST:/api/audit-fault-types/{pageIndex},{pageSize}
         * @secure
         */
        getAuditFaultTypeBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<AuditFaultTypeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-fault-types/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Audits
         * @name DeleteAudits
         * @request DELETE:/api/audits
         * @secure
         */
        deleteAudits: (data: QueryModel, params: RequestParams = {}) =>
            this.request<AuditModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audits`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Audits
         * @name InsertAudit
         * @request POST:/api/audits
         * @secure
         */
        insertAudit: (data: AuditModel, params: RequestParams = {}) =>
            this.request<AuditModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audits`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Audits
         * @name GetAuditById
         * @request GET:/api/audits/{id}
         * @secure
         */
        getAuditById: (id: string, params: RequestParams = {}) =>
            this.request<AuditModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audits/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Audits
         * @name PatchAudit
         * @request PATCH:/api/audits/{id}
         * @secure
         */
        patchAudit: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<AuditModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audits/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Audits
         * @name UpdateAudit
         * @request PUT:/api/audits/{id}
         * @secure
         */
        updateAudit: (id: string, data: AuditModel, params: RequestParams = {}) =>
            this.request<AuditModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audits/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Audits
         * @name PrintAuditById
         * @request GET:/api/audits/{id}/print
         * @secure
         */
        printAuditById: (id: string, params: RequestParams = {}) =>
            this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audits/${id}/print`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Audits
         * @name AggregationAudit
         * @request POST:/api/audits/aggregation
         * @secure
         */
        aggregationAudit: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audits/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Audits
         * @name CloneAudit
         * @request POST:/api/audits/clone
         * @secure
         */
        cloneAudit: (data: AuditModel, params: RequestParams = {}) =>
            this.request<AuditModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audits/clone`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Audits
         * @name ExportAuditBatch
         * @request POST:/api/audits/{pageIndex},{pageSize}/export
         * @secure
         */
        exportAuditBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audits/${pageIndex},${pageSize}/export`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Audits
         * @name GetAuditGroupped
         * @request POST:/api/audits/groupped
         * @secure
         */
        getAuditGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audits/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Audits
         * @name GetAuditBasicBatch
         * @request POST:/api/audits/{pageIndex},{pageSize}/basic
         * @secure
         */
        getAuditBasicBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<AuditBasicModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audits/${pageIndex},${pageSize}/basic`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Audits
         * @name GetAuditBatch
         * @request POST:/api/audits/{pageIndex},{pageSize}
         * @secure
         */
        getAuditBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<AuditModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audits/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditShiftTypes
         * @name DeleteAuditShiftTypes
         * @request DELETE:/api/audit-shift-types
         * @secure
         */
        deleteAuditShiftTypes: (data: QueryModel, params: RequestParams = {}) =>
            this.request<AuditShiftTypeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-shift-types`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditShiftTypes
         * @name InsertAuditShiftType
         * @request POST:/api/audit-shift-types
         * @secure
         */
        insertAuditShiftType: (data: AuditShiftTypeModel, params: RequestParams = {}) =>
            this.request<AuditShiftTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-shift-types`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditShiftTypes
         * @name GetAuditShiftTypeById
         * @request GET:/api/audit-shift-types/{id}
         * @secure
         */
        getAuditShiftTypeById: (id: string, params: RequestParams = {}) =>
            this.request<AuditShiftTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-shift-types/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditShiftTypes
         * @name PatchAuditShiftType
         * @request PATCH:/api/audit-shift-types/{id}
         * @secure
         */
        patchAuditShiftType: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<AuditShiftTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-shift-types/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditShiftTypes
         * @name UpdateAuditShiftType
         * @request PUT:/api/audit-shift-types/{id}
         * @secure
         */
        updateAuditShiftType: (id: string, data: AuditShiftTypeModel, params: RequestParams = {}) =>
            this.request<AuditShiftTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-shift-types/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditShiftTypes
         * @name AggregationAuditShiftType
         * @request POST:/api/audit-shift-types/aggregation
         * @secure
         */
        aggregationAuditShiftType: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-shift-types/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditShiftTypes
         * @name GetAuditShiftTypeGroupped
         * @request POST:/api/audit-shift-types/groupped
         * @secure
         */
        getAuditShiftTypeGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-shift-types/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditShiftTypes
         * @name GetAuditShiftTypeBatch
         * @request POST:/api/audit-shift-types/{pageIndex},{pageSize}
         * @secure
         */
        getAuditShiftTypeBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<AuditShiftTypeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-shift-types/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditTimings
         * @name DeleteAuditTimings
         * @request DELETE:/api/audit-timings
         * @secure
         */
        deleteAuditTimings: (data: QueryModel, params: RequestParams = {}) =>
            this.request<AuditTimingModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-timings`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditTimings
         * @name InsertAuditTiming
         * @request POST:/api/audit-timings
         * @secure
         */
        insertAuditTiming: (data: AuditTimingModel, params: RequestParams = {}) =>
            this.request<AuditTimingModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-timings`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditTimings
         * @name GetAuditTimingById
         * @request GET:/api/audit-timings/{id}
         * @secure
         */
        getAuditTimingById: (id: string, params: RequestParams = {}) =>
            this.request<AuditTimingModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-timings/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditTimings
         * @name PatchAuditTiming
         * @request PATCH:/api/audit-timings/{id}
         * @secure
         */
        patchAuditTiming: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<AuditTimingModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-timings/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditTimings
         * @name UpdateAuditTiming
         * @request PUT:/api/audit-timings/{id}
         * @secure
         */
        updateAuditTiming: (id: string, data: AuditTimingModel, params: RequestParams = {}) =>
            this.request<AuditTimingModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-timings/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditTimings
         * @name AggregationAuditTiming
         * @request POST:/api/audit-timings/aggregation
         * @secure
         */
        aggregationAuditTiming: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-timings/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditTimings
         * @name GetAuditTimingGroupped
         * @request POST:/api/audit-timings/groupped
         * @secure
         */
        getAuditTimingGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-timings/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditTimings
         * @name GetAuditTimingBatch
         * @request POST:/api/audit-timings/{pageIndex},{pageSize}
         * @secure
         */
        getAuditTimingBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<AuditTimingModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-timings/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditWorkplaces
         * @name DeleteAuditWorkplaces
         * @request DELETE:/api/audit-workplaces
         * @secure
         */
        deleteAuditWorkplaces: (data: QueryModel, params: RequestParams = {}) =>
            this.request<AuditWorkplaceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-workplaces`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditWorkplaces
         * @name InsertAuditWorkplace
         * @request POST:/api/audit-workplaces
         * @secure
         */
        insertAuditWorkplace: (data: AuditWorkplaceModel, params: RequestParams = {}) =>
            this.request<AuditWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-workplaces`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditWorkplaces
         * @name GetAuditWorkplaceById
         * @request GET:/api/audit-workplaces/{id}
         * @secure
         */
        getAuditWorkplaceById: (id: string, params: RequestParams = {}) =>
            this.request<AuditWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-workplaces/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditWorkplaces
         * @name PatchAuditWorkplace
         * @request PATCH:/api/audit-workplaces/{id}
         * @secure
         */
        patchAuditWorkplace: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<AuditWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-workplaces/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditWorkplaces
         * @name UpdateAuditWorkplace
         * @request PUT:/api/audit-workplaces/{id}
         * @secure
         */
        updateAuditWorkplace: (id: string, data: AuditWorkplaceModel, params: RequestParams = {}) =>
            this.request<AuditWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-workplaces/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditWorkplaces
         * @name AggregationAuditWorkplace
         * @request POST:/api/audit-workplaces/aggregation
         * @secure
         */
        aggregationAuditWorkplace: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-workplaces/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditWorkplaces
         * @name GetAuditWorkplaceGroupped
         * @request POST:/api/audit-workplaces/groupped
         * @secure
         */
        getAuditWorkplaceGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-workplaces/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AuditWorkplaces
         * @name GetAuditWorkplaceBatch
         * @request POST:/api/audit-workplaces/{pageIndex},{pageSize}
         * @secure
         */
        getAuditWorkplaceBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<AuditWorkplaceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/audit-workplaces/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AzureActiveDirectory
         * @name AadConnect
         * @request POST:/api/azure-active-directory/connect
         */
        aadConnect: (data: AadConnectRequestModel, params: RequestParams = {}) =>
            this.request<AadConnectResponseModel, any>({
                path: `/api/azure-active-directory/connect`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags BillOfMaterialItems
         * @name DeleteBillOfMaterialItems
         * @request DELETE:/api/bill-of-material-items
         * @secure
         */
        deleteBillOfMaterialItems: (data: QueryModel, params: RequestParams = {}) =>
            this.request<BillOfMaterialItemModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/bill-of-material-items`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags BillOfMaterialItems
         * @name InsertBillOfMaterialItem
         * @request POST:/api/bill-of-material-items
         * @secure
         */
        insertBillOfMaterialItem: (data: BillOfMaterialItemModel, params: RequestParams = {}) =>
            this.request<BillOfMaterialItemModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/bill-of-material-items`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags BillOfMaterialItems
         * @name GetBillOfMaterialItemById
         * @request GET:/api/bill-of-material-items/{id}
         * @secure
         */
        getBillOfMaterialItemById: (id: string, params: RequestParams = {}) =>
            this.request<BillOfMaterialItemModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/bill-of-material-items/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags BillOfMaterialItems
         * @name PatchBillOfMaterialItem
         * @request PATCH:/api/bill-of-material-items/{id}
         * @secure
         */
        patchBillOfMaterialItem: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<BillOfMaterialItemModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/bill-of-material-items/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags BillOfMaterialItems
         * @name UpdateBillOfMaterialItem
         * @request PUT:/api/bill-of-material-items/{id}
         * @secure
         */
        updateBillOfMaterialItem: (id: string, data: BillOfMaterialItemModel, params: RequestParams = {}) =>
            this.request<BillOfMaterialItemModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/bill-of-material-items/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags BillOfMaterialItems
         * @name AggregationBillOfMaterialItem
         * @request POST:/api/bill-of-material-items/aggregation
         * @secure
         */
        aggregationBillOfMaterialItem: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/bill-of-material-items/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags BillOfMaterialItems
         * @name GetBillOfMaterialItemGroupped
         * @request POST:/api/bill-of-material-items/groupped
         * @secure
         */
        getBillOfMaterialItemGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/bill-of-material-items/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags BillOfMaterialItems
         * @name GetBillOfMaterialItemBatch
         * @request POST:/api/bill-of-material-items/{pageIndex},{pageSize}
         * @secure
         */
        getBillOfMaterialItemBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<BillOfMaterialItemModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/bill-of-material-items/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Categories
         * @name DeleteCategories
         * @request DELETE:/api/categories
         * @secure
         */
        deleteCategories: (data: QueryModel, params: RequestParams = {}) =>
            this.request<CategoryModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/categories`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Categories
         * @name InsertCategory
         * @request POST:/api/categories
         * @secure
         */
        insertCategory: (data: CategoryModel, params: RequestParams = {}) =>
            this.request<CategoryModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/categories`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Categories
         * @name GetCategoryById
         * @request GET:/api/categories/{id}
         * @secure
         */
        getCategoryById: (id: string, params: RequestParams = {}) =>
            this.request<CategoryModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/categories/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Categories
         * @name PatchCategory
         * @request PATCH:/api/categories/{id}
         * @secure
         */
        patchCategory: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<CategoryModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/categories/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Categories
         * @name UpdateCategory
         * @request PUT:/api/categories/{id}
         * @secure
         */
        updateCategory: (id: string, data: CategoryModel, params: RequestParams = {}) =>
            this.request<CategoryModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/categories/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Categories
         * @name AggregationCategory
         * @request POST:/api/categories/aggregation
         * @secure
         */
        aggregationCategory: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/categories/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Categories
         * @name GetCategoryGroupped
         * @request POST:/api/categories/groupped
         * @secure
         */
        getCategoryGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/categories/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Categories
         * @name GetCategoryBatch
         * @request POST:/api/categories/{pageIndex},{pageSize}
         * @secure
         */
        getCategoryBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<CategoryModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/categories/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CategoryUsers
         * @name DeleteCategoryUsers
         * @request DELETE:/api/category-users
         * @secure
         */
        deleteCategoryUsers: (data: QueryModel, params: RequestParams = {}) =>
            this.request<CategoryUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/category-users`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CategoryUsers
         * @name InsertCategoryUser
         * @request POST:/api/category-users
         * @secure
         */
        insertCategoryUser: (data: CategoryUserModel, params: RequestParams = {}) =>
            this.request<CategoryUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/category-users`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CategoryUsers
         * @name GetCategoryUserById
         * @request GET:/api/category-users/{id}
         * @secure
         */
        getCategoryUserById: (id: string, params: RequestParams = {}) =>
            this.request<CategoryUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/category-users/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CategoryUsers
         * @name PatchCategoryUser
         * @request PATCH:/api/category-users/{id}
         * @secure
         */
        patchCategoryUser: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<CategoryUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/category-users/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CategoryUsers
         * @name UpdateCategoryUser
         * @request PUT:/api/category-users/{id}
         * @secure
         */
        updateCategoryUser: (id: string, data: CategoryUserModel, params: RequestParams = {}) =>
            this.request<CategoryUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/category-users/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CategoryUsers
         * @name AggregationCategoryUser
         * @request POST:/api/category-users/aggregation
         * @secure
         */
        aggregationCategoryUser: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/category-users/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CategoryUsers
         * @name GetCategoryUserGroupped
         * @request POST:/api/category-users/groupped
         * @secure
         */
        getCategoryUserGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/category-users/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CategoryUsers
         * @name GetCategoryUserBatch
         * @request POST:/api/category-users/{pageIndex},{pageSize}
         * @secure
         */
        getCategoryUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<CategoryUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/category-users/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Codebooks
         * @name DeleteCodebooks
         * @request DELETE:/api/codebooks
         * @secure
         */
        deleteCodebooks: (data: QueryModel, params: RequestParams = {}) =>
            this.request<CodebookModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/codebooks`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Codebooks
         * @name InsertCodebook
         * @request POST:/api/codebooks
         * @secure
         */
        insertCodebook: (data: CodebookModel, params: RequestParams = {}) =>
            this.request<CodebookModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/codebooks`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Codebooks
         * @name GetCodebookById
         * @request GET:/api/codebooks/{id}
         * @secure
         */
        getCodebookById: (id: string, params: RequestParams = {}) =>
            this.request<CodebookModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/codebooks/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Codebooks
         * @name PatchCodebook
         * @request PATCH:/api/codebooks/{id}
         * @secure
         */
        patchCodebook: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<CodebookModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/codebooks/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Codebooks
         * @name UpdateCodebook
         * @request PUT:/api/codebooks/{id}
         * @secure
         */
        updateCodebook: (id: string, data: CodebookModel, params: RequestParams = {}) =>
            this.request<CodebookModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/codebooks/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Codebooks
         * @name AggregationCodebook
         * @request POST:/api/codebooks/aggregation
         * @secure
         */
        aggregationCodebook: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/codebooks/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Codebooks
         * @name GetCodebookGroupped
         * @request POST:/api/codebooks/groupped
         * @secure
         */
        getCodebookGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/codebooks/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Codebooks
         * @name GetCodebookBatch
         * @request POST:/api/codebooks/{pageIndex},{pageSize}
         * @secure
         */
        getCodebookBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<CodebookModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/codebooks/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CorrectionManagers
         * @name DeleteCorrectionManagers
         * @request DELETE:/api/correction-managers
         * @secure
         */
        deleteCorrectionManagers: (data: QueryModel, params: RequestParams = {}) =>
            this.request<CorrectionManagerModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/correction-managers`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CorrectionManagers
         * @name InsertCorrectionManager
         * @request POST:/api/correction-managers
         * @secure
         */
        insertCorrectionManager: (data: CorrectionManagerModel, params: RequestParams = {}) =>
            this.request<CorrectionManagerModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/correction-managers`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CorrectionManagers
         * @name GetCorrectionManagerById
         * @request GET:/api/correction-managers/{id}
         * @secure
         */
        getCorrectionManagerById: (id: string, params: RequestParams = {}) =>
            this.request<CorrectionManagerModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/correction-managers/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CorrectionManagers
         * @name PatchCorrectionManager
         * @request PATCH:/api/correction-managers/{id}
         * @secure
         */
        patchCorrectionManager: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<CorrectionManagerModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/correction-managers/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CorrectionManagers
         * @name UpdateCorrectionManager
         * @request PUT:/api/correction-managers/{id}
         * @secure
         */
        updateCorrectionManager: (id: string, data: CorrectionManagerModel, params: RequestParams = {}) =>
            this.request<CorrectionManagerModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/correction-managers/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CorrectionManagers
         * @name AggregationCorrectionManager
         * @request POST:/api/correction-managers/aggregation
         * @secure
         */
        aggregationCorrectionManager: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/correction-managers/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CorrectionManagers
         * @name GetCorrectionManagerGroupped
         * @request POST:/api/correction-managers/groupped
         * @secure
         */
        getCorrectionManagerGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/correction-managers/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CorrectionManagers
         * @name GetCorrectionManagerBatch
         * @request POST:/api/correction-managers/{pageIndex},{pageSize}
         * @secure
         */
        getCorrectionManagerBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<CorrectionManagerModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/correction-managers/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Customers
         * @name DeleteCustomers
         * @request DELETE:/api/customers
         * @secure
         */
        deleteCustomers: (data: QueryModel, params: RequestParams = {}) =>
            this.request<CustomerModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/customers`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Customers
         * @name InsertCustomer
         * @request POST:/api/customers
         * @secure
         */
        insertCustomer: (data: CustomerModel, params: RequestParams = {}) =>
            this.request<CustomerModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/customers`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Customers
         * @name GetCustomerById
         * @request GET:/api/customers/{id}
         * @secure
         */
        getCustomerById: (id: string, params: RequestParams = {}) =>
            this.request<CustomerModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/customers/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Customers
         * @name PatchCustomer
         * @request PATCH:/api/customers/{id}
         * @secure
         */
        patchCustomer: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<CustomerModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/customers/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Customers
         * @name UpdateCustomer
         * @request PUT:/api/customers/{id}
         * @secure
         */
        updateCustomer: (id: string, data: CustomerModel, params: RequestParams = {}) =>
            this.request<CustomerModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/customers/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Customers
         * @name AggregationCustomer
         * @request POST:/api/customers/aggregation
         * @secure
         */
        aggregationCustomer: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/customers/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Customers
         * @name GetCustomerGroupped
         * @request POST:/api/customers/groupped
         * @secure
         */
        getCustomerGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/customers/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Customers
         * @name GetCustomerBatch
         * @request POST:/api/customers/{pageIndex},{pageSize}
         * @secure
         */
        getCustomerBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<CustomerModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/customers/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CycleTimes
         * @name DeleteCycleTimes
         * @request DELETE:/api/cycle-times
         * @secure
         */
        deleteCycleTimes: (data: QueryModel, params: RequestParams = {}) =>
            this.request<CycleTimeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/cycle-times`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CycleTimes
         * @name InsertCycleTime
         * @request POST:/api/cycle-times
         * @secure
         */
        insertCycleTime: (data: CycleTimeModel, params: RequestParams = {}) =>
            this.request<CycleTimeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/cycle-times`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CycleTimes
         * @name GetCycleTimeById
         * @request GET:/api/cycle-times/{id}
         * @secure
         */
        getCycleTimeById: (id: string, params: RequestParams = {}) =>
            this.request<CycleTimeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/cycle-times/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CycleTimes
         * @name PatchCycleTime
         * @request PATCH:/api/cycle-times/{id}
         * @secure
         */
        patchCycleTime: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<CycleTimeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/cycle-times/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CycleTimes
         * @name UpdateCycleTime
         * @request PUT:/api/cycle-times/{id}
         * @secure
         */
        updateCycleTime: (id: string, data: CycleTimeModel, params: RequestParams = {}) =>
            this.request<CycleTimeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/cycle-times/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CycleTimes
         * @name AggregationCycleTime
         * @request POST:/api/cycle-times/aggregation
         * @secure
         */
        aggregationCycleTime: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/cycle-times/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CycleTimes
         * @name GetCycleTimeGroupped
         * @request POST:/api/cycle-times/groupped
         * @secure
         */
        getCycleTimeGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/cycle-times/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags CycleTimes
         * @name GetCycleTimeBatch
         * @request POST:/api/cycle-times/{pageIndex},{pageSize}
         * @secure
         */
        getCycleTimeBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<CycleTimeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/cycle-times/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Defects
         * @name DeleteDefects
         * @request DELETE:/api/defects
         * @secure
         */
        deleteDefects: (data: QueryModel, params: RequestParams = {}) =>
            this.request<DefectModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defects`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Defects
         * @name InsertDefect
         * @request POST:/api/defects
         * @secure
         */
        insertDefect: (data: DefectModel, params: RequestParams = {}) =>
            this.request<DefectModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defects`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Defects
         * @name GetDefectById
         * @request GET:/api/defects/{id}
         * @secure
         */
        getDefectById: (id: string, params: RequestParams = {}) =>
            this.request<DefectModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defects/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Defects
         * @name PatchDefect
         * @request PATCH:/api/defects/{id}
         * @secure
         */
        patchDefect: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<DefectModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defects/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Defects
         * @name UpdateDefect
         * @request PUT:/api/defects/{id}
         * @secure
         */
        updateDefect: (id: string, data: DefectModel, params: RequestParams = {}) =>
            this.request<DefectModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defects/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Defects
         * @name AggregationDefect
         * @request POST:/api/defects/aggregation
         * @secure
         */
        aggregationDefect: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defects/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Defects
         * @name GetDefectGroupped
         * @request POST:/api/defects/groupped
         * @secure
         */
        getDefectGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defects/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Defects
         * @name GetDefectBatch
         * @request POST:/api/defects/{pageIndex},{pageSize}
         * @secure
         */
        getDefectBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<DefectModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defects/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectStations
         * @name DeleteDefectStations
         * @request DELETE:/api/defect-stations
         * @secure
         */
        deleteDefectStations: (data: QueryModel, params: RequestParams = {}) =>
            this.request<DefectStationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-stations`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectStations
         * @name InsertDefectStation
         * @request POST:/api/defect-stations
         * @secure
         */
        insertDefectStation: (data: DefectStationModel, params: RequestParams = {}) =>
            this.request<DefectStationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-stations`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectStations
         * @name GetDefectStationById
         * @request GET:/api/defect-stations/{id}
         * @secure
         */
        getDefectStationById: (id: string, params: RequestParams = {}) =>
            this.request<DefectStationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-stations/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectStations
         * @name PatchDefectStation
         * @request PATCH:/api/defect-stations/{id}
         * @secure
         */
        patchDefectStation: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<DefectStationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-stations/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectStations
         * @name UpdateDefectStation
         * @request PUT:/api/defect-stations/{id}
         * @secure
         */
        updateDefectStation: (id: string, data: DefectStationModel, params: RequestParams = {}) =>
            this.request<DefectStationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-stations/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectStations
         * @name AggregationDefectStation
         * @request POST:/api/defect-stations/aggregation
         * @secure
         */
        aggregationDefectStation: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-stations/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectStations
         * @name GetDefectStationGroupped
         * @request POST:/api/defect-stations/groupped
         * @secure
         */
        getDefectStationGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-stations/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectStations
         * @name GetDefectStationBatch
         * @request POST:/api/defect-stations/{pageIndex},{pageSize}
         * @secure
         */
        getDefectStationBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<DefectStationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-stations/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectWorkplaces
         * @name DeleteDefectWorkplaces
         * @request DELETE:/api/defect-workplaces
         * @secure
         */
        deleteDefectWorkplaces: (data: QueryModel, params: RequestParams = {}) =>
            this.request<DefectWorkplaceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-workplaces`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectWorkplaces
         * @name InsertDefectWorkplace
         * @request POST:/api/defect-workplaces
         * @secure
         */
        insertDefectWorkplace: (data: DefectWorkplaceModel, params: RequestParams = {}) =>
            this.request<DefectWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-workplaces`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectWorkplaces
         * @name GetDefectWorkplaceById
         * @request GET:/api/defect-workplaces/{id}
         * @secure
         */
        getDefectWorkplaceById: (id: string, params: RequestParams = {}) =>
            this.request<DefectWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-workplaces/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectWorkplaces
         * @name PatchDefectWorkplace
         * @request PATCH:/api/defect-workplaces/{id}
         * @secure
         */
        patchDefectWorkplace: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<DefectWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-workplaces/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectWorkplaces
         * @name UpdateDefectWorkplace
         * @request PUT:/api/defect-workplaces/{id}
         * @secure
         */
        updateDefectWorkplace: (id: string, data: DefectWorkplaceModel, params: RequestParams = {}) =>
            this.request<DefectWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-workplaces/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectWorkplaces
         * @name AggregationDefectWorkplace
         * @request POST:/api/defect-workplaces/aggregation
         * @secure
         */
        aggregationDefectWorkplace: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-workplaces/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectWorkplaces
         * @name GetDefectWorkplaceGroupped
         * @request POST:/api/defect-workplaces/groupped
         * @secure
         */
        getDefectWorkplaceGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-workplaces/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefectWorkplaces
         * @name GetDefectWorkplaceBatch
         * @request POST:/api/defect-workplaces/{pageIndex},{pageSize}
         * @secure
         */
        getDefectWorkplaceBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<DefectWorkplaceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/defect-workplaces/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Departments
         * @name DeleteDepartments
         * @request DELETE:/api/departments
         * @secure
         */
        deleteDepartments: (data: QueryModel, params: RequestParams = {}) =>
            this.request<DepartmentModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/departments`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Departments
         * @name InsertDepartment
         * @request POST:/api/departments
         * @secure
         */
        insertDepartment: (data: DepartmentModel, params: RequestParams = {}) =>
            this.request<DepartmentModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/departments`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Departments
         * @name GetDepartmentById
         * @request GET:/api/departments/{id}
         * @secure
         */
        getDepartmentById: (id: string, params: RequestParams = {}) =>
            this.request<DepartmentModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/departments/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Departments
         * @name PatchDepartment
         * @request PATCH:/api/departments/{id}
         * @secure
         */
        patchDepartment: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<DepartmentModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/departments/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Departments
         * @name UpdateDepartment
         * @request PUT:/api/departments/{id}
         * @secure
         */
        updateDepartment: (id: string, data: DepartmentModel, params: RequestParams = {}) =>
            this.request<DepartmentModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/departments/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Departments
         * @name AggregationDepartment
         * @request POST:/api/departments/aggregation
         * @secure
         */
        aggregationDepartment: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/departments/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Departments
         * @name GetDepartmentGroupped
         * @request POST:/api/departments/groupped
         * @secure
         */
        getDepartmentGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/departments/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Departments
         * @name GetDepartmentBatch
         * @request POST:/api/departments/{pageIndex},{pageSize}
         * @secure
         */
        getDepartmentBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<DepartmentModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/departments/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Files
         * @name DownloadFileById
         * @request GET:/api/files/{id}/download
         * @secure
         */
        downloadFileById: (id: string, params: RequestParams = {}) =>
            this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/files/${id}/download`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Files
         * @name DownloadFileThumbnailById
         * @request GET:/api/files/{id}/download-thumbnail
         * @secure
         */
        downloadFileThumbnailById: (id: string, params: RequestParams = {}) =>
            this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/files/${id}/download-thumbnail`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Files
         * @name GetFileById
         * @request GET:/api/files/{id}
         * @secure
         */
        getFileById: (id: string, params: RequestParams = {}) =>
            this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/files/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Filters
         * @name DeleteFilters
         * @request DELETE:/api/filters
         * @secure
         */
        deleteFilters: (data: QueryModel, params: RequestParams = {}) =>
            this.request<FilterModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/filters`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Filters
         * @name InsertFilter
         * @request POST:/api/filters
         * @secure
         */
        insertFilter: (data: FilterModel, params: RequestParams = {}) =>
            this.request<FilterModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/filters`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Filters
         * @name GetFilterById
         * @request GET:/api/filters/{id}
         * @secure
         */
        getFilterById: (id: string, params: RequestParams = {}) =>
            this.request<FilterModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/filters/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Filters
         * @name PatchFilter
         * @request PATCH:/api/filters/{id}
         * @secure
         */
        patchFilter: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<FilterModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/filters/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Filters
         * @name UpdateFilter
         * @request PUT:/api/filters/{id}
         * @secure
         */
        updateFilter: (id: string, data: FilterModel, params: RequestParams = {}) =>
            this.request<FilterModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/filters/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Filters
         * @name AggregationFilter
         * @request POST:/api/filters/aggregation
         * @secure
         */
        aggregationFilter: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/filters/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Filters
         * @name GetFilterGroupped
         * @request POST:/api/filters/groupped
         * @secure
         */
        getFilterGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/filters/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Filters
         * @name GetFilterBatch
         * @request POST:/api/filters/{pageIndex},{pageSize}
         * @secure
         */
        getFilterBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<FilterModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/filters/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Findings
         * @name DeleteFindings
         * @request DELETE:/api/findings
         * @secure
         */
        deleteFindings: (data: QueryModel, params: RequestParams = {}) =>
            this.request<FindingModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/findings`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Findings
         * @name InsertFinding
         * @request POST:/api/findings
         * @secure
         */
        insertFinding: (data: FindingModel, params: RequestParams = {}) =>
            this.request<FindingModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/findings`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Findings
         * @name GetFindingById
         * @request GET:/api/findings/{id}
         * @secure
         */
        getFindingById: (id: string, params: RequestParams = {}) =>
            this.request<FindingModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/findings/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Findings
         * @name PatchFinding
         * @request PATCH:/api/findings/{id}
         * @secure
         */
        patchFinding: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<FindingModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/findings/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Findings
         * @name UpdateFinding
         * @request PUT:/api/findings/{id}
         * @secure
         */
        updateFinding: (id: string, data: FindingModel, params: RequestParams = {}) =>
            this.request<FindingModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/findings/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Findings
         * @name AggregationFinding
         * @request POST:/api/findings/aggregation
         * @secure
         */
        aggregationFinding: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/findings/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Findings
         * @name GetFindingGroupped
         * @request POST:/api/findings/groupped
         * @secure
         */
        getFindingGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/findings/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Findings
         * @name ExportFindingBatch
         * @request POST:/api/findings/{pageIndex},{pageSize}/export
         * @secure
         */
        exportFindingBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/findings/${pageIndex},${pageSize}/export`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Findings
         * @name GetFindingBasicBatch
         * @request POST:/api/findings/{pageIndex},{pageSize}/basic
         * @secure
         */
        getFindingBasicBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<FindingBasicModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/findings/${pageIndex},${pageSize}/basic`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Findings
         * @name GetFindingBatch
         * @request POST:/api/findings/{pageIndex},{pageSize}
         * @secure
         */
        getFindingBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<FindingModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/findings/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Groups
         * @name DeleteGroups
         * @request DELETE:/api/groups
         * @secure
         */
        deleteGroups: (data: QueryModel, params: RequestParams = {}) =>
            this.request<GroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/groups`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Groups
         * @name InsertGroup
         * @request POST:/api/groups
         * @secure
         */
        insertGroup: (data: GroupModel, params: RequestParams = {}) =>
            this.request<GroupModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/groups`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Groups
         * @name GetGroupById
         * @request GET:/api/groups/{id}
         * @secure
         */
        getGroupById: (id: string, params: RequestParams = {}) =>
            this.request<GroupModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/groups/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Groups
         * @name PatchGroup
         * @request PATCH:/api/groups/{id}
         * @secure
         */
        patchGroup: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<GroupModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/groups/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Groups
         * @name UpdateGroup
         * @request PUT:/api/groups/{id}
         * @secure
         */
        updateGroup: (id: string, data: GroupModel, params: RequestParams = {}) =>
            this.request<GroupModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/groups/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Groups
         * @name AggregationGroup
         * @request POST:/api/groups/aggregation
         * @secure
         */
        aggregationGroup: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/groups/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Groups
         * @name GetGroupGroupped
         * @request POST:/api/groups/groupped
         * @secure
         */
        getGroupGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/groups/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Groups
         * @name GetGroupBatch
         * @request POST:/api/groups/{pageIndex},{pageSize}
         * @secure
         */
        getGroupBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<GroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/groups/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags GroupUsers
         * @name DeleteGroupUsers
         * @request DELETE:/api/group-users
         * @secure
         */
        deleteGroupUsers: (data: QueryModel, params: RequestParams = {}) =>
            this.request<GroupUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/group-users`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags GroupUsers
         * @name InsertGroupUser
         * @request POST:/api/group-users
         * @secure
         */
        insertGroupUser: (data: GroupUserModel, params: RequestParams = {}) =>
            this.request<GroupUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/group-users`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags GroupUsers
         * @name GetGroupUserById
         * @request GET:/api/group-users/{id}
         * @secure
         */
        getGroupUserById: (id: string, params: RequestParams = {}) =>
            this.request<GroupUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/group-users/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags GroupUsers
         * @name PatchGroupUser
         * @request PATCH:/api/group-users/{id}
         * @secure
         */
        patchGroupUser: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<GroupUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/group-users/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags GroupUsers
         * @name UpdateGroupUser
         * @request PUT:/api/group-users/{id}
         * @secure
         */
        updateGroupUser: (id: string, data: GroupUserModel, params: RequestParams = {}) =>
            this.request<GroupUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/group-users/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags GroupUsers
         * @name AggregationGroupUser
         * @request POST:/api/group-users/aggregation
         * @secure
         */
        aggregationGroupUser: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/group-users/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags GroupUsers
         * @name GetGroupUserGroupped
         * @request POST:/api/group-users/groupped
         * @secure
         */
        getGroupUserGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/group-users/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags GroupUsers
         * @name GetGroupUserBatch
         * @request POST:/api/group-users/{pageIndex},{pageSize}
         * @secure
         */
        getGroupUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<GroupUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/group-users/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags iCal
         * @name GetCalendar
         * @request GET:/api/ical/{id}
         */
        getCalendar: (id: string, params: RequestParams = {}) =>
            this.request<ObjectApiResultSuccess, ApiResultFailed | void>({
                path: `/api/ical/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Imports
         * @name DeleteImports
         * @request DELETE:/api/imports
         * @secure
         */
        deleteImports: (data: QueryModel, params: RequestParams = {}) =>
            this.request<ImportModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/imports`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Imports
         * @name InsertImport
         * @request POST:/api/imports
         * @secure
         */
        insertImport: (data: ImportModel, params: RequestParams = {}) =>
            this.request<ImportModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/imports`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Imports
         * @name GetImportById
         * @request GET:/api/imports/{id}
         * @secure
         */
        getImportById: (id: string, params: RequestParams = {}) =>
            this.request<ImportModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/imports/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Imports
         * @name PatchImport
         * @request PATCH:/api/imports/{id}
         * @secure
         */
        patchImport: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<ImportModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/imports/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Imports
         * @name UpdateImport
         * @request PUT:/api/imports/{id}
         * @secure
         */
        updateImport: (id: string, data: ImportModel, params: RequestParams = {}) =>
            this.request<ImportModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/imports/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Imports
         * @name AggregationImport
         * @request POST:/api/imports/aggregation
         * @secure
         */
        aggregationImport: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/imports/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Imports
         * @name GetImportGroupped
         * @request POST:/api/imports/groupped
         * @secure
         */
        getImportGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/imports/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Imports
         * @name GetImportBatch
         * @request POST:/api/imports/{pageIndex},{pageSize}
         * @secure
         */
        getImportBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ImportModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/imports/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Ip
         * @name GetMyIp
         * @request GET:/api/ip/get-my-ip
         */
        getMyIp: (params: RequestParams = {}) =>
            this.request<IpResponse, ApiResultFailed | void>({
                path: `/api/ip/get-my-ip`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Issues
         * @name ExportIssueBatch
         * @request POST:/api/issues/{pageIndex},{pageSize}/export
         * @secure
         */
        exportIssueBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/issues/${pageIndex},${pageSize}/export`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LinearAlerts
         * @name DeleteLinearAlerts
         * @request DELETE:/api/linear-alerts
         * @secure
         */
        deleteLinearAlerts: (data: QueryModel, params: RequestParams = {}) =>
            this.request<LinearAlertModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/linear-alerts`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LinearAlerts
         * @name InsertLinearAlert
         * @request POST:/api/linear-alerts
         * @secure
         */
        insertLinearAlert: (data: LinearAlertModel, params: RequestParams = {}) =>
            this.request<LinearAlertModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/linear-alerts`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LinearAlerts
         * @name GetLinearAlertById
         * @request GET:/api/linear-alerts/{id}
         * @secure
         */
        getLinearAlertById: (id: string, params: RequestParams = {}) =>
            this.request<LinearAlertModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/linear-alerts/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LinearAlerts
         * @name PatchLinearAlert
         * @request PATCH:/api/linear-alerts/{id}
         * @secure
         */
        patchLinearAlert: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<LinearAlertModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/linear-alerts/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LinearAlerts
         * @name UpdateLinearAlert
         * @request PUT:/api/linear-alerts/{id}
         * @secure
         */
        updateLinearAlert: (id: string, data: LinearAlertModel, params: RequestParams = {}) =>
            this.request<LinearAlertModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/linear-alerts/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LinearAlerts
         * @name AggregationLinearAlert
         * @request POST:/api/linear-alerts/aggregation
         * @secure
         */
        aggregationLinearAlert: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/linear-alerts/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LinearAlerts
         * @name GetLinearAlertGroupped
         * @request POST:/api/linear-alerts/groupped
         * @secure
         */
        getLinearAlertGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/linear-alerts/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LinearAlerts
         * @name GetLinearAlertBatch
         * @request POST:/api/linear-alerts/{pageIndex},{pageSize}
         * @secure
         */
        getLinearAlertBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<LinearAlertModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/linear-alerts/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LocationParents
         * @name DeleteLocationParents
         * @request DELETE:/api/location-parents
         * @secure
         */
        deleteLocationParents: (data: QueryModel, params: RequestParams = {}) =>
            this.request<LocationParentModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/location-parents`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LocationParents
         * @name InsertLocationParent
         * @request POST:/api/location-parents
         * @secure
         */
        insertLocationParent: (data: LocationParentModel, params: RequestParams = {}) =>
            this.request<LocationParentModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/location-parents`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LocationParents
         * @name GetLocationParentById
         * @request GET:/api/location-parents/{id}
         * @secure
         */
        getLocationParentById: (id: string, params: RequestParams = {}) =>
            this.request<LocationParentModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/location-parents/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LocationParents
         * @name PatchLocationParent
         * @request PATCH:/api/location-parents/{id}
         * @secure
         */
        patchLocationParent: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<LocationParentModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/location-parents/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LocationParents
         * @name UpdateLocationParent
         * @request PUT:/api/location-parents/{id}
         * @secure
         */
        updateLocationParent: (id: string, data: LocationParentModel, params: RequestParams = {}) =>
            this.request<LocationParentModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/location-parents/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LocationParents
         * @name AggregationLocationParent
         * @request POST:/api/location-parents/aggregation
         * @secure
         */
        aggregationLocationParent: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/location-parents/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LocationParents
         * @name GetLocationParentGroupped
         * @request POST:/api/location-parents/groupped
         * @secure
         */
        getLocationParentGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/location-parents/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LocationParents
         * @name GetLocationParentBatch
         * @request POST:/api/location-parents/{pageIndex},{pageSize}
         * @secure
         */
        getLocationParentBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<LocationParentModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/location-parents/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Locations
         * @name DeleteLocations
         * @request DELETE:/api/locations
         * @secure
         */
        deleteLocations: (data: QueryModel, params: RequestParams = {}) =>
            this.request<LocationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/locations`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Locations
         * @name InsertLocation
         * @request POST:/api/locations
         * @secure
         */
        insertLocation: (data: LocationModel, params: RequestParams = {}) =>
            this.request<LocationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/locations`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Locations
         * @name GetLocationById
         * @request GET:/api/locations/{id}
         * @secure
         */
        getLocationById: (id: string, params: RequestParams = {}) =>
            this.request<LocationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/locations/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Locations
         * @name PatchLocation
         * @request PATCH:/api/locations/{id}
         * @secure
         */
        patchLocation: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<LocationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/locations/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Locations
         * @name UpdateLocation
         * @request PUT:/api/locations/{id}
         * @secure
         */
        updateLocation: (id: string, data: LocationModel, params: RequestParams = {}) =>
            this.request<LocationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/locations/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Locations
         * @name AggregationLocation
         * @request POST:/api/locations/aggregation
         * @secure
         */
        aggregationLocation: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/locations/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Locations
         * @name GetLocationGroupped
         * @request POST:/api/locations/groupped
         * @secure
         */
        getLocationGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/locations/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Locations
         * @name GetLocationBatch
         * @request POST:/api/locations/{pageIndex},{pageSize}
         * @secure
         */
        getLocationBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<LocationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/locations/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponents
         * @name DeleteMachineComponents
         * @request DELETE:/api/machine-components
         * @secure
         */
        deleteMachineComponents: (data: QueryModel, params: RequestParams = {}) =>
            this.request<MachineComponentModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponents
         * @name InsertMachineComponent
         * @request POST:/api/machine-components
         * @secure
         */
        insertMachineComponent: (data: MachineComponentModel, params: RequestParams = {}) =>
            this.request<MachineComponentModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponents
         * @name GetMachineComponentById
         * @request GET:/api/machine-components/{id}
         * @secure
         */
        getMachineComponentById: (id: string, params: RequestParams = {}) =>
            this.request<MachineComponentModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponents
         * @name PatchMachineComponent
         * @request PATCH:/api/machine-components/{id}
         * @secure
         */
        patchMachineComponent: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<MachineComponentModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponents
         * @name UpdateMachineComponent
         * @request PUT:/api/machine-components/{id}
         * @secure
         */
        updateMachineComponent: (id: string, data: MachineComponentModel, params: RequestParams = {}) =>
            this.request<MachineComponentModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponents
         * @name AggregationMachineComponent
         * @request POST:/api/machine-components/aggregation
         * @secure
         */
        aggregationMachineComponent: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponents
         * @name GetMachineComponentGroupped
         * @request POST:/api/machine-components/groupped
         * @secure
         */
        getMachineComponentGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponents
         * @name GetMachineComponentBatch
         * @request POST:/api/machine-components/{pageIndex},{pageSize}
         * @secure
         */
        getMachineComponentBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<MachineComponentModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentStations
         * @name DeleteMachineComponentStations
         * @request DELETE:/api/machine-components-stations
         * @secure
         */
        deleteMachineComponentStations: (data: QueryModel, params: RequestParams = {}) =>
            this.request<MachineComponentStationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-stations`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentStations
         * @name InsertMachineComponentStation
         * @request POST:/api/machine-components-stations
         * @secure
         */
        insertMachineComponentStation: (data: MachineComponentStationModel, params: RequestParams = {}) =>
            this.request<MachineComponentStationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-stations`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentStations
         * @name GetMachineComponentStationById
         * @request GET:/api/machine-components-stations/{id}
         * @secure
         */
        getMachineComponentStationById: (id: string, params: RequestParams = {}) =>
            this.request<MachineComponentStationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-stations/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentStations
         * @name PatchMachineComponentStation
         * @request PATCH:/api/machine-components-stations/{id}
         * @secure
         */
        patchMachineComponentStation: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<MachineComponentStationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-stations/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentStations
         * @name UpdateMachineComponentStation
         * @request PUT:/api/machine-components-stations/{id}
         * @secure
         */
        updateMachineComponentStation: (id: string, data: MachineComponentStationModel, params: RequestParams = {}) =>
            this.request<MachineComponentStationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-stations/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentStations
         * @name AggregationMachineComponentStation
         * @request POST:/api/machine-components-stations/aggregation
         * @secure
         */
        aggregationMachineComponentStation: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-stations/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentStations
         * @name GetMachineComponentStationGroupped
         * @request POST:/api/machine-components-stations/groupped
         * @secure
         */
        getMachineComponentStationGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-stations/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentStations
         * @name GetMachineComponentStationBatch
         * @request POST:/api/machine-components-stations/{pageIndex},{pageSize}
         * @secure
         */
        getMachineComponentStationBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<MachineComponentStationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-stations/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentWorkplaces
         * @name DeleteMachineComponentWorkplaces
         * @request DELETE:/api/machine-components-workplaces
         * @secure
         */
        deleteMachineComponentWorkplaces: (data: QueryModel, params: RequestParams = {}) =>
            this.request<MachineComponentWorkplaceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-workplaces`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentWorkplaces
         * @name InsertMachineComponentWorkplace
         * @request POST:/api/machine-components-workplaces
         * @secure
         */
        insertMachineComponentWorkplace: (data: MachineComponentWorkplaceModel, params: RequestParams = {}) =>
            this.request<MachineComponentWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-workplaces`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentWorkplaces
         * @name GetMachineComponentWorkplaceById
         * @request GET:/api/machine-components-workplaces/{id}
         * @secure
         */
        getMachineComponentWorkplaceById: (id: string, params: RequestParams = {}) =>
            this.request<MachineComponentWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-workplaces/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentWorkplaces
         * @name PatchMachineComponentWorkplace
         * @request PATCH:/api/machine-components-workplaces/{id}
         * @secure
         */
        patchMachineComponentWorkplace: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<MachineComponentWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-workplaces/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentWorkplaces
         * @name UpdateMachineComponentWorkplace
         * @request PUT:/api/machine-components-workplaces/{id}
         * @secure
         */
        updateMachineComponentWorkplace: (id: string, data: MachineComponentWorkplaceModel, params: RequestParams = {}) =>
            this.request<MachineComponentWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-workplaces/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentWorkplaces
         * @name AggregationMachineComponentWorkplace
         * @request POST:/api/machine-components-workplaces/aggregation
         * @secure
         */
        aggregationMachineComponentWorkplace: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-workplaces/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentWorkplaces
         * @name GetMachineComponentWorkplaceGroupped
         * @request POST:/api/machine-components-workplaces/groupped
         * @secure
         */
        getMachineComponentWorkplaceGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-workplaces/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags MachineComponentWorkplaces
         * @name GetMachineComponentWorkplaceBatch
         * @request POST:/api/machine-components-workplaces/{pageIndex},{pageSize}
         * @secure
         */
        getMachineComponentWorkplaceBatch: (
            pageIndex: number,
            pageSize: number,
            data: QueryModel,
            params: RequestParams = {}
        ) =>
            this.request<MachineComponentWorkplaceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/machine-components-workplaces/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Materials
         * @name DeleteMaterials
         * @request DELETE:/api/materials
         * @secure
         */
        deleteMaterials: (data: QueryModel, params: RequestParams = {}) =>
            this.request<MaterialModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/materials`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Materials
         * @name InsertMaterial
         * @request POST:/api/materials
         * @secure
         */
        insertMaterial: (data: MaterialModel, params: RequestParams = {}) =>
            this.request<MaterialModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/materials`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Materials
         * @name GetMaterialById
         * @request GET:/api/materials/{id}
         * @secure
         */
        getMaterialById: (id: string, params: RequestParams = {}) =>
            this.request<MaterialModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/materials/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Materials
         * @name PatchMaterial
         * @request PATCH:/api/materials/{id}
         * @secure
         */
        patchMaterial: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<MaterialModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/materials/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Materials
         * @name UpdateMaterial
         * @request PUT:/api/materials/{id}
         * @secure
         */
        updateMaterial: (id: string, data: MaterialModel, params: RequestParams = {}) =>
            this.request<MaterialModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/materials/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Materials
         * @name AggregationMaterial
         * @request POST:/api/materials/aggregation
         * @secure
         */
        aggregationMaterial: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/materials/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Materials
         * @name GetMaterialGroupped
         * @request POST:/api/materials/groupped
         * @secure
         */
        getMaterialGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/materials/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Materials
         * @name GetMaterialBatch
         * @request POST:/api/materials/{pageIndex},{pageSize}
         * @secure
         */
        getMaterialBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<MaterialModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/materials/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Me
         * @name UpdateAvatar
         * @request PUT:/api/me/avatar
         * @secure
         */
        updateAvatar: (data: AvatarUploadModel, params: RequestParams = {}) =>
            this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/me/avatar`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Me
         * @name GetApplicationUser
         * @request GET:/api/me
         * @secure
         */
        getApplicationUser: (params: RequestParams = {}) =>
            this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/me`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Me
         * @name UpdateApplicationUser
         * @request PUT:/api/me
         * @secure
         */
        updateApplicationUser: (data: ApplicationUserModel, params: RequestParams = {}) =>
            this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/me`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Me
         * @name GenerateTwoFactorKey
         * @request PUT:/api/me/generate-two-factor-key
         * @secure
         */
        generateTwoFactorKey: (params: RequestParams = {}) =>
            this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/me/generate-two-factor-key`,
                method: 'PUT',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Me
         * @name EnableTwoFactor
         * @request PUT:/api/me/enable-two-factor
         * @secure
         */
        enableTwoFactor: (params: RequestParams = {}) =>
            this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/me/enable-two-factor`,
                method: 'PUT',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Me
         * @name DisableTwoFactor
         * @request PUT:/api/me/disable-two-factor
         * @secure
         */
        disableTwoFactor: (params: RequestParams = {}) =>
            this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/me/disable-two-factor`,
                method: 'PUT',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Me
         * @name GetUserInfo
         * @request GET:/api/me/userinfo
         * @secure
         */
        getUserInfo: (params: RequestParams = {}) =>
            this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/me/userinfo`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Measures
         * @name DeleteMeasures
         * @request DELETE:/api/measures
         * @secure
         */
        deleteMeasures: (data: QueryModel, params: RequestParams = {}) =>
            this.request<MeasureModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/measures`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Measures
         * @name InsertMeasure
         * @request POST:/api/measures
         * @secure
         */
        insertMeasure: (data: MeasureModel, params: RequestParams = {}) =>
            this.request<MeasureModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/measures`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Measures
         * @name GetMeasureById
         * @request GET:/api/measures/{id}
         * @secure
         */
        getMeasureById: (id: string, params: RequestParams = {}) =>
            this.request<MeasureModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/measures/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Measures
         * @name PatchMeasure
         * @request PATCH:/api/measures/{id}
         * @secure
         */
        patchMeasure: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<MeasureModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/measures/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Measures
         * @name UpdateMeasure
         * @request PUT:/api/measures/{id}
         * @secure
         */
        updateMeasure: (id: string, data: MeasureModel, params: RequestParams = {}) =>
            this.request<MeasureModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/measures/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Measures
         * @name AggregationMeasure
         * @request POST:/api/measures/aggregation
         * @secure
         */
        aggregationMeasure: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/measures/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Measures
         * @name ExportMeasureBatch
         * @request POST:/api/measures/{pageIndex},{pageSize}/export
         * @secure
         */
        exportMeasureBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/measures/${pageIndex},${pageSize}/export`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Measures
         * @name GetMeasureGroupped
         * @request POST:/api/measures/groupped
         * @secure
         */
        getMeasureGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/measures/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Measures
         * @name GetMeasureBatch
         * @request POST:/api/measures/{pageIndex},{pageSize}
         * @secure
         */
        getMeasureBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<MeasureModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/measures/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications
         * @name DeleteNotifications
         * @request DELETE:/api/notifications
         * @secure
         */
        deleteNotifications: (data: QueryModel, params: RequestParams = {}) =>
            this.request<NotificationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/notifications`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications
         * @name GetNotificationById
         * @request GET:/api/notifications/{id}
         * @secure
         */
        getNotificationById: (id: string, params: RequestParams = {}) =>
            this.request<NotificationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/notifications/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications
         * @name PatchNotification
         * @request PATCH:/api/notifications/{id}
         * @secure
         */
        patchNotification: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<NotificationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/notifications/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications
         * @name UpdateNotification
         * @request PUT:/api/notifications/{id}
         * @secure
         */
        updateNotification: (id: string, data: NotificationModel, params: RequestParams = {}) =>
            this.request<NotificationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/notifications/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications
         * @name AggregationNotification
         * @request POST:/api/notifications/aggregation
         * @secure
         */
        aggregationNotification: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/notifications/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications
         * @name GetNotificationGroupped
         * @request POST:/api/notifications/groupped
         * @secure
         */
        getNotificationGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/notifications/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications
         * @name GetNotificationBatch
         * @request POST:/api/notifications/{pageIndex},{pageSize}
         * @secure
         */
        getNotificationBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<NotificationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/notifications/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags NotRatedOptionReasons
         * @name DeleteNotRatedOptionReasons
         * @request DELETE:/api/not-rated-option-reasons
         * @secure
         */
        deleteNotRatedOptionReasons: (data: QueryModel, params: RequestParams = {}) =>
            this.request<NotRatedOptionReasonModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/not-rated-option-reasons`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags NotRatedOptionReasons
         * @name InsertNotRatedOptionReason
         * @request POST:/api/not-rated-option-reasons
         * @secure
         */
        insertNotRatedOptionReason: (data: NotRatedOptionReasonModel, params: RequestParams = {}) =>
            this.request<NotRatedOptionReasonModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/not-rated-option-reasons`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags NotRatedOptionReasons
         * @name GetNotRatedOptionReasonById
         * @request GET:/api/not-rated-option-reasons/{id}
         * @secure
         */
        getNotRatedOptionReasonById: (id: string, params: RequestParams = {}) =>
            this.request<NotRatedOptionReasonModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/not-rated-option-reasons/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags NotRatedOptionReasons
         * @name PatchNotRatedOptionReason
         * @request PATCH:/api/not-rated-option-reasons/{id}
         * @secure
         */
        patchNotRatedOptionReason: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<NotRatedOptionReasonModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/not-rated-option-reasons/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags NotRatedOptionReasons
         * @name UpdateNotRatedOptionReason
         * @request PUT:/api/not-rated-option-reasons/{id}
         * @secure
         */
        updateNotRatedOptionReason: (id: string, data: NotRatedOptionReasonModel, params: RequestParams = {}) =>
            this.request<NotRatedOptionReasonModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/not-rated-option-reasons/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags NotRatedOptionReasons
         * @name AggregationNotRatedOptionReason
         * @request POST:/api/not-rated-option-reasons/aggregation
         * @secure
         */
        aggregationNotRatedOptionReason: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/not-rated-option-reasons/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags NotRatedOptionReasons
         * @name GetNotRatedOptionReasonGroupped
         * @request POST:/api/not-rated-option-reasons/groupped
         * @secure
         */
        getNotRatedOptionReasonGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/not-rated-option-reasons/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags NotRatedOptionReasons
         * @name GetNotRatedOptionReasonBatch
         * @request POST:/api/not-rated-option-reasons/{pageIndex},{pageSize}
         * @secure
         */
        getNotRatedOptionReasonBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<NotRatedOptionReasonModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/not-rated-option-reasons/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags OpenAI
         * @name GenerateQuestions
         * @request POST:/api/open-ai/generate-questions/{auditId}
         * @secure
         */
        generateQuestions: (auditId: string, data: AiSuggestQuestionsRequest, params: RequestParams = {}) =>
            this.request<AiSuggestQuestionsResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/open-ai/generate-questions/${auditId}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags OpenAI
         * @name ImproveQuestions
         * @request POST:/api/open-ai/improve-questions/{auditId}
         * @secure
         */
        improveQuestions: (auditId: string, data: AiSuggestQuestionsRequest, params: RequestParams = {}) =>
            this.request<AiSuggestQuestionsResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/open-ai/improve-questions/${auditId}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PanelDashboards
         * @name DeletePanelDashboards
         * @request DELETE:/api/panel-dashboards
         * @secure
         */
        deletePanelDashboards: (data: QueryModel, params: RequestParams = {}) =>
            this.request<PanelDashboardModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/panel-dashboards`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PanelDashboards
         * @name InsertPanelDashboard
         * @request POST:/api/panel-dashboards
         * @secure
         */
        insertPanelDashboard: (data: PanelDashboardModel, params: RequestParams = {}) =>
            this.request<PanelDashboardModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/panel-dashboards`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PanelDashboards
         * @name GetPanelDashboardById
         * @request GET:/api/panel-dashboards/{id}
         * @secure
         */
        getPanelDashboardById: (id: string, params: RequestParams = {}) =>
            this.request<PanelDashboardModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/panel-dashboards/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PanelDashboards
         * @name PatchPanelDashboard
         * @request PATCH:/api/panel-dashboards/{id}
         * @secure
         */
        patchPanelDashboard: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<PanelDashboardModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/panel-dashboards/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PanelDashboards
         * @name UpdatePanelDashboard
         * @request PUT:/api/panel-dashboards/{id}
         * @secure
         */
        updatePanelDashboard: (id: string, data: PanelDashboardModel, params: RequestParams = {}) =>
            this.request<PanelDashboardModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/panel-dashboards/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PanelDashboards
         * @name AggregationPanelDashboard
         * @request POST:/api/panel-dashboards/aggregation
         * @secure
         */
        aggregationPanelDashboard: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/panel-dashboards/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PanelDashboards
         * @name GetPanelDashboardGroupped
         * @request POST:/api/panel-dashboards/groupped
         * @secure
         */
        getPanelDashboardGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/panel-dashboards/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PanelDashboards
         * @name GetPanelDashboardBatch
         * @request POST:/api/panel-dashboards/{pageIndex},{pageSize}
         * @secure
         */
        getPanelDashboardBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<PanelDashboardModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/panel-dashboards/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Permissions
         * @name DeletePermissions
         * @request DELETE:/api/permissions
         * @secure
         */
        deletePermissions: (data: QueryModel, params: RequestParams = {}) =>
            this.request<PermissionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/permissions`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Permissions
         * @name InsertPermission
         * @request POST:/api/permissions
         * @secure
         */
        insertPermission: (data: PermissionModel, params: RequestParams = {}) =>
            this.request<PermissionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/permissions`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Permissions
         * @name GetPermissionById
         * @request GET:/api/permissions/{id}
         * @secure
         */
        getPermissionById: (id: string, params: RequestParams = {}) =>
            this.request<PermissionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/permissions/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Permissions
         * @name PatchPermission
         * @request PATCH:/api/permissions/{id}
         * @secure
         */
        patchPermission: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<PermissionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/permissions/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Permissions
         * @name UpdatePermission
         * @request PUT:/api/permissions/{id}
         * @secure
         */
        updatePermission: (id: string, data: PermissionModel, params: RequestParams = {}) =>
            this.request<PermissionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/permissions/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Permissions
         * @name AggregationPermission
         * @request POST:/api/permissions/aggregation
         * @secure
         */
        aggregationPermission: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/permissions/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Permissions
         * @name GetPermissionGroupped
         * @request POST:/api/permissions/groupped
         * @secure
         */
        getPermissionGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/permissions/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Permissions
         * @name GetPermissionBatch
         * @request POST:/api/permissions/{pageIndex},{pageSize}
         * @secure
         */
        getPermissionBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<PermissionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/permissions/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PlanItems
         * @name DeletePlanItems
         * @request DELETE:/api/plan-items
         * @secure
         */
        deletePlanItems: (data: QueryModel, params: RequestParams = {}) =>
            this.request<PlanItemModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/plan-items`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PlanItems
         * @name InsertPlanItem
         * @request POST:/api/plan-items
         * @secure
         */
        insertPlanItem: (data: PlanItemModel, params: RequestParams = {}) =>
            this.request<PlanItemModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/plan-items`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PlanItems
         * @name GetPlanItemById
         * @request GET:/api/plan-items/{id}
         * @secure
         */
        getPlanItemById: (id: string, params: RequestParams = {}) =>
            this.request<PlanItemModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/plan-items/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PlanItems
         * @name PatchPlanItem
         * @request PATCH:/api/plan-items/{id}
         * @secure
         */
        patchPlanItem: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<PlanItemModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/plan-items/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PlanItems
         * @name UpdatePlanItem
         * @request PUT:/api/plan-items/{id}
         * @secure
         */
        updatePlanItem: (id: string, data: PlanItemModel, params: RequestParams = {}) =>
            this.request<PlanItemModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/plan-items/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PlanItems
         * @name AggregationPlanItem
         * @request POST:/api/plan-items/aggregation
         * @secure
         */
        aggregationPlanItem: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/plan-items/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PlanItems
         * @name ExportPlanItemBatch
         * @request POST:/api/plan-items/{pageIndex},{pageSize}/export
         * @secure
         */
        exportPlanItemBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/plan-items/${pageIndex},${pageSize}/export`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PlanItems
         * @name GetPlanItemGroupped
         * @request POST:/api/plan-items/groupped
         * @secure
         */
        getPlanItemGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/plan-items/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PlanItems
         * @name PrintPlanItemById
         * @request POST:/api/plan-items/{id}/print
         * @secure
         */
        printPlanItemById: (id: string, data: PrintPlanItemRequestOptions, params: RequestParams = {}) =>
            this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/plan-items/${id}/print`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PlanItems
         * @name GetPlanItemBasicBatch
         * @request POST:/api/plan-items/{pageIndex},{pageSize}/basic
         * @secure
         */
        getPlanItemBasicBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<PlanItemBasicModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/plan-items/${pageIndex},${pageSize}/basic`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PlanItems
         * @name GetPlanItemBatch
         * @request POST:/api/plan-items/{pageIndex},{pageSize}
         * @secure
         */
        getPlanItemBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<PlanItemModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/plan-items/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Positions
         * @name DeletePositions
         * @request DELETE:/api/positions
         * @secure
         */
        deletePositions: (data: QueryModel, params: RequestParams = {}) =>
            this.request<PositionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/positions`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Positions
         * @name InsertPosition
         * @request POST:/api/positions
         * @secure
         */
        insertPosition: (data: PositionModel, params: RequestParams = {}) =>
            this.request<PositionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/positions`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Positions
         * @name GetPositionById
         * @request GET:/api/positions/{id}
         * @secure
         */
        getPositionById: (id: string, params: RequestParams = {}) =>
            this.request<PositionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/positions/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Positions
         * @name PatchPosition
         * @request PATCH:/api/positions/{id}
         * @secure
         */
        patchPosition: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<PositionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/positions/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Positions
         * @name UpdatePosition
         * @request PUT:/api/positions/{id}
         * @secure
         */
        updatePosition: (id: string, data: PositionModel, params: RequestParams = {}) =>
            this.request<PositionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/positions/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Positions
         * @name AggregationPosition
         * @request POST:/api/positions/aggregation
         * @secure
         */
        aggregationPosition: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/positions/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Positions
         * @name GetPositionGroupped
         * @request POST:/api/positions/groupped
         * @secure
         */
        getPositionGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/positions/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Positions
         * @name GetPositionBatch
         * @request POST:/api/positions/{pageIndex},{pageSize}
         * @secure
         */
        getPositionBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<PositionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/positions/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ProductCollections
         * @name DeleteProductCollections
         * @request DELETE:/api/product-collections
         * @secure
         */
        deleteProductCollections: (data: QueryModel, params: RequestParams = {}) =>
            this.request<ProductCollectionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/product-collections`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ProductCollections
         * @name InsertProductCollection
         * @request POST:/api/product-collections
         * @secure
         */
        insertProductCollection: (data: ProductCollectionModel, params: RequestParams = {}) =>
            this.request<ProductCollectionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/product-collections`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ProductCollections
         * @name GetProductCollectionById
         * @request GET:/api/product-collections/{id}
         * @secure
         */
        getProductCollectionById: (id: string, params: RequestParams = {}) =>
            this.request<ProductCollectionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/product-collections/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ProductCollections
         * @name PatchProductCollection
         * @request PATCH:/api/product-collections/{id}
         * @secure
         */
        patchProductCollection: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<ProductCollectionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/product-collections/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ProductCollections
         * @name UpdateProductCollection
         * @request PUT:/api/product-collections/{id}
         * @secure
         */
        updateProductCollection: (id: string, data: ProductCollectionModel, params: RequestParams = {}) =>
            this.request<ProductCollectionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/product-collections/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ProductCollections
         * @name AggregationProductCollection
         * @request POST:/api/product-collections/aggregation
         * @secure
         */
        aggregationProductCollection: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/product-collections/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ProductCollections
         * @name GetProductCollectionGroupped
         * @request POST:/api/product-collections/groupped
         * @secure
         */
        getProductCollectionGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/product-collections/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ProductCollections
         * @name GetProductCollectionBatch
         * @request POST:/api/product-collections/{pageIndex},{pageSize}
         * @secure
         */
        getProductCollectionBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ProductCollectionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/product-collections/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Products
         * @name DeleteProducts
         * @request DELETE:/api/products
         * @secure
         */
        deleteProducts: (data: QueryModel, params: RequestParams = {}) =>
            this.request<ProductModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/products`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Products
         * @name InsertProduct
         * @request POST:/api/products
         * @secure
         */
        insertProduct: (data: ProductModel, params: RequestParams = {}) =>
            this.request<ProductModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/products`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Products
         * @name GetProductById
         * @request GET:/api/products/{id}
         * @secure
         */
        getProductById: (id: string, params: RequestParams = {}) =>
            this.request<ProductModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/products/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Products
         * @name PatchProduct
         * @request PATCH:/api/products/{id}
         * @secure
         */
        patchProduct: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<ProductModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/products/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Products
         * @name UpdateProduct
         * @request PUT:/api/products/{id}
         * @secure
         */
        updateProduct: (id: string, data: ProductModel, params: RequestParams = {}) =>
            this.request<ProductModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/products/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Products
         * @name AggregationProduct
         * @request POST:/api/products/aggregation
         * @secure
         */
        aggregationProduct: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/products/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Products
         * @name GetProductGroupped
         * @request POST:/api/products/groupped
         * @secure
         */
        getProductGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/products/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Products
         * @name GetProductBatch
         * @request POST:/api/products/{pageIndex},{pageSize}
         * @secure
         */
        getProductBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ProductModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/products/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Projects
         * @name DeleteProjects
         * @request DELETE:/api/projects
         * @secure
         */
        deleteProjects: (data: QueryModel, params: RequestParams = {}) =>
            this.request<ProjectModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/projects`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Projects
         * @name InsertProject
         * @request POST:/api/projects
         * @secure
         */
        insertProject: (data: ProjectModel, params: RequestParams = {}) =>
            this.request<ProjectModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/projects`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Projects
         * @name GetProjectById
         * @request GET:/api/projects/{id}
         * @secure
         */
        getProjectById: (id: string, params: RequestParams = {}) =>
            this.request<ProjectModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/projects/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Projects
         * @name PatchProject
         * @request PATCH:/api/projects/{id}
         * @secure
         */
        patchProject: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<ProjectModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/projects/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Projects
         * @name UpdateProject
         * @request PUT:/api/projects/{id}
         * @secure
         */
        updateProject: (id: string, data: ProjectModel, params: RequestParams = {}) =>
            this.request<ProjectModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/projects/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Projects
         * @name AggregationProject
         * @request POST:/api/projects/aggregation
         * @secure
         */
        aggregationProject: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/projects/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Projects
         * @name GetProjectGroupped
         * @request POST:/api/projects/groupped
         * @secure
         */
        getProjectGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/projects/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Projects
         * @name GetProjectBatch
         * @request POST:/api/projects/{pageIndex},{pageSize}
         * @secure
         */
        getProjectBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ProjectModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/projects/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PublicFiles
         * @name DownloadPublicFileById
         * @request GET:/api/public-files/{id}/download
         * @secure
         */
        downloadPublicFileById: (id: string, params: RequestParams = {}) =>
            this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/public-files/${id}/download`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PublicFiles
         * @name GetPublicFileById
         * @request GET:/api/public-files/{id}
         * @secure
         */
        getPublicFileById: (id: string, params: RequestParams = {}) =>
            this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/public-files/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags QuestionGroups
         * @name DeleteQuestionGroups
         * @request DELETE:/api/question-groups
         * @secure
         */
        deleteQuestionGroups: (data: QueryModel, params: RequestParams = {}) =>
            this.request<QuestionGroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/question-groups`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags QuestionGroups
         * @name InsertQuestionGroup
         * @request POST:/api/question-groups
         * @secure
         */
        insertQuestionGroup: (data: QuestionGroupModel, params: RequestParams = {}) =>
            this.request<QuestionGroupModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/question-groups`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags QuestionGroups
         * @name GetQuestionGroupById
         * @request GET:/api/question-groups/{id}
         * @secure
         */
        getQuestionGroupById: (id: string, params: RequestParams = {}) =>
            this.request<QuestionGroupModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/question-groups/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags QuestionGroups
         * @name PatchQuestionGroup
         * @request PATCH:/api/question-groups/{id}
         * @secure
         */
        patchQuestionGroup: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<QuestionGroupModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/question-groups/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags QuestionGroups
         * @name UpdateQuestionGroup
         * @request PUT:/api/question-groups/{id}
         * @secure
         */
        updateQuestionGroup: (id: string, data: QuestionGroupModel, params: RequestParams = {}) =>
            this.request<QuestionGroupModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/question-groups/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags QuestionGroups
         * @name AggregationQuestionGroup
         * @request POST:/api/question-groups/aggregation
         * @secure
         */
        aggregationQuestionGroup: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/question-groups/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags QuestionGroups
         * @name GetQuestionGroupGroupped
         * @request POST:/api/question-groups/groupped
         * @secure
         */
        getQuestionGroupGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/question-groups/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags QuestionGroups
         * @name GetQuestionGroupBatch
         * @request POST:/api/question-groups/{pageIndex},{pageSize}
         * @secure
         */
        getQuestionGroupBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<QuestionGroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/question-groups/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Questions
         * @name DeleteQuestions
         * @request DELETE:/api/questions
         * @secure
         */
        deleteQuestions: (data: QueryModel, params: RequestParams = {}) =>
            this.request<QuestionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/questions`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Questions
         * @name InsertQuestion
         * @request POST:/api/questions
         * @secure
         */
        insertQuestion: (data: QuestionModel, params: RequestParams = {}) =>
            this.request<QuestionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/questions`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Questions
         * @name GetQuestionById
         * @request GET:/api/questions/{id}
         * @secure
         */
        getQuestionById: (id: string, params: RequestParams = {}) =>
            this.request<QuestionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/questions/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Questions
         * @name PatchQuestion
         * @request PATCH:/api/questions/{id}
         * @secure
         */
        patchQuestion: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<QuestionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/questions/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Questions
         * @name UpdateQuestion
         * @request PUT:/api/questions/{id}
         * @secure
         */
        updateQuestion: (id: string, data: QuestionModel, params: RequestParams = {}) =>
            this.request<QuestionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/questions/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Questions
         * @name AggregationQuestion
         * @request POST:/api/questions/aggregation
         * @secure
         */
        aggregationQuestion: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/questions/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Questions
         * @name GetQuestionGroupped
         * @request POST:/api/questions/groupped
         * @secure
         */
        getQuestionGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/questions/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Questions
         * @name GetQuestionBatch
         * @request POST:/api/questions/{pageIndex},{pageSize}
         * @secure
         */
        getQuestionBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<QuestionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/questions/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags QuickLogin
         * @name MakeQuickLoginPin
         * @request POST:/api/quick-login/pin
         */
        makeQuickLoginPin: (data: ValidateQuickLoginModel, params: RequestParams = {}) =>
            this.request<TokenResponseApiResultSuccess, TokenErrorResponseApiResultFailed | void>({
                path: `/api/quick-login/pin`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags RawItems
         * @name ExportRawItemBatch
         * @request POST:/api/raw-items/{pageIndex},{pageSize}/export
         * @secure
         */
        exportRawItemBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/raw-items/${pageIndex},${pageSize}/export`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ResetPassword
         * @name ResetPassword
         * @request POST:/api/reset-password
         */
        resetPassword: (data: ResetPasswordModel, params: RequestParams = {}) =>
            this.request<IdentityResult, any>({
                path: `/api/reset-password`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ResetPassword
         * @name ConfirmResetPassword
         * @request POST:/api/reset-password/confirm
         */
        confirmResetPassword: (data: ConfirmResetPasswordModel, params: RequestParams = {}) =>
            this.request<IdentityResult, any>({
                path: `/api/reset-password/confirm`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Responses
         * @name DeleteResponses
         * @request DELETE:/api/responses
         * @secure
         */
        deleteResponses: (data: QueryModel, params: RequestParams = {}) =>
            this.request<ResponseModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/responses`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Responses
         * @name InsertResponse
         * @request POST:/api/responses
         * @secure
         */
        insertResponse: (data: ResponseModel, params: RequestParams = {}) =>
            this.request<ResponseModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/responses`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Responses
         * @name GetResponseById
         * @request GET:/api/responses/{id}
         * @secure
         */
        getResponseById: (id: string, params: RequestParams = {}) =>
            this.request<ResponseModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/responses/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Responses
         * @name PatchResponse
         * @request PATCH:/api/responses/{id}
         * @secure
         */
        patchResponse: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<ResponseModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/responses/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Responses
         * @name UpdateResponse
         * @request PUT:/api/responses/{id}
         * @secure
         */
        updateResponse: (id: string, data: ResponseModel, params: RequestParams = {}) =>
            this.request<ResponseModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/responses/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Responses
         * @name AggregationResponse
         * @request POST:/api/responses/aggregation
         * @secure
         */
        aggregationResponse: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/responses/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Responses
         * @name ExportResponseBatch
         * @request POST:/api/responses/{pageIndex},{pageSize}/export
         * @secure
         */
        exportResponseBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/responses/${pageIndex},${pageSize}/export`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Responses
         * @name GetResponseGroupped
         * @request POST:/api/responses/groupped
         * @secure
         */
        getResponseGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/responses/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Responses
         * @name GetResponseBatch
         * @request POST:/api/responses/{pageIndex},{pageSize}
         * @secure
         */
        getResponseBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ResponseModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/responses/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ResponseValues
         * @name DeleteResponseValues
         * @request DELETE:/api/response-values
         * @secure
         */
        deleteResponseValues: (data: QueryModel, params: RequestParams = {}) =>
            this.request<ResponseValueModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/response-values`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ResponseValues
         * @name InsertResponseValue
         * @request POST:/api/response-values
         * @secure
         */
        insertResponseValue: (data: ResponseValueModel, params: RequestParams = {}) =>
            this.request<ResponseValueModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/response-values`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ResponseValues
         * @name GetResponseValueById
         * @request GET:/api/response-values/{id}
         * @secure
         */
        getResponseValueById: (id: string, params: RequestParams = {}) =>
            this.request<ResponseValueModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/response-values/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ResponseValues
         * @name PatchResponseValue
         * @request PATCH:/api/response-values/{id}
         * @secure
         */
        patchResponseValue: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<ResponseValueModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/response-values/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ResponseValues
         * @name UpdateResponseValue
         * @request PUT:/api/response-values/{id}
         * @secure
         */
        updateResponseValue: (id: string, data: ResponseValueModel, params: RequestParams = {}) =>
            this.request<ResponseValueModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/response-values/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ResponseValues
         * @name AggregationResponseValue
         * @request POST:/api/response-values/aggregation
         * @secure
         */
        aggregationResponseValue: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/response-values/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ResponseValues
         * @name GetResponseValueGroupped
         * @request POST:/api/response-values/groupped
         * @secure
         */
        getResponseValueGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/response-values/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ResponseValues
         * @name GetResponseValueBatch
         * @request POST:/api/response-values/{pageIndex},{pageSize}
         * @secure
         */
        getResponseValueBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ResponseValueModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/response-values/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Roles
         * @name DeleteRoles
         * @request DELETE:/api/roles
         * @secure
         */
        deleteRoles: (data: QueryModel, params: RequestParams = {}) =>
            this.request<RoleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/roles`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Roles
         * @name InsertRole
         * @request POST:/api/roles
         * @secure
         */
        insertRole: (data: RoleModel, params: RequestParams = {}) =>
            this.request<RoleModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/roles`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Roles
         * @name GetRoleById
         * @request GET:/api/roles/{id}
         * @secure
         */
        getRoleById: (id: string, params: RequestParams = {}) =>
            this.request<RoleModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/roles/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Roles
         * @name PatchRole
         * @request PATCH:/api/roles/{id}
         * @secure
         */
        patchRole: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<RoleModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/roles/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Roles
         * @name UpdateRole
         * @request PUT:/api/roles/{id}
         * @secure
         */
        updateRole: (id: string, data: RoleModel, params: RequestParams = {}) =>
            this.request<RoleModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/roles/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Roles
         * @name AggregationRole
         * @request POST:/api/roles/aggregation
         * @secure
         */
        aggregationRole: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/roles/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Roles
         * @name GetRoleGroupped
         * @request POST:/api/roles/groupped
         * @secure
         */
        getRoleGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/roles/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Roles
         * @name GetRoleBatch
         * @request POST:/api/roles/{pageIndex},{pageSize}
         * @secure
         */
        getRoleBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<RoleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/roles/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapCauses
         * @name DeleteScrapCauses
         * @request DELETE:/api/scrap-causes
         * @secure
         */
        deleteScrapCauses: (data: QueryModel, params: RequestParams = {}) =>
            this.request<ScrapCauseModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-causes`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapCauses
         * @name InsertScrapCause
         * @request POST:/api/scrap-causes
         * @secure
         */
        insertScrapCause: (data: ScrapCauseModel, params: RequestParams = {}) =>
            this.request<ScrapCauseModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-causes`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapCauses
         * @name GetScrapCauseById
         * @request GET:/api/scrap-causes/{id}
         * @secure
         */
        getScrapCauseById: (id: string, params: RequestParams = {}) =>
            this.request<ScrapCauseModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-causes/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapCauses
         * @name PatchScrapCause
         * @request PATCH:/api/scrap-causes/{id}
         * @secure
         */
        patchScrapCause: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<ScrapCauseModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-causes/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapCauses
         * @name UpdateScrapCause
         * @request PUT:/api/scrap-causes/{id}
         * @secure
         */
        updateScrapCause: (id: string, data: ScrapCauseModel, params: RequestParams = {}) =>
            this.request<ScrapCauseModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-causes/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapCauses
         * @name AggregationScrapCause
         * @request POST:/api/scrap-causes/aggregation
         * @secure
         */
        aggregationScrapCause: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-causes/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapCauses
         * @name GetScrapCauseGroupped
         * @request POST:/api/scrap-causes/groupped
         * @secure
         */
        getScrapCauseGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-causes/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapCauses
         * @name GetScrapCauseBatch
         * @request POST:/api/scrap-causes/{pageIndex},{pageSize}
         * @secure
         */
        getScrapCauseBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ScrapCauseModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-causes/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasons
         * @name DeleteScrapReasons
         * @request DELETE:/api/scrap-reasons
         * @secure
         */
        deleteScrapReasons: (data: QueryModel, params: RequestParams = {}) =>
            this.request<ScrapReasonModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reasons`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasons
         * @name InsertScrapReason
         * @request POST:/api/scrap-reasons
         * @secure
         */
        insertScrapReason: (data: ScrapReasonModel, params: RequestParams = {}) =>
            this.request<ScrapReasonModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reasons`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasons
         * @name GetScrapReasonById
         * @request GET:/api/scrap-reasons/{id}
         * @secure
         */
        getScrapReasonById: (id: string, params: RequestParams = {}) =>
            this.request<ScrapReasonModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reasons/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasons
         * @name PatchScrapReason
         * @request PATCH:/api/scrap-reasons/{id}
         * @secure
         */
        patchScrapReason: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<ScrapReasonModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reasons/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasons
         * @name UpdateScrapReason
         * @request PUT:/api/scrap-reasons/{id}
         * @secure
         */
        updateScrapReason: (id: string, data: ScrapReasonModel, params: RequestParams = {}) =>
            this.request<ScrapReasonModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reasons/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasons
         * @name AggregationScrapReason
         * @request POST:/api/scrap-reasons/aggregation
         * @secure
         */
        aggregationScrapReason: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reasons/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasons
         * @name GetScrapReasonGroupped
         * @request POST:/api/scrap-reasons/groupped
         * @secure
         */
        getScrapReasonGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reasons/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasons
         * @name GetScrapReasonBatch
         * @request POST:/api/scrap-reasons/{pageIndex},{pageSize}
         * @secure
         */
        getScrapReasonBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ScrapReasonModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reasons/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasonWorkplaces
         * @name DeleteScrapReasonWorkplaces
         * @request DELETE:/api/scrap-reason-workplaces
         * @secure
         */
        deleteScrapReasonWorkplaces: (data: QueryModel, params: RequestParams = {}) =>
            this.request<ScrapReasonWorkplaceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reason-workplaces`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasonWorkplaces
         * @name InsertScrapReasonWorkplace
         * @request POST:/api/scrap-reason-workplaces
         * @secure
         */
        insertScrapReasonWorkplace: (data: ScrapReasonWorkplaceModel, params: RequestParams = {}) =>
            this.request<ScrapReasonWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reason-workplaces`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasonWorkplaces
         * @name GetScrapReasonWorkplaceById
         * @request GET:/api/scrap-reason-workplaces/{id}
         * @secure
         */
        getScrapReasonWorkplaceById: (id: string, params: RequestParams = {}) =>
            this.request<ScrapReasonWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reason-workplaces/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasonWorkplaces
         * @name PatchScrapReasonWorkplace
         * @request PATCH:/api/scrap-reason-workplaces/{id}
         * @secure
         */
        patchScrapReasonWorkplace: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<ScrapReasonWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reason-workplaces/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasonWorkplaces
         * @name UpdateScrapReasonWorkplace
         * @request PUT:/api/scrap-reason-workplaces/{id}
         * @secure
         */
        updateScrapReasonWorkplace: (id: string, data: ScrapReasonWorkplaceModel, params: RequestParams = {}) =>
            this.request<ScrapReasonWorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reason-workplaces/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasonWorkplaces
         * @name AggregationScrapReasonWorkplace
         * @request POST:/api/scrap-reason-workplaces/aggregation
         * @secure
         */
        aggregationScrapReasonWorkplace: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reason-workplaces/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasonWorkplaces
         * @name GetScrapReasonWorkplaceGroupped
         * @request POST:/api/scrap-reason-workplaces/groupped
         * @secure
         */
        getScrapReasonWorkplaceGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reason-workplaces/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ScrapReasonWorkplaces
         * @name GetScrapReasonWorkplaceBatch
         * @request POST:/api/scrap-reason-workplaces/{pageIndex},{pageSize}
         * @secure
         */
        getScrapReasonWorkplaceBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ScrapReasonWorkplaceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/scrap-reason-workplaces/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ServiceQueueItems
         * @name GetServiceQueueItemById
         * @request GET:/api/service-queue-items/{id}
         * @secure
         */
        getServiceQueueItemById: (id: string, params: RequestParams = {}) =>
            this.request<ServiceQueueItemModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/service-queue-items/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ServiceQueueItems
         * @name InsertServiceQueueItem
         * @request POST:/api/service-queue-items
         * @secure
         */
        insertServiceQueueItem: (data: ServiceQueueItemModel, params: RequestParams = {}) =>
            this.request<ServiceQueueItemModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/service-queue-items`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ServiceQueueItems
         * @name AggregationServiceQueueItem
         * @request POST:/api/service-queue-items/aggregation
         * @secure
         */
        aggregationServiceQueueItem: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/service-queue-items/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ServiceQueueItems
         * @name GetServiceQueueItemGroupped
         * @request POST:/api/service-queue-items/groupped
         * @secure
         */
        getServiceQueueItemGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/service-queue-items/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ServiceQueueItems
         * @name GetServiceQueueItemBatch
         * @request POST:/api/service-queue-items/{pageIndex},{pageSize}
         * @secure
         */
        getServiceQueueItemBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ServiceQueueItemModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/service-queue-items/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetPassword
         * @name SetPassword
         * @request POST:/api/set-password
         * @secure
         */
        setPassword: (data: SetPasswordModel, params: RequestParams = {}) =>
            this.request<IdentityResult, void>({
                path: `/api/set-password`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftFiles
         * @name DeleteShiftFiles
         * @request DELETE:/api/shift-files
         * @secure
         */
        deleteShiftFiles: (data: QueryModel, params: RequestParams = {}) =>
            this.request<ShiftFileModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-files`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftFiles
         * @name InsertShiftFile
         * @request POST:/api/shift-files
         * @secure
         */
        insertShiftFile: (data: ShiftFileModel, params: RequestParams = {}) =>
            this.request<ShiftFileModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-files`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftFiles
         * @name GetShiftFileById
         * @request GET:/api/shift-files/{id}
         * @secure
         */
        getShiftFileById: (id: string, params: RequestParams = {}) =>
            this.request<ShiftFileModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-files/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftFiles
         * @name PatchShiftFile
         * @request PATCH:/api/shift-files/{id}
         * @secure
         */
        patchShiftFile: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<ShiftFileModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-files/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftFiles
         * @name UpdateShiftFile
         * @request PUT:/api/shift-files/{id}
         * @secure
         */
        updateShiftFile: (id: string, data: ShiftFileModel, params: RequestParams = {}) =>
            this.request<ShiftFileModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-files/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftFiles
         * @name AggregationShiftFile
         * @request POST:/api/shift-files/aggregation
         * @secure
         */
        aggregationShiftFile: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-files/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftFiles
         * @name GetShiftFileGroupped
         * @request POST:/api/shift-files/groupped
         * @secure
         */
        getShiftFileGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-files/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftFiles
         * @name GetShiftFileBatch
         * @request POST:/api/shift-files/{pageIndex},{pageSize}
         * @secure
         */
        getShiftFileBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ShiftFileModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-files/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Shifts
         * @name DeleteShifts
         * @request DELETE:/api/shifts
         * @secure
         */
        deleteShifts: (data: QueryModel, params: RequestParams = {}) =>
            this.request<ShiftModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shifts`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Shifts
         * @name InsertShift
         * @request POST:/api/shifts
         * @secure
         */
        insertShift: (data: ShiftModel, params: RequestParams = {}) =>
            this.request<ShiftModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shifts`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Shifts
         * @name GetShiftById
         * @request GET:/api/shifts/{id}
         * @secure
         */
        getShiftById: (id: string, params: RequestParams = {}) =>
            this.request<ShiftModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shifts/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Shifts
         * @name PatchShift
         * @request PATCH:/api/shifts/{id}
         * @secure
         */
        patchShift: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<ShiftModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shifts/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Shifts
         * @name UpdateShift
         * @request PUT:/api/shifts/{id}
         * @secure
         */
        updateShift: (id: string, data: ShiftModel, params: RequestParams = {}) =>
            this.request<ShiftModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shifts/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Shifts
         * @name PrintShiftById
         * @request GET:/api/shifts/{id}/print
         * @secure
         */
        printShiftById: (id: string, params: RequestParams = {}) =>
            this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shifts/${id}/print`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Shifts
         * @name AggregationShift
         * @request POST:/api/shifts/aggregation
         * @secure
         */
        aggregationShift: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shifts/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Shifts
         * @name ExportShiftBatch
         * @request POST:/api/shifts/{pageIndex},{pageSize}/export
         * @secure
         */
        exportShiftBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shifts/${pageIndex},${pageSize}/export`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Shifts
         * @name GetShiftGroupped
         * @request POST:/api/shifts/groupped
         * @secure
         */
        getShiftGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shifts/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Shifts
         * @name GetShiftsBasicBatch
         * @request POST:/api/shifts/{pageIndex},{pageSize}/basic
         * @secure
         */
        getShiftsBasicBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ShiftBasicModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shifts/${pageIndex},${pageSize}/basic`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Shifts
         * @name GetShiftBatch
         * @request POST:/api/shifts/{pageIndex},{pageSize}
         * @secure
         */
        getShiftBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ShiftModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shifts/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftScrapRecords
         * @name DeleteShiftScrapRecords
         * @request DELETE:/api/shift-scrap-records
         * @secure
         */
        deleteShiftScrapRecords: (data: QueryModel, params: RequestParams = {}) =>
            this.request<ShiftScrapRecordModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-scrap-records`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftScrapRecords
         * @name InsertShiftScrapRecord
         * @request POST:/api/shift-scrap-records
         * @secure
         */
        insertShiftScrapRecord: (data: ShiftScrapRecordModel, params: RequestParams = {}) =>
            this.request<ShiftScrapRecordModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-scrap-records`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftScrapRecords
         * @name GetShiftScrapRecordById
         * @request GET:/api/shift-scrap-records/{id}
         * @secure
         */
        getShiftScrapRecordById: (id: string, params: RequestParams = {}) =>
            this.request<ShiftScrapRecordModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-scrap-records/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftScrapRecords
         * @name PatchShiftScrapRecord
         * @request PATCH:/api/shift-scrap-records/{id}
         * @secure
         */
        patchShiftScrapRecord: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<ShiftScrapRecordModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-scrap-records/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftScrapRecords
         * @name UpdateShiftScrapRecord
         * @request PUT:/api/shift-scrap-records/{id}
         * @secure
         */
        updateShiftScrapRecord: (id: string, data: ShiftScrapRecordModel, params: RequestParams = {}) =>
            this.request<ShiftScrapRecordModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-scrap-records/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftScrapRecords
         * @name AggregationShiftScrapRecord
         * @request POST:/api/shift-scrap-records/aggregation
         * @secure
         */
        aggregationShiftScrapRecord: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-scrap-records/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftScrapRecords
         * @name GetShiftScrapRecordGroupped
         * @request POST:/api/shift-scrap-records/groupped
         * @secure
         */
        getShiftScrapRecordGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-scrap-records/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftScrapRecords
         * @name GetShiftScrapRecordBatch
         * @request POST:/api/shift-scrap-records/{pageIndex},{pageSize}
         * @secure
         */
        getShiftScrapRecordBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ShiftScrapRecordModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-scrap-records/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftStations
         * @name DeleteShiftStations
         * @request DELETE:/api/shift-stations
         * @secure
         */
        deleteShiftStations: (data: QueryModel, params: RequestParams = {}) =>
            this.request<ShiftStationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-stations`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftStations
         * @name InsertShiftStation
         * @request POST:/api/shift-stations
         * @secure
         */
        insertShiftStation: (data: ShiftStationModel, params: RequestParams = {}) =>
            this.request<ShiftStationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-stations`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftStations
         * @name GetShiftStationById
         * @request GET:/api/shift-stations/{id}
         * @secure
         */
        getShiftStationById: (id: string, params: RequestParams = {}) =>
            this.request<ShiftStationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-stations/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftStations
         * @name PatchShiftStation
         * @request PATCH:/api/shift-stations/{id}
         * @secure
         */
        patchShiftStation: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<ShiftStationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-stations/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftStations
         * @name UpdateShiftStation
         * @request PUT:/api/shift-stations/{id}
         * @secure
         */
        updateShiftStation: (id: string, data: ShiftStationModel, params: RequestParams = {}) =>
            this.request<ShiftStationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-stations/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftStations
         * @name AggregationShiftStation
         * @request POST:/api/shift-stations/aggregation
         * @secure
         */
        aggregationShiftStation: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-stations/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftStations
         * @name ExportShiftStationBatch
         * @request POST:/api/shift-stations/{pageIndex},{pageSize}/export
         * @secure
         */
        exportShiftStationBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-stations/${pageIndex},${pageSize}/export`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftStations
         * @name GetShiftStationGroupped
         * @request POST:/api/shift-stations/groupped
         * @secure
         */
        getShiftStationGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-stations/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftStations
         * @name GetShiftStationBatch
         * @request POST:/api/shift-stations/{pageIndex},{pageSize}
         * @secure
         */
        getShiftStationBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ShiftStationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-stations/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTeamTypes
         * @name DeleteShiftTeamTypes
         * @request DELETE:/api/shift-team-types
         * @secure
         */
        deleteShiftTeamTypes: (data: QueryModel, params: RequestParams = {}) =>
            this.request<ShiftTeamTypeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-team-types`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTeamTypes
         * @name InsertShiftTeamType
         * @request POST:/api/shift-team-types
         * @secure
         */
        insertShiftTeamType: (data: ShiftTeamTypeModel, params: RequestParams = {}) =>
            this.request<ShiftTeamTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-team-types`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTeamTypes
         * @name GetShiftTeamTypeById
         * @request GET:/api/shift-team-types/{id}
         * @secure
         */
        getShiftTeamTypeById: (id: string, params: RequestParams = {}) =>
            this.request<ShiftTeamTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-team-types/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTeamTypes
         * @name PatchShiftTeamType
         * @request PATCH:/api/shift-team-types/{id}
         * @secure
         */
        patchShiftTeamType: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<ShiftTeamTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-team-types/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTeamTypes
         * @name UpdateShiftTeamType
         * @request PUT:/api/shift-team-types/{id}
         * @secure
         */
        updateShiftTeamType: (id: string, data: ShiftTeamTypeModel, params: RequestParams = {}) =>
            this.request<ShiftTeamTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-team-types/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTeamTypes
         * @name AggregationShiftTeamType
         * @request POST:/api/shift-team-types/aggregation
         * @secure
         */
        aggregationShiftTeamType: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-team-types/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTeamTypes
         * @name GetShiftTeamTypeGroupped
         * @request POST:/api/shift-team-types/groupped
         * @secure
         */
        getShiftTeamTypeGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-team-types/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTeamTypes
         * @name GetShiftTeamTypeBatch
         * @request POST:/api/shift-team-types/{pageIndex},{pageSize}
         * @secure
         */
        getShiftTeamTypeBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ShiftTeamTypeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-team-types/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTypes
         * @name DeleteShiftTypes
         * @request DELETE:/api/shift-types
         * @secure
         */
        deleteShiftTypes: (data: QueryModel, params: RequestParams = {}) =>
            this.request<ShiftTypeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-types`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTypes
         * @name InsertShiftType
         * @request POST:/api/shift-types
         * @secure
         */
        insertShiftType: (data: ShiftTypeModel, params: RequestParams = {}) =>
            this.request<ShiftTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-types`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTypes
         * @name GetShiftTypeById
         * @request GET:/api/shift-types/{id}
         * @secure
         */
        getShiftTypeById: (id: string, params: RequestParams = {}) =>
            this.request<ShiftTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-types/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTypes
         * @name PatchShiftType
         * @request PATCH:/api/shift-types/{id}
         * @secure
         */
        patchShiftType: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<ShiftTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-types/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTypes
         * @name UpdateShiftType
         * @request PUT:/api/shift-types/{id}
         * @secure
         */
        updateShiftType: (id: string, data: ShiftTypeModel, params: RequestParams = {}) =>
            this.request<ShiftTypeModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-types/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTypes
         * @name AggregationShiftType
         * @request POST:/api/shift-types/aggregation
         * @secure
         */
        aggregationShiftType: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-types/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTypes
         * @name GetShiftTypeGroupped
         * @request POST:/api/shift-types/groupped
         * @secure
         */
        getShiftTypeGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-types/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShiftTypes
         * @name GetShiftTypeBatch
         * @request POST:/api/shift-types/{pageIndex},{pageSize}
         * @secure
         */
        getShiftTypeBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<ShiftTypeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/shift-types/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Signal
         * @name GetSignalNotificationBatch
         * @request POST:/api/signal/search
         * @secure
         */
        getSignalNotificationBatch: (
            query?: {
                /** @format date-time */
                fromDate?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<EventList, ApiResultFailed | void>({
                path: `/api/signal/search`,
                method: 'POST',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags SignIn
         * @name SignInLdapCreate
         * @request POST:/api/sign-in/ldap
         */
        signInLdapCreate: (data: LdapSignInModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/sign-in/ldap`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SignOut
         * @name SignOut
         * @request POST:/api/sign-out
         */
        signOut: (params: RequestParams = {}) =>
            this.request<IdentityResult, any>({
                path: `/api/sign-out`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags SignUp
         * @name SignUp
         * @request POST:/api/sign-up
         */
        signUp: (data: SignUpModel, params: RequestParams = {}) =>
            this.request<IdentityResult, any>({
                path: `/api/sign-up`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags SignUp
         * @name ActivateAccount
         * @request POST:/api/sign-up/confirm
         */
        activateAccount: (data: ConfirmEmailModel, params: RequestParams = {}) =>
            this.request<IdentityResult, any>({
                path: `/api/sign-up/confirm`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags SolvedIssues
         * @name ExportSolvedIssueBatch
         * @request POST:/api/solved-issues/{pageIndex},{pageSize}/export
         * @secure
         */
        exportSolvedIssueBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/solved-issues/${pageIndex},${pageSize}/export`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stations
         * @name DeleteStations
         * @request DELETE:/api/stations
         * @secure
         */
        deleteStations: (data: QueryModel, params: RequestParams = {}) =>
            this.request<StationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/stations`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stations
         * @name InsertStation
         * @request POST:/api/stations
         * @secure
         */
        insertStation: (data: StationModel, params: RequestParams = {}) =>
            this.request<StationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/stations`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stations
         * @name GetStationById
         * @request GET:/api/stations/{id}
         * @secure
         */
        getStationById: (id: string, params: RequestParams = {}) =>
            this.request<StationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/stations/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stations
         * @name PatchStation
         * @request PATCH:/api/stations/{id}
         * @secure
         */
        patchStation: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<StationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/stations/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stations
         * @name UpdateStation
         * @request PUT:/api/stations/{id}
         * @secure
         */
        updateStation: (id: string, data: StationModel, params: RequestParams = {}) =>
            this.request<StationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/stations/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stations
         * @name AggregationStation
         * @request POST:/api/stations/aggregation
         * @secure
         */
        aggregationStation: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/stations/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stations
         * @name GetStationGroupped
         * @request POST:/api/stations/groupped
         * @secure
         */
        getStationGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/stations/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stations
         * @name GetStationBatch
         * @request POST:/api/stations/{pageIndex},{pageSize}
         * @secure
         */
        getStationBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<StationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/stations/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Targets
         * @name DeleteTargets
         * @request DELETE:/api/targets
         * @secure
         */
        deleteTargets: (data: QueryModel, params: RequestParams = {}) =>
            this.request<TargetModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/targets`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Targets
         * @name InsertTarget
         * @request POST:/api/targets
         * @secure
         */
        insertTarget: (data: TargetModel, params: RequestParams = {}) =>
            this.request<TargetModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/targets`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Targets
         * @name GetTargetById
         * @request GET:/api/targets/{id}
         * @secure
         */
        getTargetById: (id: string, params: RequestParams = {}) =>
            this.request<TargetModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/targets/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Targets
         * @name PatchTarget
         * @request PATCH:/api/targets/{id}
         * @secure
         */
        patchTarget: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<TargetModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/targets/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Targets
         * @name UpdateTarget
         * @request PUT:/api/targets/{id}
         * @secure
         */
        updateTarget: (id: string, data: TargetModel, params: RequestParams = {}) =>
            this.request<TargetModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/targets/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Targets
         * @name AggregationTarget
         * @request POST:/api/targets/aggregation
         * @secure
         */
        aggregationTarget: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/targets/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Targets
         * @name GetTargetGroupped
         * @request POST:/api/targets/groupped
         * @secure
         */
        getTargetGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/targets/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Targets
         * @name GetTargetBatch
         * @request POST:/api/targets/{pageIndex},{pageSize}
         * @secure
         */
        getTargetBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<TargetModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/targets/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantConnections
         * @name DeleteTenantConnection
         * @request DELETE:/api/tenant-connections
         * @secure
         */
        deleteTenantConnection: (data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantInvitationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-connections`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantConnections
         * @name InsertTenantConnection
         * @request POST:/api/tenant-connections
         * @secure
         */
        insertTenantConnection: (data: TenantInvitationModel, params: RequestParams = {}) =>
            this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-connections`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantConnections
         * @name GetTenantConnectionBatch
         * @request POST:/api/tenant-connections/{pageIndex},{pageSize}
         * @secure
         */
        getTenantConnectionBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantInvitationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-connections/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantDevices
         * @name DeleteTenantDevices
         * @request DELETE:/api/tenant-devices
         * @secure
         */
        deleteTenantDevices: (data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantDeviceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-devices`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantDevices
         * @name InsertTenantDevice
         * @request POST:/api/tenant-devices
         * @secure
         */
        insertTenantDevice: (data: TenantDeviceModel, params: RequestParams = {}) =>
            this.request<TenantDeviceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-devices`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantDevices
         * @name GetTenantDeviceById
         * @request GET:/api/tenant-devices/{id}
         * @secure
         */
        getTenantDeviceById: (id: string, params: RequestParams = {}) =>
            this.request<TenantDeviceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-devices/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantDevices
         * @name PatchTenantDevice
         * @request PATCH:/api/tenant-devices/{id}
         * @secure
         */
        patchTenantDevice: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<TenantDeviceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-devices/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantDevices
         * @name UpdateTenantDevice
         * @request PUT:/api/tenant-devices/{id}
         * @secure
         */
        updateTenantDevice: (id: string, data: TenantDeviceModel, params: RequestParams = {}) =>
            this.request<TenantDeviceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-devices/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantDevices
         * @name AggregationTenantDevice
         * @request POST:/api/tenant-devices/aggregation
         * @secure
         */
        aggregationTenantDevice: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-devices/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantDevices
         * @name GetTenantDeviceGroupped
         * @request POST:/api/tenant-devices/groupped
         * @secure
         */
        getTenantDeviceGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-devices/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantDevices
         * @name GetTenantDeviceBatch
         * @request POST:/api/tenant-devices/{pageIndex},{pageSize}
         * @secure
         */
        getTenantDeviceBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantDeviceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-devices/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantDeviceSubscriptions
         * @name DeleteTenantDeviceSubscriptions
         * @request DELETE:/api/tenant-device-subscriptions
         * @secure
         */
        deleteTenantDeviceSubscriptions: (data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantDeviceSubscriptionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-device-subscriptions`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantDeviceSubscriptions
         * @name InsertTenantDeviceSubscription
         * @request POST:/api/tenant-device-subscriptions
         * @secure
         */
        insertTenantDeviceSubscription: (data: TenantDeviceSubscriptionModel, params: RequestParams = {}) =>
            this.request<TenantDeviceSubscriptionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-device-subscriptions`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantDeviceSubscriptions
         * @name GetTenantDeviceSubscriptionById
         * @request GET:/api/tenant-device-subscriptions/{id}
         * @secure
         */
        getTenantDeviceSubscriptionById: (id: string, params: RequestParams = {}) =>
            this.request<TenantDeviceSubscriptionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-device-subscriptions/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantDeviceSubscriptions
         * @name PatchTenantDeviceSubscription
         * @request PATCH:/api/tenant-device-subscriptions/{id}
         * @secure
         */
        patchTenantDeviceSubscription: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<TenantDeviceSubscriptionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-device-subscriptions/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantDeviceSubscriptions
         * @name UpdateTenantDeviceSubscription
         * @request PUT:/api/tenant-device-subscriptions/{id}
         * @secure
         */
        updateTenantDeviceSubscription: (id: string, data: TenantDeviceSubscriptionModel, params: RequestParams = {}) =>
            this.request<TenantDeviceSubscriptionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-device-subscriptions/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantDeviceSubscriptions
         * @name GetTenantDeviceSubscriptionBatch
         * @request POST:/api/tenant-device-subscriptions/{pageIndex},{pageSize}
         * @secure
         */
        getTenantDeviceSubscriptionBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantDeviceSubscriptionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-device-subscriptions/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantInvitations
         * @name DeleteTenantInvitations
         * @request DELETE:/api/tenant-invitations
         * @secure
         */
        deleteTenantInvitations: (data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantInvitationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-invitations`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantInvitations
         * @name DeleteTenantClientInvitations
         * @request DELETE:/api/tenant-invitations/client
         * @secure
         */
        deleteTenantClientInvitations: (data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantInvitationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-invitations/client`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantInvitations
         * @name GetTenantInvitationById
         * @request GET:/api/tenant-invitations/{id}
         * @secure
         */
        getTenantInvitationById: (id: string, params: RequestParams = {}) =>
            this.request<TenantInvitationModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-invitations/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantInvitations
         * @name GetTenantInvitationBatch
         * @request POST:/api/tenant-invitations/{pageIndex},{pageSize}
         * @secure
         */
        getTenantInvitationBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantInvitationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-invitations/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantIpRestrictions
         * @name DeleteTenantIpRestrictions
         * @request DELETE:/api/tenant-ip-restrictions
         * @secure
         */
        deleteTenantIpRestrictions: (data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantIpRestrictionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-ip-restrictions`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantIpRestrictions
         * @name InsertTenantIpRestriction
         * @request POST:/api/tenant-ip-restrictions
         * @secure
         */
        insertTenantIpRestriction: (data: TenantIpRestrictionModel, params: RequestParams = {}) =>
            this.request<TenantIpRestrictionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-ip-restrictions`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantIpRestrictions
         * @name GetTenantIpRestrictionById
         * @request GET:/api/tenant-ip-restrictions/{id}
         * @secure
         */
        getTenantIpRestrictionById: (id: string, params: RequestParams = {}) =>
            this.request<TenantIpRestrictionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-ip-restrictions/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantIpRestrictions
         * @name PatchTenantIpRestriction
         * @request PATCH:/api/tenant-ip-restrictions/{id}
         * @secure
         */
        patchTenantIpRestriction: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<TenantIpRestrictionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-ip-restrictions/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantIpRestrictions
         * @name UpdateTenantIpRestriction
         * @request PUT:/api/tenant-ip-restrictions/{id}
         * @secure
         */
        updateTenantIpRestriction: (id: string, data: TenantIpRestrictionModel, params: RequestParams = {}) =>
            this.request<TenantIpRestrictionModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-ip-restrictions/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantIpRestrictions
         * @name AggregationTenantIpRestriction
         * @request POST:/api/tenant-ip-restrictions/aggregation
         * @secure
         */
        aggregationTenantIpRestriction: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-ip-restrictions/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantIpRestrictions
         * @name GetTenantIpRestrictionGroupped
         * @request POST:/api/tenant-ip-restrictions/groupped
         * @secure
         */
        getTenantIpRestrictionGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-ip-restrictions/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantIpRestrictions
         * @name GetTenantIpRestrictionBatch
         * @request POST:/api/tenant-ip-restrictions/{pageIndex},{pageSize}
         * @secure
         */
        getTenantIpRestrictionBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantIpRestrictionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-ip-restrictions/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Tenants
         * @name UpdateTenantAvatar
         * @request PUT:/api/tenants/{id}/avatar
         * @secure
         */
        updateTenantAvatar: (id: string, data: AvatarUploadModel, params: RequestParams = {}) =>
            this.request<AvatarUploadModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenants/${id}/avatar`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Tenants
         * @name GetTenantById
         * @request GET:/api/tenants/{id}
         * @secure
         */
        getTenantById: (id: string, params: RequestParams = {}) =>
            this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenants/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Tenants
         * @name PatchTenant
         * @request PATCH:/api/tenants/{id}
         * @secure
         */
        patchTenant: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<void, ApiResultFailed | void>({
                path: `/api/tenants/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Tenants
         * @name UpdateTenant
         * @request PUT:/api/tenants/{id}
         * @secure
         */
        updateTenant: (id: string, data: TenantModel, params: RequestParams = {}) =>
            this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenants/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Tenants
         * @name InsertTenant
         * @request POST:/api/tenants
         * @secure
         */
        insertTenant: (data: TenantModel, params: RequestParams = {}) =>
            this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenants`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Tenants
         * @name GetTenantBatch
         * @request POST:/api/tenants/{pageIndex},{pageSize}
         * @secure
         */
        getTenantBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenants/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantUsers
         * @name DeleteTenantUsers
         * @request DELETE:/api/tenant-users
         * @secure
         */
        deleteTenantUsers: (data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-users`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantUsers
         * @name InsertTenantUser
         * @request POST:/api/tenant-users
         * @secure
         */
        insertTenantUser: (data: TenantUserModel, params: RequestParams = {}) =>
            this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-users`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantUsers
         * @name GetTenantUserById
         * @request GET:/api/tenant-users/{id}
         * @secure
         */
        getTenantUserById: (id: string, params: RequestParams = {}) =>
            this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-users/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantUsers
         * @name UpdateTenantUser
         * @request PUT:/api/tenant-users/{id}
         * @secure
         */
        updateTenantUser: (id: string, data: TenantUserModel, params: RequestParams = {}) =>
            this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-users/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantUsers
         * @name AggregationTenantUser
         * @request POST:/api/tenant-users/aggregation
         * @secure
         */
        aggregationTenantUser: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-users/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantUsers
         * @name GetTenantUserBatch
         * @request POST:/api/tenant-users/{pageIndex},{pageSize}
         * @secure
         */
        getTenantUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<TenantUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-users/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags TenantUsers
         * @name SetQuickLoginPin
         * @request PUT:/api/tenant-users/{id}/set-quick-login-pin
         * @secure
         */
        setQuickLoginPin: (id: string, data: string, params: RequestParams = {}) =>
            this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/tenant-users/${id}/set-quick-login-pin`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UnitOfMeasures
         * @name DeleteUnitOfMeasures
         * @request DELETE:/api/unit-of-measures
         * @secure
         */
        deleteUnitOfMeasures: (data: QueryModel, params: RequestParams = {}) =>
            this.request<UnitOfMeasureModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/unit-of-measures`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UnitOfMeasures
         * @name InsertUnitOfMeasure
         * @request POST:/api/unit-of-measures
         * @secure
         */
        insertUnitOfMeasure: (data: UnitOfMeasureModel, params: RequestParams = {}) =>
            this.request<UnitOfMeasureModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/unit-of-measures`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UnitOfMeasures
         * @name GetUnitOfMeasureById
         * @request GET:/api/unit-of-measures/{id}
         * @secure
         */
        getUnitOfMeasureById: (id: string, params: RequestParams = {}) =>
            this.request<UnitOfMeasureModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/unit-of-measures/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UnitOfMeasures
         * @name PatchUnitOfMeasure
         * @request PATCH:/api/unit-of-measures/{id}
         * @secure
         */
        patchUnitOfMeasure: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<UnitOfMeasureModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/unit-of-measures/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UnitOfMeasures
         * @name UpdateUnitOfMeasure
         * @request PUT:/api/unit-of-measures/{id}
         * @secure
         */
        updateUnitOfMeasure: (id: string, data: UnitOfMeasureModel, params: RequestParams = {}) =>
            this.request<UnitOfMeasureModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/unit-of-measures/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UnitOfMeasures
         * @name AggregationUnitOfMeasure
         * @request POST:/api/unit-of-measures/aggregation
         * @secure
         */
        aggregationUnitOfMeasure: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/unit-of-measures/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UnitOfMeasures
         * @name GetUnitOfMeasureGroupped
         * @request POST:/api/unit-of-measures/groupped
         * @secure
         */
        getUnitOfMeasureGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/unit-of-measures/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UnitOfMeasures
         * @name GetUnitOfMeasureBatch
         * @request POST:/api/unit-of-measures/{pageIndex},{pageSize}
         * @secure
         */
        getUnitOfMeasureBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<UnitOfMeasureModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/unit-of-measures/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UserRoles
         * @name DeleteUserRoles
         * @request DELETE:/api/user-roles
         * @secure
         */
        deleteUserRoles: (data: QueryModel, params: RequestParams = {}) =>
            this.request<UserRoleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/user-roles`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UserRoles
         * @name InsertUserRole
         * @request POST:/api/user-roles
         * @secure
         */
        insertUserRole: (data: UserRoleModel, params: RequestParams = {}) =>
            this.request<UserRoleModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/user-roles`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UserRoles
         * @name GetUserRoleById
         * @request GET:/api/user-roles/{id}
         * @secure
         */
        getUserRoleById: (id: string, params: RequestParams = {}) =>
            this.request<UserRoleModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/user-roles/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UserRoles
         * @name PatchUserRole
         * @request PATCH:/api/user-roles/{id}
         * @secure
         */
        patchUserRole: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<UserRoleModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/user-roles/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UserRoles
         * @name UpdateUserRole
         * @request PUT:/api/user-roles/{id}
         * @secure
         */
        updateUserRole: (id: string, data: UserRoleModel, params: RequestParams = {}) =>
            this.request<UserRoleModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/user-roles/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UserRoles
         * @name AggregationUserRole
         * @request POST:/api/user-roles/aggregation
         * @secure
         */
        aggregationUserRole: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/user-roles/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UserRoles
         * @name GetUserRoleGroupped
         * @request POST:/api/user-roles/groupped
         * @secure
         */
        getUserRoleGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/user-roles/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UserRoles
         * @name GetUserRoleBatch
         * @request POST:/api/user-roles/{pageIndex},{pageSize}
         * @secure
         */
        getUserRoleBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<UserRoleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/user-roles/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Verifications
         * @name ExportVerificationBatch
         * @request POST:/api/verifications/{pageIndex},{pageSize}/export
         * @secure
         */
        exportVerificationBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/verifications/${pageIndex},${pageSize}/export`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Workplaces
         * @name DeleteWorkplaces
         * @request DELETE:/api/workplaces
         * @secure
         */
        deleteWorkplaces: (data: QueryModel, params: RequestParams = {}) =>
            this.request<WorkplaceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplaces`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Workplaces
         * @name InsertWorkplace
         * @request POST:/api/workplaces
         * @secure
         */
        insertWorkplace: (data: WorkplaceModel, params: RequestParams = {}) =>
            this.request<WorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplaces`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Workplaces
         * @name GetWorkplaceById
         * @request GET:/api/workplaces/{id}
         * @secure
         */
        getWorkplaceById: (id: string, params: RequestParams = {}) =>
            this.request<WorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplaces/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Workplaces
         * @name PatchWorkplace
         * @request PATCH:/api/workplaces/{id}
         * @secure
         */
        patchWorkplace: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<WorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplaces/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Workplaces
         * @name UpdateWorkplace
         * @request PUT:/api/workplaces/{id}
         * @secure
         */
        updateWorkplace: (id: string, data: WorkplaceModel, params: RequestParams = {}) =>
            this.request<WorkplaceModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplaces/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Workplaces
         * @name AggregationWorkplace
         * @request POST:/api/workplaces/aggregation
         * @secure
         */
        aggregationWorkplace: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplaces/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Workplaces
         * @name GetWorkplaceGroupped
         * @request POST:/api/workplaces/groupped
         * @secure
         */
        getWorkplaceGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplaces/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Workplaces
         * @name GetWorkplaceBatch
         * @request POST:/api/workplaces/{pageIndex},{pageSize}
         * @secure
         */
        getWorkplaceBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<WorkplaceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplaces/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkplaceShutdowns
         * @name DeleteWorkplaceShutdowns
         * @request DELETE:/api/workplace-shutdowns
         * @secure
         */
        deleteWorkplaceShutdowns: (data: QueryModel, params: RequestParams = {}) =>
            this.request<WorkplaceShutdownModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplace-shutdowns`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkplaceShutdowns
         * @name InsertWorkplaceShutdown
         * @request POST:/api/workplace-shutdowns
         * @secure
         */
        insertWorkplaceShutdown: (data: WorkplaceShutdownModel, params: RequestParams = {}) =>
            this.request<WorkplaceShutdownModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplace-shutdowns`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkplaceShutdowns
         * @name GetWorkplaceShutdownById
         * @request GET:/api/workplace-shutdowns/{id}
         * @secure
         */
        getWorkplaceShutdownById: (id: string, params: RequestParams = {}) =>
            this.request<WorkplaceShutdownModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplace-shutdowns/${id}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkplaceShutdowns
         * @name PatchWorkplaceShutdown
         * @request PATCH:/api/workplace-shutdowns/{id}
         * @secure
         */
        patchWorkplaceShutdown: (id: string, data: Operation[], params: RequestParams = {}) =>
            this.request<WorkplaceShutdownModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplace-shutdowns/${id}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkplaceShutdowns
         * @name UpdateWorkplaceShutdown
         * @request PUT:/api/workplace-shutdowns/{id}
         * @secure
         */
        updateWorkplaceShutdown: (id: string, data: WorkplaceShutdownModel, params: RequestParams = {}) =>
            this.request<WorkplaceShutdownModelApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplace-shutdowns/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkplaceShutdowns
         * @name AggregationWorkplaceShutdown
         * @request POST:/api/workplace-shutdowns/aggregation
         * @secure
         */
        aggregationWorkplaceShutdown: (data: AggregationModel, params: RequestParams = {}) =>
            this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplace-shutdowns/aggregation`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkplaceShutdowns
         * @name GetWorkplaceShutdownGroupped
         * @request POST:/api/workplace-shutdowns/groupped
         * @secure
         */
        getWorkplaceShutdownGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
            this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplace-shutdowns/groupped`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkplaceShutdowns
         * @name GetWorkplaceShutdownBatch
         * @request POST:/api/workplace-shutdowns/{pageIndex},{pageSize}
         * @secure
         */
        getWorkplaceShutdownBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
            this.request<WorkplaceShutdownModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
                path: `/api/workplace-shutdowns/${pageIndex},${pageSize}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
}
